export const translations = {
  reportTitle: {
    en: 'Report title',
    nb: 'Rapporttittel',
    de: 'Berichtstitel',
    sv: 'Rapporttitel',
    fi: 'Raportin otsikko',
    cz: 'Název zprávy',
  },
  reportScope: {
    en: 'Scope',
    nb: 'Omfang',
    de: 'Umfang',
    sv: 'Omfattning',
    fi: 'Rajaus',
    cz: 'Rozsah',
  },
  reportContents: {
    en: 'Contents',
    nb: 'Innhold',
    de: 'Inhalt',
    sv: 'Innehåll',
    fi: 'Sisältö',
    cz: 'Obsah',
  },
  reportWrite: {
    en: 'Write',
    nb: 'Skriv',
    de: 'Verfassen',
    sv: 'Skriv',
    fi: 'Kirjoita',
    cz: 'Psaní',
  },
  reportMetrics: {
    en: 'Metrics',
    nb: 'Måleverdier',
    de: 'Messgrößen',
    sv: 'Mätvärden',
    fi: 'Mittarit',
    cz: 'Veličiny',
  },
  reportPart: {
    en: 'Report part',
    nb: 'Rapportdel',
    de: 'Berichtsteil',
    sv: 'Rapportdel',
    fi: 'Raportin osa',
    cz: 'Část zprávy',
  },
  reportScopeHelp: {
    en: 'Select the installations for the whole report. Every part uses this scope and period.',
    nb: 'Velg installasjonene for hele rapporten. Alle deler bruker dette omfanget og denne perioden.',
    de: 'Wählen Sie die Installationen für den gesamten Bericht. Alle Teile verwenden diesen Umfang und Zeitraum.',
    sv: 'Välj installationer för hela rapporten. Alla delar använder detta urval och denna period.',
    fi: 'Valitse koko raportin asennukset. Kaikki osat käyttävät samaa rajausta ja ajanjaksoa.',
    cz: 'Vyberte instalace pro celou zprávu. Všechny části používají tento rozsah a období.',
  },
  reportDowntimeScopeHelp: {
    en: 'Downtime uses gaps in sensor readings from all report installations, independently of the selected metrics.',
    nb: 'Nedetid bruker hull i sensoravlesninger fra alle rapportens installasjoner, uavhengig av valgte måleverdier.',
    de: 'Ausfallzeiten verwenden Lücken in Sensormessungen aller Berichtsinstallationen, unabhängig von den gewählten Messgrößen.',
    sv: 'Avbrott baseras på luckor i sensoravläsningar från alla rapportens installationer, oberoende av valda mätvärden.',
    fi: 'Katkokset perustuvat kaikkien raportin asennusten anturilukemien aukkoihin valituista mittareista riippumatta.',
    cz: 'Výpadky vycházejí z mezer v měřeních senzorů všech instalací zprávy nezávisle na vybraných veličinách.',
  },
  reportContentsHelp: {
    en: 'Supported metrics are included for each installation. Text is kept when parts are turned off.',
    nb: 'Støttede måleverdier tas med for hver installasjon. Tekst beholdes når deler slås av.',
    de: 'Unterstützte Messgrößen werden je Installation aufgenommen. Texte bleiben beim Abwählen von Teilen erhalten.',
    sv: 'Mätvärden som stöds tas med för varje installation. Text sparas när delar stängs av.',
    fi: 'Tuetut mittarit sisällytetään asennuksittain. Tekstit säilyvät, kun osia poistetaan käytöstä.',
    cz: 'Pro každou instalaci se zahrnou podporované veličiny. Text se zachová při vypnutí částí.',
  },
  reportConclusionContext: {
    en: 'Review the recommendations below and write one final conclusion for the report.',
    nb: 'Se gjennom anbefalingene nedenfor og skriv én avsluttende konklusjon for rapporten.',
    de: 'Prüfen Sie die Empfehlungen unten und verfassen Sie ein abschließendes Fazit für den Bericht.',
    sv: 'Granska rekommendationerna nedan och skriv en slutlig slutsats för rapporten.',
    fi: 'Tarkista alla olevat suositukset ja kirjoita raportin lopullinen johtopäätös.',
    cz: 'Projděte níže uvedená doporučení a napište závěrečné shrnutí zprávy.',
  },
  reportScopeChanged: {
    en: 'The report scope or period has changed. Review the visuals and existing text before generating the report.',
    nb: 'Rapportens omfang eller periode er endret. Se gjennom visualiseringene og eksisterende tekst før rapporten genereres.',
    de: 'Umfang oder Zeitraum wurden geändert. Prüfen Sie Darstellungen und vorhandene Texte vor dem Erstellen des Berichts.',
    sv: 'Rapportens urval eller period har ändrats. Granska visualiseringarna och befintlig text innan rapporten skapas.',
    fi: 'Raportin rajaus tai ajanjakso on muuttunut. Tarkista kuvat ja aiemmat tekstit ennen raportin luomista.',
    cz: 'Rozsah nebo období zprávy se změnily. Před vytvořením zprávy zkontrolujte grafy a stávající text.',
  },
  exportData: {
    en: 'Export data',
    nb: 'Eksporter data',
    de: 'Daten exportieren',
    sv: 'Exportera data',
    fi: 'Vie tiedot',
    cz: 'Exportovat data',
  },
  exportDataDescription: {
    en: 'Choose the period, data type and filters for the export.',
    nb: 'Velg periode, datatype og filtre for eksporten.',
    de: 'Zeitraum, Datentyp und Filter für den Export wählen.',
    sv: 'Välj period, datatyp och filter för exporten.',
    fi: 'Valitse viennin ajanjakso, tietotyyppi ja suodattimet.',
    cz: 'Vyberte období, typ dat a filtry pro export.',
  },
  exportCurrentPeriod: {
    en: 'Current selection',
    nb: 'Gjeldende periode',
    de: 'Aktuelle Auswahl',
    sv: 'Aktuellt val',
    fi: 'Nykyinen valinta',
    cz: 'Aktuální výběr',
  },
  exportAggregatedData: {
    en: 'Aggregated data',
    nb: 'Aggregerte data',
    de: 'Aggregierte Daten',
    sv: 'Aggregerade data',
    fi: 'Koostetut tiedot',
    cz: 'Agregovaná data',
  },
  exportAggregateDescription: {
    en: 'Three-hour intervals: average temperature and humidity; maximum moisture and wood moisture.',
    nb: 'Tre timers intervaller: gjennomsnittlig temperatur og luftfuktighet; maksimal fukt og trefukt.',
    de: 'Drei-Stunden-Intervalle: mittlere Temperatur und Luftfeuchte; maximale Feuchte und Holzfeuchte.',
    sv: 'Tretimmarsintervall: medeltemperatur och luftfuktighet; maximal fukt och träfukt.',
    fi: 'Kolmen tunnin jaksot: lämpötilan ja ilmankosteuden keskiarvo; kosteuden ja puukosteuden maksimi.',
    cz: 'Tříhodinové intervaly: průměrná teplota a vlhkost vzduchu; maximální vlhkost a vlhkost dřeva.',
  },
  exportRawData: {
    en: 'Raw data',
    nb: 'Rådata',
    de: 'Rohdaten',
    sv: 'Rådata',
    fi: 'Raakatiedot',
    cz: 'Nezpracovaná data',
  },
  exportRawDescription: {
    en: 'Individual sensor readings',
    nb: 'Individuelle sensoravlesninger',
    de: 'Einzelne Sensormessungen',
    sv: 'Enskilda sensoravläsningar',
    fi: 'Yksittäiset anturilukemat',
    cz: 'Jednotlivá měření senzorů',
  },
  exportDataType: {
    en: 'Data',
    nb: 'Data',
    de: 'Daten',
    sv: 'Data',
    fi: 'Tiedot',
    cz: 'Data',
  },
  exportWeatherTitle: {
    en: 'Weather data',
    nb: 'Værdata',
    de: 'Wetterdaten',
    sv: 'Väderdata',
    fi: 'Säätiedot',
    cz: 'Údaje o počasí',
  },
  exportDownloadWeather: {
    en: 'Download weather data',
    nb: 'Last ned værdata',
    de: 'Wetterdaten herunterladen',
    sv: 'Ladda ner väderdata',
    fi: 'Lataa säätiedot',
    cz: 'Stáhnout údaje o počasí',
  },
  exportWeatherHelp: {
    en: 'Download a separate file for the selected period and format. Archived forecasts, not measured observations. Sensor filters do not apply. Missing records are not filled in.',
    nb: 'Last ned en egen fil for valgt periode og format. Arkiverte værvarsler, ikke målte observasjoner. Sensorfiltre gjelder ikke. Manglende data fylles ikke inn.',
    de: 'Eine separate Datei für den gewählten Zeitraum und das gewählte Format herunterladen. Archivierte Vorhersagen, keine Messbeobachtungen. Sensorfilter gelten nicht. Fehlende Datensätze werden nicht ergänzt.',
    sv: 'Ladda ner en separat fil för vald period och valt format. Arkiverade prognoser, inte uppmätta observationer. Sensorfilter gäller inte. Saknade poster fylls inte i.',
    fi: 'Lataa erillinen tiedosto valitulta ajanjaksolta valitussa muodossa. Arkistoituja ennusteita, ei mitattuja havaintoja. Anturisuodattimet eivät koske säätietoja. Puuttuvia tietoja ei täytetä.',
    cz: 'Stáhnout samostatný soubor pro vybrané období a formát. Archivované předpovědi, nikoli naměřená pozorování. Filtry senzorů se nepoužijí. Chybějící záznamy se nedoplňují.',
  },
  exportWeatherAttribution: {
    en: 'Data from MET Norway, licensed under CC BY 4.0. Selected fields archived and exported by Sensor Innovation. Attribution and licence links are included in every exported row. You may share and adapt the weather data under this licence; retain attribution and indicate changes.',
    nb: 'Data fra MET Norway, lisensiert under CC BY 4.0. Utvalgte felt arkivert og eksportert av Sensor Innovation. Kilde og lisenslenker følger hver eksporterte rad. Værdataene kan deles og bearbeides under denne lisensen; behold kildehenvisning og oppgi endringer.',
    de: 'Daten von MET Norway unter CC BY 4.0. Ausgewählte Felder von Sensor Innovation archiviert und exportiert. Quellenangabe und Lizenzlinks stehen in jeder exportierten Zeile. Wetterdaten dürfen gemäß dieser Lizenz geteilt und bearbeitet werden; Quellenangabe beibehalten und Änderungen kennzeichnen.',
    sv: 'Data från MET Norway, licensierade under CC BY 4.0. Utvalda fält arkiverade och exporterade av Sensor Innovation. Källhänvisning och licenslänkar ingår i varje exporterad rad. Väderdata får delas och bearbetas enligt licensen; behåll källhänvisning och ange ändringar.',
    fi: 'MET Norwayn tiedot, lisenssi CC BY 4.0. Sensor Innovation on arkistoinut ja vienyt valitut kentät. Lähde ja lisenssilinkit sisältyvät jokaiseen vietyyn riviin. Säätietoja saa jakaa ja muokata lisenssin mukaisesti; säilytä lähdemerkintä ja ilmoita muutokset.',
    cz: 'Data od MET Norway pod licencí CC BY 4.0. Vybraná pole archivovala a exportovala společnost Sensor Innovation. Zdroj a odkazy na licenci jsou součástí každého exportovaného řádku. Údaje o počasí lze sdílet a upravovat podle této licence; zachovejte uvedení zdroje a označte změny.',
  },
  exportWeatherDownloaded: {
    en: 'Weather data downloaded. You can also download sensor data for the same period below.',
    nb: 'Værdata er lastet ned. Du kan også laste ned sensordata for samme periode nedenfor.',
    de: 'Wetterdaten heruntergeladen. Sensordaten für denselben Zeitraum können unten heruntergeladen werden.',
    sv: 'Väderdata har laddats ner. Du kan även ladda ner sensordata för samma period nedan.',
    fi: 'Säätiedot ladattu. Voit ladata alta myös anturitiedot samalta ajanjaksolta.',
    cz: 'Údaje o počasí byly staženy. Níže můžete stáhnout i data senzorů za stejné období.',
  },
  exportFormat: {
    en: 'Format',
    nb: 'Format',
    de: 'Format',
    sv: 'Format',
    fi: 'Muoto',
    cz: 'Formát',
  },
  exportCompressedCsv: {
    en: 'Compressed CSV (.csv.gz)',
    nb: 'Komprimert CSV (.csv.gz)',
    de: 'Komprimierte CSV (.csv.gz)',
    sv: 'Komprimerad CSV (.csv.gz)',
    fi: 'Pakattu CSV (.csv.gz)',
    cz: 'Komprimované CSV (.csv.gz)',
  },
  exportFilters: {
    en: 'Filters',
    nb: 'Filtre',
    de: 'Filter',
    sv: 'Filter',
    fi: 'Suodattimet',
    cz: 'Filtry',
  },
  exportFilterHelp: {
    en: 'Leave a filter empty to include all values. Chart filters are not applied.',
    nb: 'La et filter stå tomt for å inkludere alle verdier. Diagramfiltre brukes ikke.',
    de: 'Leere Filter schließen alle Werte ein. Diagrammfilter werden nicht angewendet.',
    sv: 'Lämna ett filter tomt för att inkludera alla värden. Diagramfilter tillämpas inte.',
    fi: 'Tyhjä suodatin sisältää kaikki arvot. Kaavion suodattimia ei käytetä.',
    cz: 'Prázdný filtr zahrnuje všechny hodnoty. Filtry grafu se nepoužijí.',
  },
  exportReadingStatus: {
    en: 'Reading status (during period)',
    nb: 'Avlesningsstatus (i perioden)',
    de: 'Messstatus (im Zeitraum)',
    sv: 'Avläsningsstatus (under perioden)',
    fi: 'Lukeman tila (ajanjaksolla)',
    cz: 'Stav měření (v období)',
  },
  exportStatusHelp: {
    en: 'Exports matching readings or aggregates. Offline gaps do not generate rows. Status estimates use sensors’ current statuses; historical counts may differ.',
    nb: 'Eksporterer samsvarende avlesninger eller aggregater. Frakoblede perioder gir ingen rader. Statusestimater bruker sensorers nåværende status; historiske antall kan avvike.',
    de: 'Exportiert passende Messungen oder Aggregate. Offline-Lücken erzeugen keine Zeilen. Statusschätzungen verwenden den aktuellen Sensorstatus; historische Anzahlen können abweichen.',
    sv: 'Exporterar matchande avläsningar eller aggregat. Offlineperioder ger inga rader. Statusuppskattningar använder sensorernas aktuella status; historiska antal kan avvika.',
    fi: 'Vie vastaavat lukemat tai koosteet. Yhteyskatkot eivät luo rivejä. Tila-arviot perustuvat anturien nykyiseen tilaan; historialliset määrät voivat poiketa.',
    cz: 'Exportuje odpovídající měření nebo agregáty. Výpadky nevytvářejí řádky. Odhady podle stavu využívají aktuální stav senzorů; historické počty se mohou lišit.',
  },
  exportEstimatedRows: {
    en: 'Estimated rows',
    nb: 'Estimerte rader',
    de: 'Geschätzte Zeilen',
    sv: 'Uppskattade rader',
    fi: 'Arvioidut rivit',
    cz: 'Odhad řádků',
  },
  exportDays: {
    en: '{{count}} days',
    nb: '{{count}} dager',
    de: '{{count}} Tage',
    sv: '{{count}} dagar',
    fi: '{{count}} päivää',
    cz: '{{count}} dní',
  },
  exportRawEstimateHelp: {
    en: 'Estimate assumes 90 raw readings per day, or 45 for wood sensors. Actual counts vary.',
    nb: 'Estimatet antar 90 råavlesninger per dag, eller 45 for trefuktsensorer. Faktisk antall varierer.',
    de: 'Schätzung: 90 Rohmessungen pro Tag, bei Holzfeuchtesensoren 45. Tatsächliche Anzahl variiert.',
    sv: 'Uppskattning: 90 råavläsningar per dag, eller 45 för träfuktsensorer. Faktiskt antal varierar.',
    fi: 'Arvio: 90 raakalukemaa päivässä, puukosteusantureille 45. Todellinen määrä vaihtelee.',
    cz: 'Odhad: 90 nezpracovaných měření denně, u senzorů vlhkosti dřeva 45. Skutečný počet se liší.',
  },
  exportAggregateEstimateHelp: {
    en: 'Estimate assumes 8 three-hour aggregates per sensor per day. Actual counts vary.',
    nb: 'Estimatet antar 8 tretimersaggregater per sensor per dag. Faktisk antall varierer.',
    de: 'Schätzung: 8 Drei-Stunden-Aggregate pro Sensor und Tag. Tatsächliche Anzahl variiert.',
    sv: 'Uppskattning: 8 tretimmarsaggregat per sensor och dag. Faktiskt antal varierar.',
    fi: 'Arvio: 8 kolmen tunnin koostetta anturia ja päivää kohti. Todellinen määrä vaihtelee.',
    cz: 'Odhad: 8 tříhodinových agregátů na senzor denně. Skutečný počet se liší.',
  },
  exportDateError: {
    en: 'Choose a valid period of up to 371 days ending today or earlier.',
    nb: 'Velg en gyldig periode på opptil 371 dager som slutter i dag eller tidligere.',
    de: 'Gültigen Zeitraum bis 371 Tage wählen, der heute oder früher endet.',
    sv: 'Välj en giltig period på högst 371 dagar som slutar idag eller tidigare.',
    fi: 'Valitse enintään 371 päivän jakso, joka päättyy tänään tai aiemmin.',
    cz: 'Vyberte platné období do 371 dní končící dnes nebo dříve.',
  },
  exportFailed: {
    en: 'The export failed. Please try again.',
    nb: 'Eksporten mislyktes. Prøv igjen.',
    de: 'Export fehlgeschlagen. Bitte erneut versuchen.',
    sv: 'Exporten misslyckades. Försök igen.',
    fi: 'Vienti epäonnistui. Yritä uudelleen.',
    cz: 'Export se nezdařil. Zkuste to znovu.',
  },
  exportProgress: {
    en: 'Preparing export: {{completed}} / {{total}} sensors',
    nb: 'Forbereder eksport: {{completed}} / {{total}} sensorer',
    de: 'Export wird vorbereitet: {{completed}} / {{total}} Sensoren',
    sv: 'Förbereder export: {{completed}} / {{total}} sensorer',
    fi: 'Valmistellaan vientiä: {{completed}} / {{total}} anturia',
    cz: 'Příprava exportu: {{completed}} / {{total}} senzorů',
  },
  exportDownloadData: {
    en: 'Download data',
    nb: 'Last ned data',
    de: 'Daten herunterladen',
    sv: 'Ladda ner data',
    fi: 'Lataa tiedot',
    cz: 'Stáhnout data',
  },
  personalConsumer: {
    en: 'Personal consumer',
    nb: 'Privatperson',
    de: 'Privatperson',
    sv: 'Privatperson',
    fi: 'Yksityishenkilö',
    cz: 'Soukromá osoba',
  },
  searchCountryOrCode: {
    en: 'Search country or code...',
    nb: 'Søk etter land eller landskode...',
    de: 'Land oder Vorwahl suchen...',
    sv: 'Sök land eller landskod...',
    fi: 'Hae maata tai suuntanumeroa...',
    cz: 'Hledat zemi nebo předvolbu...',
  },
  noCountriesFound: {
    en: 'No countries found',
    nb: 'Ingen land funnet',
    de: 'Keine Länder gefunden',
    sv: 'Inga länder hittades',
    fi: 'Maita ei löytynyt',
    cz: 'Žádné země nenalezeny',
  },
  thresholds: {
    en: 'Thresholds',
    nb: 'Terskelverdier',
    de: 'Schwellenwerte',
    sv: 'Tröskelvärden',
    fi: 'Raja-arvot',
    cz: 'Prahové hodnoty',
  },
  insideRoofSensors: {
    en: 'Inside-roof sensors',
    nb: 'Sensorer inne i taket',
    de: 'Sensoren im Dach',
    sv: 'Sensorer inne i taket',
    fi: 'Katon sisäiset anturit',
    cz: 'Senzory uvnitř střechy',
  },
  onRoofSensors: {
    en: 'On-roof sensors',
    nb: 'Sensorer på taket',
    de: 'Sensoren auf dem Dach',
    sv: 'Sensorer på taket',
    fi: 'Katolla olevat anturit',
    cz: 'Senzory na střeše',
  },
  protectedSensorThresholdsDescription: {
    en: 'these use special algorithms that cannot be changed without permission. They can be adjusted in rare cases – please contact Sensor Innovation if you have any questions.',
    nb: 'disse bruker spesielle algoritmer som ikke kan endres uten tillatelse. De kan justeres i sjeldne tilfeller – kontakt Sensor Innovation hvis du har spørsmål.',
    de: 'diese verwenden spezielle Algorithmen, die nicht ohne Genehmigung geändert werden können. In seltenen Fällen sind Anpassungen möglich – wenden Sie sich bei Fragen bitte an Sensor Innovation.',
    sv: 'dessa använder särskilda algoritmer som inte kan ändras utan tillstånd. De kan justeras i sällsynta fall – kontakta Sensor Innovation om du har frågor.',
    fi: 'nämä käyttävät erityisiä algoritmeja, joita ei voi muuttaa ilman lupaa. Niitä voidaan säätää harvinaisissa tapauksissa – ota yhteyttä Sensor Innovationiin, jos sinulla on kysyttävää.',
    cz: 'používají speciální algoritmy, které nelze měnit bez povolení. Ve výjimečných případech je lze upravit – v případě dotazů kontaktujte Sensor Innovation.',
  },
  fitProjectsOnMap: {
    en: 'Fit projects on map',
    nb: 'Vis prosjektene på kartet',
    de: 'Projekte auf Karte einpassen',
    sv: 'Visa projekten på kartan',
    fi: 'Sovita projektit kartalle',
    cz: 'Zobrazit projekty na mapě',
  },
  projectView: {
    en: 'Project view',
    nb: 'Prosjektvisning',
    de: 'Projektansicht',
    sv: 'Projektvy',
    fi: 'Projektinäkymä',
    cz: 'Zobrazení projektů',
  },
  listView: {
    en: 'List view',
    nb: 'Listevisning',
    de: 'Listenansicht',
    sv: 'Listvy',
    fi: 'Luettelonäkymä',
    cz: 'Zobrazení seznamu',
  },
  cardView: {
    en: 'Card view',
    nb: 'Kortvisning',
    de: 'Kartenansicht',
    sv: 'Kortvy',
    fi: 'Korttinäkymä',
    cz: 'Zobrazení karet',
  },
  projectAccessDenied: {
    en: 'No access to this project',
    nb: 'Ingen tilgang til dette prosjektet',
    de: 'Kein Zugriff auf dieses Projekt',
    sv: 'Ingen åtkomst till det här projektet',
    fi: 'Ei pääsyä tähän projektiin',
    cz: 'K tomuto projektu nemáte přístup',
  },
  projectAccessDeniedDescription: {
    en: 'You do not have permission to view this project. Contact your project administrator if you need access.',
    nb: 'Du har ikke tillatelse til å se dette prosjektet. Kontakt prosjektadministratoren hvis du trenger tilgang.',
    de: 'Sie haben keine Berechtigung, dieses Projekt anzusehen. Wenden Sie sich an Ihren Projektadministrator, wenn Sie Zugriff benötigen.',
    sv: 'Du har inte behörighet att visa det här projektet. Kontakta din projektadministratör om du behöver åtkomst.',
    fi: 'Sinulla ei ole oikeutta tarkastella tätä projektia. Ota yhteyttä projektin ylläpitäjään, jos tarvitset pääsyn.',
    cz: 'Nemáte oprávnění zobrazit tento projekt. Pokud potřebujete přístup, kontaktujte správce projektu.',
  },
  allProjects: {
    en: 'All projects',
    nb: 'Alle prosjekter',
    de: 'Alle Projekte',
    sv: 'Alla projekt',
    fi: 'Kaikki projektit',
    cz: 'Všechny projekty',
  },
  projectOverview: {
    en: 'Project overview',
    nb: 'Prosjektoversikt',
    de: 'Projektübersicht',
    sv: 'Projektöversikt',
    fi: 'Projektin yleiskatsaus',
    cz: 'Přehled projektu',
  },
  scrollToNavigation: {
    en: 'Show navigation',
    nb: 'Vis navigasjon',
    de: 'Navigation anzeigen',
    sv: 'Visa navigering',
    fi: 'Näytä navigointi',
    cz: 'Zobrazit navigaci',
  },
  adminPanel: {
    en: 'Admin Panel',
    nb: 'Administrasjonspanel',
    de: 'Adminbereich',
    sv: 'Adminpanel',
    fi: 'Ylläpitopaneeli',
    cz: 'Panel správce',
  },
  adminManagement: {
    en: 'Management',
    nb: 'Administrasjon',
    de: 'Verwaltung',
    sv: 'Administration',
    fi: 'Hallinta',
    cz: 'Správa',
  },
  adminInsights: {
    en: 'Insights',
    nb: 'Innsikt',
    de: 'Einblicke',
    sv: 'Insikter',
    fi: 'Analytiikka',
    cz: 'Přehledy',
  },
  adminNavigation: {
    en: 'Admin navigation',
    nb: 'Administrasjonsmeny',
    de: 'Admin-Navigation',
    sv: 'Administrationsmeny',
    fi: 'Ylläpitovalikko',
    cz: 'Navigace správce',
  },
  reorder: {
    en: 'Reorder',
    nb: 'Endre rekkefølge',
    de: 'Neu anordnen',
    sv: 'Ändra ordning',
    fi: 'Järjestä uudelleen',
    cz: 'Změnit pořadí',
  },
  dragToReorder: {
    en: 'Drag to reorder',
    nb: 'Dra for å endre rekkefølge',
    de: 'Zum Neuordnen ziehen',
    sv: 'Dra för att ändra ordning',
    fi: 'Muuta järjestystä vetämällä',
    cz: 'Přetažením změňte pořadí',
  },
  reorderKeyboardHelp: {
    en: 'Use the arrow keys to move this installation. Save to keep the new order, or cancel to discard it.',
    nb: 'Bruk piltastene for å flytte installasjonen. Lagre den nye rekkefølgen, eller avbryt.',
    de: 'Diese Installation mit den Pfeiltasten verschieben. Die neue Reihenfolge speichern oder abbrechen.',
    sv: 'Använd piltangenterna för att flytta installationen. Spara den nya ordningen eller avbryt.',
    fi: 'Siirrä asennusta nuolinäppäimillä. Tallenna uusi järjestys tai peruuta.',
    cz: 'Pomocí šipek přesuňte instalaci. Nové pořadí uložte nebo zrušte.',
  },
  installationReorderPosition: {
    en: '{{- name}}, position {{position}} of {{total}}',
    nb: '{{- name}}, plass {{position}} av {{total}}',
    de: '{{- name}}, Position {{position}} von {{total}}',
    sv: '{{- name}}, plats {{position}} av {{total}}',
    fi: '{{- name}}, sijainti {{position}} / {{total}}',
    cz: '{{- name}}, pozice {{position}} z {{total}}',
  },
  dropInstallationMap: {
    en: 'Drag and drop a file here, or click to browse',
    nb: 'Dra og slipp en fil her, eller klikk for å velge',
    de: 'Datei hierher ziehen oder zum Auswählen klicken',
    sv: 'Dra och släpp en fil här, eller klicka för att välja',
    fi: 'Vedä ja pudota tiedosto tähän tai valitse napsauttamalla',
    cz: 'Přetáhněte sem soubor nebo klikněte pro výběr',
  },
  allDataCombined: {
    en: 'All data combined',
    nb: 'Alle data samlet',
    de: 'Alle Daten kombiniert',
    sv: 'Alla data samlade',
    fi: 'Kaikki tiedot yhdessä',
    cz: 'Všechna data dohromady',
  },
  combinedDataDescription: {
    en: 'Display data from all installations in combined charts',
    nb: 'Vis data fra alle installasjoner i samlede diagrammer',
    de: 'Daten aller Installationen in gemeinsamen Diagrammen anzeigen',
    sv: 'Visa data från alla installationer i gemensamma diagram',
    fi: 'Näytä kaikkien asennusten tiedot yhdistetyissä kaavioissa',
    cz: 'Zobrazte data ze všech instalací ve společných grafech',
  },
  dataInstallationCount: {
    en: '{{count}} installations',
    nb: '{{count}} installasjoner',
    de: '{{count}} Installationen',
    sv: '{{count}} installationer',
    fi: '{{count}} asennusta',
    cz: '{{count}} instalací',
  },
  gatewaysOnlineCount: {
    en: '{{online}} of {{total}} gateways online',
    nb: '{{online}} av {{total}} gatewayer tilkoblet',
    de: '{{online}} von {{total}} Gateways online',
    sv: '{{online}} av {{total}} gateways online',
    fi: '{{online}} / {{total}} yhdyskäytävää verkossa',
    cz: '{{online}} z {{total}} bran online',
  },
  projectSettingsTooltip: {
    en: 'Thresholds, BMS integration and team access for this project',
    nb: 'Terskelverdier, BMS-integrasjon og teamtilgang for dette prosjektet',
    de: 'Schwellenwerte, BMS-Integration und Teamzugriff für dieses Projekt',
    sv: 'Tröskelvärden, BMS-integration och teamåtkomst för detta projekt',
    fi: 'Tämän projektin raja-arvot, BMS-integraatio ja tiimin käyttöoikeudet',
    cz: 'Prahové hodnoty, integrace BMS a přístup týmu pro tento projekt',
  },
  projectDocumentationTooltip: {
    en: 'Project reports, photos and technical documents',
    nb: 'Prosjektrapporter, bilder og tekniske dokumenter',
    de: 'Projektberichte, Fotos und technische Dokumente',
    sv: 'Projektrapporter, foton och tekniska dokument',
    fi: 'Projektiraportit, valokuvat ja tekniset asiakirjat',
    cz: 'Projektové zprávy, fotografie a technické dokumenty',
  },
  projectInstallationTooltip: {
    en: 'Plan and manage sensor and gateway placements on each installation map',
    nb: 'Planlegg og administrer plassering av sensorer og gatewayer på hvert installasjonskart',
    de: 'Sensor- und Gateway-Platzierungen auf jeder Installationskarte planen und verwalten',
    sv: 'Planera och hantera placering av sensorer och gateways på varje installationskarta',
    fi: 'Suunnittele ja hallitse anturien ja yhdyskäytävien sijoittelua kussakin asennuskartassa',
    cz: 'Plánujte a spravujte umístění senzorů a bran na každé instalační mapě',
  },
  projectDataTooltip: {
    en: 'Real-time and historical data for the whole project or one installation',
    nb: 'Sanntidsdata og historiske data for hele prosjektet eller én installasjon',
    de: 'Echtzeit- und historische Daten für das gesamte Projekt oder eine Installation',
    sv: 'Realtidsdata och historiska data för hela projektet eller en installation',
    fi: 'Reaaliaikaiset ja historiatiedot koko projektille tai yhdelle asennukselle',
    cz: 'Aktuální a historická data pro celý projekt nebo jednu instalaci',
  },
  projectDashboardTooltip: {
    en: 'Project summary, statistics and quick access to everything in the project',
    nb: 'Prosjektoversikt, statistikk og rask tilgang til alt i prosjektet',
    de: 'Projektübersicht, Statistiken und schneller Zugriff auf alles im Projekt',
    sv: 'Projektöversikt, statistik och snabb åtkomst till allt i projektet',
    fi: 'Projektin yhteenveto, tilastot ja nopea pääsy kaikkeen projektissa',
    cz: 'Souhrn projektu, statistiky a rychlý přístup ke všemu v projektu',
  },
  featureFlags: {
    en: 'Feature flags',
    nb: 'Funksjonsflagg',
    de: 'Feature-Flags',
    sv: 'Funktionsflaggor',
    fi: 'Ominaisuusliput',
    cz: 'Příznaky funkcí',
  },
  condensation: {
    en: 'Condensation',
    nb: 'Kondens',
    de: 'Kondensation',
    sv: 'Kondens',
    fi: 'Kondensaatio',
    cz: 'Kondenzace',
  },
  realtime: {
    en: 'Real-time',
    nb: 'Sanntid',
    de: 'Echtzeit',
    sv: 'Realtid',
    fi: 'Reaaliaikainen',
    cz: 'V reálném čase',
  },
  dataView: {
    en: 'View',
    nb: 'Visning',
    de: 'Ansicht',
    sv: 'Vy',
    fi: 'Näkymä',
    cz: 'Zobrazení',
  },
  allInstallations: {
    en: 'All installations',
    nb: 'Alle installasjoner',
    de: 'Alle Installationen',
    sv: 'Alla installationer',
    fi: 'Kaikki asennukset',
    cz: 'Všechny instalace',
  },
  backToInstallations: {
    en: 'Back to installations',
    nb: 'Tilbake til installasjoner',
    de: 'Zurück zu Installationen',
    sv: 'Tillbaka till installationer',
    fi: 'Takaisin asennuksiin',
    cz: 'Zpět na instalace',
  },

  projectData: { en: 'Data', nb: 'Data', de: 'Daten', sv: 'Data', fi: 'Data', cz: 'Data' },
  reportSetupHelp: {
    en: 'Set the report details and introduce the project. Your selected data period is already filled in.',
    nb: 'Angi rapportdetaljene og introduser prosjektet. Den valgte dataperioden er allerede fylt inn.',
    de: 'Legen Sie die Berichtsdetails fest und stellen Sie das Projekt vor. Der ausgewählte Datenzeitraum ist bereits eingetragen.',
    cz: 'Nastavte podrobnosti zprávy a představte projekt. Vybrané období dat je již vyplněno.',
    fi: 'Määritä raportin tiedot ja esittele projekti. Valittu datajakso on jo täytetty.',
    sv: 'Ange rapportdetaljerna och introducera projektet. Den valda dataperioden är redan ifylld.',
  },
  reportWeatherHelp: {
    en: 'Include the weather for this period and add context in the preview. Turn it off to leave this section out.',
    nb: 'Ta med været for perioden og legg til kommentarer i forhåndsvisningen. Slå av for å utelate delen.',
    de: 'Fügen Sie das Wetter für diesen Zeitraum hinzu und ergänzen Sie Kommentare in der Vorschau. Deaktivieren Sie die Option, um diesen Abschnitt auszulassen.',
    cz: 'Zahrňte počasí za toto období a přidejte komentář v náhledu. Vypnutím tuto část vynecháte.',
    fi: 'Sisällytä jakson sää ja lisää kommentteja esikatselussa. Poista valinta jättääksesi osan pois.',
    sv: 'Ta med vädret för perioden och lägg till kommentarer i förhandsvisningen. Stäng av för att utelämna avsnittet.',
  },
  reportChartsHelp: {
    en: 'Choose the charts to include. Add one shared comment in the preview and adjust the chart selections as needed.',
    nb: 'Velg diagrammene som skal tas med. Legg til en felles kommentar i forhåndsvisningen og tilpass diagramutvalget ved behov.',
    de: 'Wählen Sie die Diagramme aus. Fügen Sie in der Vorschau einen gemeinsamen Kommentar hinzu und passen Sie die Diagrammauswahl bei Bedarf an.',
    cz: 'Vyberte grafy do zprávy. V náhledu přidejte jeden společný komentář a podle potřeby upravte výběr v grafech.',
    fi: 'Valitse sisällytettävät kaaviot. Lisää yhteinen kommentti esikatselussa ja säädä kaavioiden valintoja tarvittaessa.',
    sv: 'Välj diagram att ta med. Lägg till en gemensam kommentar i förhandsvisningen och anpassa diagramvalen vid behov.',
  },
  reportDowntimeHelp: {
    en: 'Choose downtime maps, a signal-gap chart, or both. Each map keeps its own observations.',
    nb: 'Velg nedetidskart, et diagram over signalbrudd eller begge deler. Hvert kart har egne observasjoner.',
    de: 'Wählen Sie Ausfallzeitkarten, ein Signallückendiagramm oder beides. Jede Karte hat eigene Beobachtungen.',
    cz: 'Vyberte mapy výpadků, graf výpadků signálu nebo obojí. Každá mapa má vlastní pozorování.',
    fi: 'Valitse katkokartat, signaalikatkoskaavio tai molemmat. Jokaisella kartalla on omat havainnot.',
    sv: 'Välj avbrottskartor, ett diagram över signalavbrott eller båda. Varje karta har egna observationer.',
  },
  reportConclusionHelp: {
    en: 'Finish with your findings and recommendations. You can review and rearrange all sections next.',
    nb: 'Avslutt med funn og anbefalinger. Deretter kan du se gjennom og endre rekkefølgen på alle delene.',
    de: 'Schließen Sie mit Ihren Ergebnissen und Empfehlungen ab. Anschließend können Sie alle Abschnitte prüfen und neu anordnen.',
    cz: 'Na závěr uveďte zjištění a doporučení. V dalším kroku můžete všechny části zkontrolovat a přeuspořádat.',
    fi: 'Viimeistele havainnoilla ja suosituksilla. Seuraavaksi voit tarkistaa ja järjestää kaikki osat.',
    sv: 'Avsluta med dina resultat och rekommendationer. Därefter kan du granska och ändra ordningen på alla delar.',
  },
  reportPreviewEmpty: {
    en: 'Choose content in the section options to see it here. Unselected content will be left out of the report.',
    nb: 'Velg innhold i alternativene for å se det her. Innhold som ikke er valgt, blir utelatt fra rapporten.',
    de: 'Wählen Sie Inhalte in den Abschnittsoptionen aus, um sie hier anzuzeigen. Nicht ausgewählte Inhalte werden im Bericht ausgelassen.',
    cz: 'Vyberte obsah v možnostech části a zobrazí se zde. Nevybraný obsah nebude součástí zprávy.',
    fi: 'Valitse sisältöä osan asetuksista nähdäksesi sen tässä. Valitsematon sisältö jätetään raportista pois.',
    sv: 'Välj innehåll i avsnittets alternativ för att visa det här. Innehåll som inte valts tas inte med i rapporten.',
  },
  reportMapSelectionHelp: {
    en: 'Each card adds one map to the report. Choose its metric in the card, then open the preview to add observations for that map.',
    nb: 'Hvert kort legger til ett kart i rapporten. Velg måleparameter i kortet, og åpne forhåndsvisningen for å legge til observasjoner for kartet.',
    de: 'Jede Karte fügt dem Bericht eine Kartenseite hinzu. Wählen Sie die Messgröße im Kartenfeld und öffnen Sie die Vorschau, um Beobachtungen für diese Karte hinzuzufügen.',
    cz: 'Každá karta přidá do zprávy jednu mapu. Vyberte metriku přímo na kartě a otevřete náhled pro přidání pozorování k této mapě.',
    fi: 'Jokainen kortti lisää raporttiin yhden kartan. Valitse mittari kortissa ja avaa esikatselu lisätäksesi kartan havainnot.',
    sv: 'Varje kort lägger till en karta i rapporten. Välj mätvärde i kortet och öppna förhandsvisningen för att lägga till observationer för kartan.',
  },
  reportMapPreviewHelp: {
    en: 'These observations apply only to this map.',
    nb: 'Disse observasjonene gjelder bare dette kartet.',
    de: 'Diese Beobachtungen gelten nur für diese Karte.',
    cz: 'Tato pozorování se vztahují pouze k této mapě.',
    fi: 'Nämä havainnot koskevat vain tätä karttaa.',
    sv: 'Dessa observationer gäller endast den här kartan.',
  },
  addMap: {
    en: 'Add map',
    nb: 'Legg til kart',
    de: 'Karte hinzufügen',
    cz: 'Přidat mapu',
    fi: 'Lisää kartta',
    sv: 'Lägg till karta',
  },
  reportMapNow: { en: 'Now', nb: 'Nå', de: 'Jetzt', cz: 'Nyní', fi: 'Nyt', sv: 'Nu' },
  reportMapReading: {
    en: 'Selected reading',
    nb: 'Valgt måling',
    de: 'Ausgewählter Messwert',
    cz: 'Vybrané měření',
    fi: 'Valittu mittaus',
    sv: 'Vald mätning',
  },
  backToReportSteps: {
    en: 'Back to report steps',
    nb: 'Tilbake til rapportstegene',
    de: 'Zurück zu den Berichtsschritten',
    cz: 'Zpět ke krokům zprávy',
    fi: 'Takaisin raportin vaiheisiin',
    sv: 'Tillbaka till rapportstegen',
  },
  reportRevisionCreatesDraft: {
    en: 'Changes will be saved as a new report. The existing report is kept in Documentation → Reports.',
    nb: 'Endringer lagres som en ny rapport. Den eksisterende rapporten beholdes under Dokumentasjon → Rapporter.',
    de: 'Änderungen werden als neuer Bericht gespeichert. Der bestehende Bericht bleibt unter Dokumentation → Berichte erhalten.',
    cz: 'Změny se uloží jako nová zpráva. Stávající zpráva zůstane v Dokumentace → Zprávy.',
    fi: 'Muutokset tallennetaan uutena raporttina. Nykyinen raportti säilyy kohdassa Dokumentaatio → Raportit.',
    sv: 'Ändringar sparas som en ny rapport. Den befintliga rapporten finns kvar under Dokumentation → Rapporter.',
  },
  reportPdfReady: {
    en: 'Your PDF is ready.',
    nb: 'PDF-en er klar.',
    de: 'Ihre PDF ist fertig.',
    cz: 'Vaše PDF je připraveno.',
    fi: 'PDF on valmis.',
    sv: 'Din PDF är klar.',
  },
  reportDocumentationLocation: {
    en: 'Your report is also available under Documentation → Reports.',
    nb: 'Rapporten er også tilgjengelig under Dokumentasjon → Rapporter.',
    de: 'Ihr Bericht ist auch unter Dokumentation → Berichte verfügbar.',
    cz: 'Zpráva je také dostupná v Dokumentace → Zprávy.',
    fi: 'Raportti on saatavilla myös kohdassa Dokumentaatio → Raportit.',
    sv: 'Rapporten finns också under Dokumentation → Rapporter.',
  },
  reportGenerationTakingLonger: {
    en: 'Generation is taking longer than expected. Check again or find the report under Documentation → Reports.',
    nb: 'Genereringen tar lengre tid enn forventet. Sjekk igjen eller finn rapporten under Dokumentasjon → Rapporter.',
    de: 'Die Erstellung dauert länger als erwartet. Prüfen Sie erneut oder suchen Sie unter Dokumentation → Berichte.',
    cz: 'Generování trvá déle než očekáváno. Zkontrolujte znovu nebo najděte zprávu v Dokumentace → Zprávy.',
    fi: 'Luonti kestää odotettua kauemmin. Tarkista uudelleen tai etsi raportti kohdasta Dokumentaatio → Raportit.',
    sv: 'Genereringen tar längre tid än väntat. Kontrollera igen eller hitta rapporten under Dokumentation → Rapporter.',
  },
  checkReportAgain: {
    en: 'Check again',
    nb: 'Sjekk igjen',
    de: 'Erneut prüfen',
    cz: 'Zkontrolovat znovu',
    fi: 'Tarkista uudelleen',
    sv: 'Kontrollera igen',
  },
  preparedReportPreview: {
    en: 'Prepared report preview',
    nb: 'Forhåndsvisning av klargjort rapport',
    de: 'Vorschau des vorbereiteten Berichts',
    cz: 'Náhled připravené zprávy',
    fi: 'Valmistellun raportin esikatselu',
    sv: 'Förhandsvisning av förberedd rapport',
  },

  reportChartsInstallationScope: {
    en: 'Charts use the sensors from the installations selected in Period summary.',
    nb: 'Diagrammene bruker sensorene fra installasjonene valgt i periodesammendraget.',
    de: 'Die Diagramme verwenden die Sensoren der in der Zeitraumübersicht ausgewählten Installationen.',
    cz: 'Grafy používají senzory instalací vybraných v souhrnu období.',
    fi: 'Kaaviot käyttävät jakson yhteenvedossa valittujen asennusten antureita.',
    sv: 'Diagrammen använder sensorerna från installationerna som valts i periodsammanfattningen.',
  },
  conclusion: {
    en: 'Conclusion',
    nb: 'Konklusjon',
    de: 'Fazit',
    cz: 'Závěr',
    fi: 'Johtopäätös',
    sv: 'Slutsats',
  },
  reportReview: {
    en: 'Review report',
    nb: 'Se gjennom rapport',
    de: 'Bericht prüfen',
    cz: 'Zkontrolovat zprávu',
    fi: 'Tarkista raportti',
    sv: 'Granska rapport',
  },
  reportReviewDescription: {
    en: 'All selected report parts are listed in PDF order. Drag and drop parts to rearrange the report, or use the move buttons.',
    nb: 'Alle valgte rapportdeler vises i PDF-rekkefølge. Dra og slipp delene for å endre rekkefølgen, eller bruk flytteknappene.',
    de: 'Alle ausgewählten Berichtsteile sind in PDF-Reihenfolge aufgelistet. Ordnen Sie Teile per Drag-and-drop oder mit den Verschiebeschaltflächen neu an.',
    cz: 'Všechny vybrané části zprávy jsou uvedeny v pořadí PDF. Změňte pořadí částí přetažením nebo pomocí tlačítek pro přesun.',
    fi: 'Kaikki valitut raportin osat näkyvät PDF-järjestyksessä. Järjestä osat vetämällä ja pudottamalla tai käyttämällä siirtopainikkeita.',
    sv: 'Alla valda rapportdelar visas i PDF-ordning. Dra och släpp delarna för att ändra ordningen, eller använd flyttknapparna.',
  },
  recreateReportPdf: {
    en: 'Recreate PDF',
    nb: 'Lag PDF på nytt',
    de: 'PDF erneut erstellen',
    cz: 'Znovu vytvořit PDF',
    fi: 'Luo PDF uudelleen',
    sv: 'Skapa PDF igen',
  },
  accessExpiryDate: {
    cz: 'Datum vypršení přístupu',
    de: 'Ablaufdatum des Zugriffs',
    en: 'Access expiry date',
    sv: 'Åtkomstens utgångsdatum',
    fi: 'Käyttöoikeuden umpeutumispäivä',
    nb: 'Tilgang utløpsdato',
  },
  actions: {
    cz: 'Akce',
    de: 'Aktionen',
    en: 'Actions',
    sv: 'Åtgärder',
    fi: 'Toiminnot',
    nb: 'Handlinger',
  },
  activate: {
    cz: 'Aktivovat',
    de: 'Aktivieren',
    en: 'Activate',
    sv: 'Aktivera',
    fi: 'Aktivoi',
    nb: 'Aktiver',
  },
  activateDevice: {
    cz: 'Aktivovat zařízení',
    de: 'Gerät aktivieren',
    en: 'Activate device',
    sv: 'Aktivera enhet',
    fi: 'Aktivoi laite',
    nb: 'Aktiver enhet',
  },
  replaceSensor: {
    cz: 'Vyměnit senzor',
    de: 'Sensor ersetzen',
    en: 'Replace sensor',
    sv: 'Ersätt sensor',
    fi: 'Korvaa anturi',
    nb: 'Erstatt sensor',
  },
  replaceSensorInfo: {
    cz: 'Tímto nahradíte stávající senzor novým senzorem. Všechna data ze stávajícího senzoru budou převedena na nový senzor a starý senzor bude deaktivován.',
    de: 'Dadurch wird der bestehende Sensor durch einen neuen Sensor ersetzt. Alle Daten des bestehenden Sensors werden auf den neuen Sensor übertragen, und der alte Sensor wird deaktiviert.',
    en: 'This will replace the existing sensor with a new sensor. All data from the existing sensor will be transferred to the new sensor, and the old sensor will be deactivated.',
    sv: 'Detta ersätter den befintliga sensorn med en ny sensor. All data från den befintliga sensorn överförs till den nya sensorn, och den gamla sensorn inaktiveras.',
    fi: 'Tämä korvaa nykyisen anturin uudella anturilla. Kaikki nykyisen anturin tiedot siirretään uudelle anturille, ja vanha anturi poistetaan käytöstä.',
    nb: 'Dette vil erstatte den eksisterende sensoren med en ny sensor. Alle data fra den eksisterende sensoren vil bli overført til den nye sensoren, og den gamle sensoren vil bli deaktivert.',
  },
  replaceSensorConfirmation: {
    cz: 'Rozumím, že tento senzor bude trvale nahrazen',
    de: 'Ich verstehe, dass dieser Sensor dauerhaft ersetzt wird',
    en: 'I understand that this sensor will be permanently replaced',
    sv: 'Jag förstår att den här sensorn kommer att ersättas permanent',
    fi: 'Ymmärrän, että tämä anturi korvataan pysyvästi',
    nb: 'Jeg forstår at denne sensoren vil bli permanent erstattet',
  },
  replaceSensorConfirm: {
    cz: 'Potvrdit výměnu',
    de: 'Ersetzung bestätigen',
    en: 'Confirm replacement',
    sv: 'Bekräfta ersättning',
    fi: 'Vahvista korvaus',
    nb: 'Bekreft erstatning',
  },
  replaceGateway: {
    cz: 'Vyměnit gateway',
    de: 'Gateway ersetzen',
    en: 'Replace gateway',
    sv: 'Ersätt gateway',
    fi: 'Korvaa yhdyskäytävä',
    nb: 'Erstatt gateway',
  },
  replaceGatewayInfo: {
    cz: 'Tímto nahradíte stávající gateway novým gateway. Všechna data ze stávajícího gateway budou převedena na nový gateway a starý gateway bude deaktivován.',
    de: 'Dadurch wird das bestehende Gateway durch ein neues Gateway ersetzt. Alle Daten des bestehenden Gateways werden auf das neue Gateway übertragen, und das alte Gateway wird deaktiviert.',
    en: 'This will replace the existing gateway with a new gateway. All data from the existing gateway will be transferred to the new gateway, and the old gateway will be deactivated.',
    sv: 'Detta ersätter den befintliga gatewayen med en ny gateway. All data från den befintliga gatewayen överförs till den nya gatewayen, och den gamla gatewayen inaktiveras.',
    fi: 'Tämä korvaa nykyisen yhdyskäytävän uudella yhdyskäytävällä. Kaikki nykyisen yhdyskäytävän tiedot siirretään uudelle yhdyskäytävälle, ja vanha yhdyskäytävä poistetaan käytöstä.',
    nb: 'Dette vil erstatte den eksisterende gatewayen med en ny gateway. Alle data fra den eksisterende gatewayen vil bli overført til den nye gatewayen, og den gamle gatewayen vil bli deaktivert.',
  },
  replaceGatewayConfirmation: {
    cz: 'Rozumím, že tento gateway bude trvale nahrazen',
    de: 'Ich verstehe, dass dieses Gateway dauerhaft ersetzt wird',
    en: 'I understand that this gateway will be permanently replaced',
    sv: 'Jag förstår att den här gatewayen kommer att ersättas permanent',
    fi: 'Ymmärrän, että tämä yhdyskäytävä korvataan pysyvästi',
    nb: 'Jeg forstår at denne gatewayen vil bli permanent erstattet',
  },
  replaceGatewayConfirm: {
    cz: 'Potvrdit výměnu',
    de: 'Ersetzung bestätigen',
    en: 'Confirm replacement',
    sv: 'Bekräfta ersättning',
    fi: 'Vahvista korvaus',
    nb: 'Bekreft erstatning',
  },
  activatedUnits: {
    cz: 'Aktivované jednotky',
    de: 'Aktivierte Einheiten',
    en: 'Activated units',
    sv: 'Aktiverade enheter',
    fi: 'Aktivoidut laitteet',
    nb: 'Aktiverte enheter',
  },
  active: {
    cz: 'Aktivní',
    de: 'Aktiv',
    en: 'Active',
    sv: 'Aktiv',
    fi: 'Aktiivinen',
    nb: 'Aktiv',
  },
  passive: {
    cz: 'Pasivní',
    de: 'Passiv',
    en: 'Passive',
    sv: 'Passiv',
    fi: 'Passiivinen',
    nb: 'Passiv',
  },
  activeGateways: {
    cz: 'Aktivní brány',
    de: 'Aktive Gateways',
    en: 'Active gateways',
    sv: 'Aktiva gateways',
    fi: 'Aktiiviset reitittimet',
    nb: 'Aktive gatewayer',
  },
  add: {
    cz: 'Přidat',
    de: 'Hinzufügen',
    en: 'Add',
    sv: 'Lägg till',
    fi: 'Lisää',
    nb: 'Legg til',
  },
  addCompany: {
    cz: 'Přidat společnost',
    de: 'Firma hinzufügen',
    en: 'Add company',
    sv: 'Lägg till företag',
    fi: 'Lisää yritys',
    nb: 'Legg til selskap',
  },
  addDevice: {
    cz: 'Přidat zařízení',
    de: 'Gerät hinzufügen',
    en: 'Add device',
    sv: 'Lägg till enhet',
    fi: 'Lisää laite',
    nb: 'Legg til enhet',
  },
  addDistributor: {
    cz: 'Přidat distributéra',
    de: 'Distributor hinzufügen',
    en: 'Add distributor',
    sv: 'Lägg till distributör',
    fi: 'Lisää jakelija',
    nb: 'Legg til distributør',
  },
  addDistributorUser: {
    cz: 'Přidat uživatele distributora',
    de: 'Distributor-Benutzer hinzufügen',
    en: 'Add distributor user',
    sv: 'Lägg till distributöranvändare',
    fi: 'Lisää jakelijakäyttäjä',
    nb: 'Legg til distributørbruker',
  },
  addFile: {
    cz: 'Přidat soubor',
    de: 'Datei hinzufügen',
    en: 'Add file',
    sv: 'Lägg till fil',
    fi: 'Lisää tiedosto',
    nb: 'Legg til fil',
  },
  addInstallation: {
    cz: 'Přidat instalaci',
    de: 'Installation hinzufügen',
    en: 'Add installation',
    sv: 'Lägg till installation',
    fi: 'Lisää asennus',
    nb: 'Legg til installasjon',
  },
  addProject: {
    cz: 'Přidat projekt',
    de: 'Projekt hinzufügen',
    en: 'Add project',
    sv: 'Lägg till projekt',
    fi: 'Lisää projekti',
    nb: 'Legg til prosjekt',
  },
  addUser: {
    cz: 'Přidat uživatele',
    de: 'Benutzer hinzufügen',
    en: 'Add user',
    sv: 'Lägg till användare',
    fi: 'Lisää käyttäjä',
    nb: 'Legg til bruker',
  },
  address: {
    cz: 'Adresa',
    de: 'Adresse',
    en: 'Address',
    sv: 'Adresse',
    fi: 'Osoite',
    nb: 'Adresse',
  },
  admin: {
    cz: 'Admin',
    de: 'Admin',
    en: 'Admin',
    sv: 'Admin',
    fi: 'Admin',
    nb: 'Admin',
  },
  monitoring: {
    cz: 'Monitoring',
    de: 'Monitoring',
    en: 'Monitoring',
    sv: 'Monitoring',
    fi: 'Monitoring',
    nb: 'Monitoring',
  },
  kpiDashboard: {
    cz: 'Fleet dashboard',
    de: 'Fleet-Dashboard',
    en: 'Fleet dashboard',
    sv: 'Fleet dashboard',
    fi: 'Fleet-koontinäyttö',
    nb: 'Fleet-dashboard',
  },
  kpiDashboardAccessRequired: {
    cz: 'Přístup k tomuto KPI dashboardu je omezen.',
    de: 'Der Zugriff auf dieses KPI-Dashboard ist eingeschränkt.',
    en: 'Access to this KPI dashboard is restricted.',
    sv: 'Åtkomst till denna KPI-dashboard är begränsad.',
    fi: 'Pääsy tähän KPI-koontinäyttöön on rajoitettu.',
    nb: 'Tilgang til dette KPI-dashboardet er begrenset.',
  },
  projectMap: {
    cz: 'Mapa projektů',
    de: 'Projektkarte',
    en: 'Project map',
    sv: 'Projektkarta',
    fi: 'Projektikartta',
    nb: 'Prosjektkart',
  },
  projectMapDescription: {
    cz: 'Celosvětový přehled umístění projektů.',
    de: 'Weltweite Übersicht der Projektstandorte.',
    en: 'Worldwide overview of project locations.',
    sv: 'Global översikt över projektplatser.',
    fi: 'Maailmanlaajuinen yleiskuva projektien sijainneista.',
    nb: 'Global oversikt over prosjektplasseringer.',
  },
  projectMapInstructions: {
    cz: 'Přibližujte a posouvejte mapu. Výběrem značky přiblížíte přesnou polohu projektu.',
    de: 'Zoomen und verschieben Sie die Karte. Wählen Sie eine Markierung aus, um den genauen Projektstandort anzuzeigen.',
    en: 'Zoom and pan the map. Select a marker to zoom in on the exact project location.',
    sv: 'Zooma och panorera kartan. Välj en markör för att zooma in på projektets exakta plats.',
    fi: 'Zoomaa ja siirrä karttaa. Valitse merkki nähdäksesi projektin tarkan sijainnin.',
    nb: 'Zoom og flytt kartet. Velg en markør for å zoome inn på prosjektets nøyaktige plassering.',
  },
  projectsWithoutCoordinates: {
    cz: '{{count}} projektů bez platných souřadnic není zobrazeno.',
    de: '{{count}} Projekte ohne gültige Koordinaten werden nicht angezeigt.',
    en: '{{count}} projects without valid coordinates are not displayed.',
    sv: '{{count}} projekt utan giltiga koordinater visas inte.',
    fi: '{{count}} projektia ilman kelvollisia koordinaatteja ei näytetä.',
    nb: '{{count}} prosjekter uten gyldige koordinater vises ikke.',
  },
  noProjectsWithCoordinates: {
    cz: 'Žádné projekty nemají platné souřadnice.',
    de: 'Keine Projekte haben gültige Koordinaten.',
    en: 'No projects have valid coordinates.',
    sv: 'Inga projekt har giltiga koordinater.',
    fi: 'Yhdelläkään projektilla ei ole kelvollisia koordinaatteja.',
    nb: 'Ingen prosjekter har gyldige koordinater.',
  },
  locations: {
    cz: 'Lokality',
    de: 'Standorte',
    en: 'Locations',
    sv: 'Platser',
    fi: 'Sijainnit',
    nb: 'Lokasjoner',
  },
  previousWeekLabel: {
    cz: 'Předchozí',
    de: 'Vorherige',
    en: 'Previous',
    sv: 'Föregående',
    fi: 'Edellinen',
    nb: 'Forrige',
  },
  previousNinetyDays: {
    cz: 'oproti předchozím 90 dnům',
    de: 'gegenüber den vorherigen 90 Tagen',
    en: 'vs previous 90 days',
    sv: 'mot föregående 90 dagar',
    fi: 'verrattuna edellisiin 90 päivään',
    nb: 'mot forrige 90 dager',
  },
  previousYearToDate: {
    cz: 'oproti stejnému období loni',
    de: 'gegenüber Vorjahr bis heute',
    en: 'vs previous year to date',
    sv: 'mot samma period föregående år',
    fi: 'verrattuna viime vuoden vastaavaan jaksoon',
    nb: 'mot samme periode i fjor',
  },
  sensorStageTrend: {
    cz: 'Senzory v instalačních a provozních projektech',
    de: 'Sensoren in Installations- und Betriebsprojekten',
    en: 'Sensors in installation and operative projects',
    sv: 'Sensorer i installations- och operativa projekt',
    fi: 'Anturit asennus- ja operatiivisissa projekteissa',
    nb: 'Sensorer i installasjons- og operative prosjekter',
  },
  projectStageTrend: {
    cz: 'Trend fáze projektu',
    de: 'Projektphasen-Trend',
    en: 'Project stage trend',
    sv: 'Projektfastrend',
    fi: 'Projektivaiheen trendi',
    nb: 'Prosjektfasetrend',
  },
  weeklyPortfolioSummary: {
    cz: 'Týdenní souhrn portfolia',
    de: 'Wöchentliche Portfolio-Zusammenfassung',
    en: 'Weekly portfolio summary',
    sv: 'Veckovis portföljsammanfattning',
    fi: 'Viikoittainen portfolion yhteenveto',
    nb: 'Ukentlig porteføljesammendrag',
  },
  weeklyPortfolioSummaryDescription: {
    cz: 'Souhrnný týdenní přehled senzorů a stavových změn napříč všemi projekty.',
    de: 'Aggregierte Wochenübersicht für Sensoren und Statusänderungen über alle Projekte.',
    en: 'Aggregated weekly sensor status and status transitions across all projects.',
    sv: 'Aggregerad veckovis vy för sensorstatus och statusövergångar i alla projekt.',
    fi: 'Koostettu viikkonäkymä anturien tiloista ja tilasiirtymistä kaikissa projekteissa.',
    nb: 'Aggregert ukentlig sensorstatus og statusoverganger på tvers av alle prosjekter.',
  },
  current: {
    cz: 'Aktuálně',
    de: 'Aktuell',
    en: 'Current',
    sv: 'Aktuell',
    fi: 'Nykyinen',
    nb: 'Nåværende',
  },
  sensorsInInstallationProjects: {
    cz: 'Senzory v instalačních projektech',
    de: 'Sensoren in Installationsprojekten',
    en: 'Sensors in installation projects',
    sv: 'Sensorer i installationsprojekt',
    fi: 'Anturit asennusprojekteissa',
    nb: 'Sensorer i installasjonsprosjekter',
  },
  sensorsInOperativeProjects: {
    cz: 'Senzory v provozních projektech',
    de: 'Sensoren in operativen Projekten',
    en: 'Sensors in operative projects',
    sv: 'Sensorer i operativa projekt',
    fi: 'Anturit operatiivisissa projekteissa',
    nb: 'Sensorer i operative prosjekter',
  },
  weeklySensorStatusChanges: {
    cz: 'Týdenní změny stavu senzorů',
    de: 'Wöchentliche Sensorstatusänderungen',
    en: 'Weekly sensor status changes',
    sv: 'Veckovisa sensorstatusändringar',
    fi: 'Viikoittaiset anturitilan muutokset',
    nb: 'Ukentlige sensorstatusendringer',
  },
  statusTransitions: {
    cz: 'Přechody stavů',
    de: 'Statusübergänge',
    en: 'Status transitions',
    sv: 'Statusövergångar',
    fi: 'Tilasiirtymät',
    nb: 'Statusoverganger',
  },
  projectsWithNewAlertSensors: {
    cz: 'Projekty s novými senzory v alarmu',
    de: 'Projekte mit neuen Sensoren im Alarm',
    en: 'Projects with new sensors in alert',
    sv: 'Projekt med nya sensorer i larm',
    fi: 'Projektit, joissa on uusia hälyttäviä antureita',
    nb: 'Prosjekter med nye sensorer i alarm',
  },
  projectsWithAlertSensors: {
    cz: 'Projekty se senzory v alarmu',
    de: 'Projekte mit Sensoren im Alarm',
    en: 'Projects with sensors in alert',
    sv: 'Projekt med sensorer i larm',
    fi: 'Projektit, joissa on hälyttäviä antureita',
    nb: 'Prosjekter med sensorer i alarm',
  },
  monitoringSortRecentActivity: {
    cz: 'Nejnovější aktivita',
    de: 'Neueste Aktivität',
    en: 'Most recent activity',
    sv: 'Senaste aktivitet',
    fi: 'Viimeisin aktiivisuus',
    nb: 'Nyeste aktivitet',
  },
  monitoringSortMostQueriesToday: {
    cz: 'Nejvíce dotazů dnes',
    de: 'Meiste Abfragen heute',
    en: 'Most queries today',
    sv: 'Flest frågor idag',
    fi: 'Eniten kyselyitä tänään',
    nb: 'Flest spørringer i dag',
  },
  monitoringSortHighestResponseTime: {
    cz: 'Nejvyšší responstid',
    de: 'Höchste Antwortzeit',
    en: 'Highest response time',
    sv: 'Högsta svarstid',
    fi: 'Korkein vasteaika',
    nb: 'Høyest responstid',
  },
  monitoringSortHighestAverageResponseTime: {
    cz: 'Nejvyšší průměrná responstid',
    de: 'Höchste durchschnittliche Antwortzeit',
    en: 'Highest average response time',
    sv: 'Högsta genomsnittliga svarstid',
    fi: 'Korkein keskimääräinen vasteaika',
    nb: 'Høyest gjennomsnittlig responstid',
  },
  adminAccessRequired: {
    cz: 'Je vyžadován přístup správce.',
    de: 'Administratorzugriff erforderlich.',
    en: 'Admin access required.',
    sv: 'Administratörsåtkomst krävs.',
    fi: 'Ylläpitäjän käyttöoikeus vaaditaan.',
    nb: 'Administrator-tilgang kreves.',
  },
  alarm: {
    cz: 'Poplach',
    de: 'Alarm',
    en: 'Alarm',
    sv: 'Alarm',
    fi: 'Hälytys',
    nb: 'Alarm',
  },
  alert: {
    cz: 'Upozornění',
    de: 'Alarm',
    en: 'Alert',
    sv: 'Varsel',
    fi: 'Hälytys',
    nb: 'Varsel',
  },
  alertChannels: {
    cz: 'Kanály upozornění',
    de: 'Benachrichtigungskanäle',
    en: 'Alert channels',
    sv: 'Varslingskanaler',
    fi: 'Hälytyskanavat',
    nb: 'Varslingskanaler',
  },
  alerts: {
    cz: 'Upozornění',
    de: 'Warnungen',
    en: 'Alerts',
    sv: 'Varsler',
    fi: 'Hälytykset',
    nb: 'Varsler',
  },
  all: {
    cz: 'Vše',
    de: 'Alle',
    en: 'All',
    sv: 'Alla',
    fi: 'Kaikki',
    nb: 'Alle',
  },
  allSensors: {
    cz: 'Všechny senzory',
    de: 'Alle Sensoren',
    en: 'All sensors',
    sv: 'Alla sensorer',
    fi: 'Kaikki anturit',
    nb: 'Alle sensorer',
  },
  anErrorOccured: {
    cz: 'Došlo k chybě',
    de: 'Ein Fehler ist aufgetreten',
    en: 'An error occurred',
    sv: 'Ett fel uppstod',
    fi: 'Punainen',
    nb: 'En feil oppstod',
  },
  learningCenter: {
    cz: 'Vzdělávací centrum',
    de: 'Lerncenter',
    en: 'Learning center',
    sv: 'Utbildningscenter',
    fi: 'Oppimiskeskus',
    nb: 'Læringssenter',
  },
  applyFilters: {
    cz: 'Použít filtry',
    de: 'Filter anwenden',
    en: 'Apply filters',
    sv: 'Använd filter',
    fi: 'Käytä suodattimia',
    nb: 'Bruk filtre',
  },
  aquasafe: {
    cz: 'Aquasafe',
    de: 'Aquasafe',
    en: 'Aquasafe',
    sv: 'Aquasafe',
    fi: 'Aquasafe',
    nb: 'Aquasafe',
  },
  archived: {
    cz: 'Archivováno',
    de: 'Archiviert',
    en: 'Archived',
    sv: 'Arkivert',
    fi: 'Arkistoitu',
    nb: 'Arkivert',
  },
  general: {
    cz: 'Obecné',
    de: 'Allgemein',
    en: 'General',
    sv: 'Allmänt',
    fi: 'Yleiset',
    nb: 'Generelt',
  },
  asBuilt: {
    cz: 'Jako-postavené',
    de: 'Als-gebaut',
    en: 'As-built',
    sv: 'Som-bygget',
    fi: 'Kuten rakennettu',
    nb: 'Som-bygget',
  },
  asphalt: {
    cz: 'Asfalt',
    de: 'Asphalt',
    en: 'Asphalt',
    sv: 'Asfalt',
    fi: 'Bitumi',
    nb: 'Asfalt',
  },
  at: {
    cz: 'v',
    de: 'bei',
    en: 'at',
    sv: 'kl',
    fi: 'klo',
    nb: 'kl',
  },
  atLeastOneInstallationPlanMustBeSelected: {
    cz: 'Musí být vybrán alespoň jeden plán instalace',
    de: 'Mindestens ein Installationsplan muss ausgewählt sein',
    en: 'At least one installation plan must be selected',
    sv: 'Minst en installationsplan måste väljas',
    fi: 'Vähintään yksi asennussuunnitelma on valittava.',
    nb: 'Minst én installasjonsplan må velges',
  },
  atLeastOneMustBeSelected: {
    cz: 'Musí být vybráno alespoň jedno',
    de: 'Mindestens eines muss ausgewählt werden',
    en: 'At least one must be selected',
    sv: 'Minst ett måste väljas',
    fi: 'Vähintään yksi on valittava.',
    nb: 'Minst ett må velges',
  },
  avgRelativeHumidityAndWater: {
    cz: 'Průměrná relativní vlhkost a vlhkost',
    de: 'Durchschnittliche relative Luftfeuchtigkeit und Wassersammlung',
    en: 'Average relative humidity and moisture',
    sv: 'Genomsnittlig relativ luftfuktighet och vattenskador',
    fi: 'Keskimääräinen suhteellinen kosteus ja vesikertymä (kosteus)',
    nb: 'Gjennomsnittlig relativ fuktighet og vannsamling',
  },
  back: {
    cz: 'Zpět',
    de: 'Zurück',
    en: 'Back',
    sv: 'Tillbaka',
    fi: 'Takaisin',
    nb: 'Tilbake',
  },
  blueRoof: {
    cz: 'Modrá střecha',
    de: 'Blaues Dach',
    en: 'Blue roof',
    sv: 'Blått tak',
    fi: 'Sininen katto',
    nb: 'Blått tak',
  },
  bracket: {
    cz: 'Bracket',
    de: 'Bracket',
    en: 'Bracket',
    sv: 'Slukvakt',
    fi: 'Bracket',
    nb: 'Slukvakt',
  },
  bracketInto: {
    cz: 'into® Bracket',
    de: 'into® Bracket',
    en: 'into® Bracket',
    sv: 'into® Bracket',
    fi: 'into® Bracket',
    nb: 'into® Bracket',
  },
  buildingOwner: {
    cz: 'Vlastník budovy',
    de: 'Gebäudeinhaber',
    en: 'Project owner',
    sv: 'Byggnadsägare',
    fi: 'Projektin omistaja',
    nb: 'Bygningseier',
  },
  buildingOwnerContactEmail: {
    cz: 'E-mail kontaktní osoby vlastníka budovy',
    de: 'E-Mail der Kontaktperson des Gebäudeinhabers',
    en: 'Project owner contact email',
    sv: 'Byggnadsägares e-postadress',
    fi: 'Projektin omistajan sähköposti',
    nb: 'Bygningseier kontakt e-post',
  },
  buildingOwnerInformation: {
    cz: 'Informace o vlastníkovi budovy',
    de: 'Gebäudeinhaberinformationen',
    en: 'Project owner information',
    sv: 'Byggnadsägarinformation',
    fi: 'Projektin omistajan tiedot',
    nb: 'Byggeierinformasjon',
  },
  by: {
    cz: 'od',
    de: 'von',
    en: 'by',
    sv: 'av',
    fi: 'tekijä',
    nb: 'av',
  },
  camera: {
    cz: 'Kamera',
    de: 'Kamera',
    en: 'Camera',
    sv: 'Kamera',
    fi: 'Kamera',
    nb: 'Kamera',
  },
  cancel: {
    cz: 'Zrušit',
    de: 'Abbrechen',
    en: 'Cancel',
    sv: 'Avbryt',
    fi: 'Peruuta',
    nb: 'Avbryt',
  },
  cannotDeleteInstallation: {
    cz: 'Nelze smazat instalaci',
    de: 'Installation kann nicht gelöscht werden',
    en: 'Cannot delete installation',
    sv: 'Kan inte ta bort installation',
    fi: 'Asennusta ei voi poistaa',
    nb: 'Kan ikke slette installasjon',
  },
  changeInstallation: {
    cz: 'Změnit instalaci',
    de: 'Installation ändern',
    en: 'Change installation',
    sv: 'Redigera installation',
    fi: 'Vaihda asennus',
    nb: 'Endre installasjon',
  },
  changeOrder: {
    cz: 'Změnit pořadí',
    de: 'Reihenfolge ändern',
    en: 'Change order',
    sv: 'Ändra ordning',
    fi: 'Vaihda järjestystä',
    nb: 'Endre rekkefølge',
  },
  changeWaterStatus: {
    cz: 'Změnit stav vody',
    de: 'Wasserstatus ändern',
    en: 'Change water status',
    sv: 'Ändra vattenstatus',
    fi: 'Muuta veden tilaa',
    nb: 'Endre vannstatus',
  },
  checkingReport: {
    cz: 'Kontroluji zprávu',
    de: 'Prüfe Bericht',
    en: 'Checking report',
    sv: 'Sjekker rapport',
    fi: 'Tarkistetaan raporttia',
    nb: 'Sjekker rapport',
  },
  continueAsDraft: {
    cz: 'Pokračovat jako koncept',
    de: 'Als Entwurf fortsetzen',
    en: 'Continue as draft',
    sv: 'Fortsätt som utkast',
    fi: 'Jatka luonnoksena',
    nb: 'Fortsett som utkast',
  },
  continueDraft: {
    cz: 'Pokračovat v konceptu',
    de: 'Entwurf fortsetzen',
    en: 'Continue draft',
    sv: 'Fortsätt utkast',
    fi: 'Jatka luonnosta',
    nb: 'Fortsett utkast',
  },
  checklists: {
    cz: 'Kontrolní seznamy',
    de: 'Checklisten',
    en: 'Checklists',
    sv: 'Checklistor',
    fi: 'Tarkistuslistat',
    nb: 'Sjekklister',
  },
  clear: {
    cz: 'Vyčistit',
    de: 'Löschen',
    en: 'Clear',
    sv: 'Töm',
    fi: 'Tyhjennä',
    nb: 'Tøm',
  },
  close: {
    cz: 'Zavřít',
    de: 'Schließen',
    en: 'Close',
    sv: 'Stäng',
    fi: 'Sulje',
    nb: 'Lukk',
  },
  closeWater: {
    cz: 'Zavřít vodu',
    de: 'Wasser schließen',
    en: 'Close water',
    sv: 'Stäng vatten',
    fi: 'Sulje vesi',
    nb: 'Lukke vann',
  },
  closeWaterConfirmation: {
    cz: 'Opravdu chcete zavřít vodu na tomto zařízení?',
    de: 'Möchten Sie das Wasser auf diesem Gerät wirklich schließen?',
    en: 'Are you sure you want to close water on this device?',
    sv: 'Är du säker på att du vill stänga vatten på den här enheten?',
    fi: 'Haluatko varmasti sulkea veden tästä laitteesta?',
    nb: 'Er du sikker på at du vil lukke vann på denne enheten?',
  },
  closed: {
    cz: 'Zavřeno',
    de: 'Geschlossen',
    en: 'Closed',
    sv: 'Stängd',
    fi: 'Suljettu',
    nb: 'Lukket',
  },
  code: {
    cz: 'Kód',
    de: 'Code',
    en: 'Code',
    sv: 'Kod',
    fi: 'Koodi',
    nb: 'Kode',
  },
  combinedWithClimate: {
    cz: 'Kombinováno s externími klimatickými daty - na základě dostupných meteorologických dat',
    de: 'Kombiniert mit externen Klimadaten - basierend auf verfügbaren Wetterdaten',
    en: 'Combined with external climate data - based on available weather data',
    sv: 'Kombination med externa klimadata - baserat på tillgänglig väderdata',
    fi: 'Yhdistetty ulkoisiin sääietoihin - perustuen saatavilla oleviin säätietoihin',
    nb: 'Kombinasjon med ytre klimadata - basert på tilgjengelig værdata',
  },
  count: {
    cz: 'Count',
    de: 'Count',
    en: 'Count',
    sv: 'Count',
    fi: 'Count',
    nb: 'Antall',
  },
  comment: {
    cz: 'Komentář',
    de: 'Kommentar',
    en: 'Comment',
    sv: 'Kommentar',
    fi: 'Kommentti',
    nb: 'Kommentar',
  },
  compactWoodenRoof: {
    cz: 'Kompaktní dřevěná střecha',
    de: 'Kompaktes Holzdach',
    en: 'Compact wooden roof',
    sv: 'Lätt tak',
    fi: 'Kevyt katto',
    nb: 'Lett tak',
  },
  companies: {
    cz: 'Společnosti',
    de: 'Einheiten',
    en: 'Companies',
    sv: 'Företag',
    fi: 'Yritykset',
    nb: 'Selskaper',
  },
  company: {
    cz: 'Společnost',
    de: 'Firma',
    en: 'Company',
    sv: 'Företag',
    fi: 'Yritys',
    nb: 'Selskap',
  },
  companyName: {
    cz: 'Název společnosti',
    de: 'Firmenname',
    en: 'Company name',
    sv: 'Firmanamn',
    fi: 'Yrityksen nimi',
    nb: 'Firmanavn',
  },
  companyStatusInactive: {
    cz: 'Neaktivní',
    de: 'Inaktiv',
    en: 'Inactive',
    sv: 'Inaktiv',
    fi: 'Inaktiivinen',
    nb: 'Inaktiv',
  },
  customer: {
    cz: 'Zákazník',
    de: 'Kunde',
    en: 'Customer',
    sv: 'Kund',
    fi: 'Asiakas',
    nb: 'Kunde',
  },
  default: {
    cz: 'Výchozí',
    de: 'Standard',
    en: 'Default',
    sv: 'Standard',
    fi: 'Oletus',
    nb: 'Standard',
  },
  concrete: {
    cz: 'Beton',
    de: 'Beton',
    en: 'Concrete',
    sv: 'Betong',
    fi: 'Betoni',
    nb: 'Betong',
  },
  concreteOverlay: {
    cz: 'Betonová vrstva',
    de: 'Betonüberzug',
    en: 'Concrete overlay',
    sv: 'Betongöverhänge',
    fi: 'Betonipeite',
    nb: 'Betongoverlegg',
  },
  conductiveUnderlay: {
    cz: 'Vodivá podložka',
    de: 'Leitfähige Unterlage',
    en: 'Conductive Underlay',
    sv: 'Ledande underlag',
    fi: 'Johtava aluskerros',
    nb: 'Elektrisk ledende underlag',
  },
  configuration: {
    cz: 'Konfigurace',
    de: 'Konfiguration',
    en: 'Configuration',
    sv: 'Konfiguration',
    fi: 'Konfiguraatio',
    nb: 'Konfigurasjon',
  },
  confirm: {
    cz: 'Potvrdit',
    de: 'Bestätigen',
    en: 'Confirm',
    sv: 'Bekräfta',
    fi: 'Vahvista',
    nb: 'Bekreft',
  },
  unsavedChanges: {
    cz: 'Neuložené změny',
    de: 'Ungespeicherte Änderungen',
    en: 'Unsaved changes',
    sv: 'Osparade ändringar',
    fi: 'Tallentamattomat muutokset',
    nb: 'Ulagrede endringer',
  },
  discardChanges: {
    cz: 'Zahodit změny',
    de: 'Änderungen verwerfen',
    en: 'Discard changes',
    sv: 'Förkasta ändringar',
    fi: 'Hylkää muutokset',
    nb: 'Forkast endringer',
  },
  saveChangesQuestion: {
    cz: 'Uložit změny?',
    de: 'Änderungen speichern?',
    en: 'Save changes?',
    sv: 'Spara ändringar?',
    fi: 'Tallennetaanko muutokset?',
    nb: 'Lagre endringer?',
  },
  confirmDelete: {
    cz: 'Opravdu chcete smazat?',
    de: 'Möchten Sie wirklich löschen?',
    en: 'Are you sure you want to delete?',
    sv: 'Är du säker på att du vill ta bort?',
    fi: 'Haluatko varmasti poistaa?',
    nb: 'Er du sikker på at du vil slette?',
  },
  confirmDeleteInstallation: {
    cz: 'Opravdu chcete smazat tuto instalaci?',
    de: 'Möchten Sie diese Installation wirklich löschen?',
    en: 'Are you sure you want to delete this installation?',
    sv: 'Är du säker på att du vill ta bort den här installationen?',
    fi: 'Haluatko varmasti poistaa tämän asennuksen?',
    nb: 'Er du sikker på at du vil slette denne installasjonen?',
  },
  confirmDeleteInstallationPlan: {
    cz: 'Opravdu chcete smazat tento plán instalace?',
    de: 'Möchten Sie diesen Installationsplan wirklich löschen?',
    en: 'Are you sure you want to delete this installation plan?',
    sv: 'Är du säker på att du vill ta bort den här installationsplanen?',
    fi: 'Haluatko varmasti poistaa tämän asennussuunnitelman?',
    nb: 'Er du sikker på at du vil slette denne installasjonsplanen?',
  },
  confirmDeleteReport: {
    cz: 'Opravdu chcete smazat tuto zprávu?',
    de: 'Möchten Sie diesen Bericht wirklich löschen?',
    en: 'Are you sure you want to delete this report?',
    sv: 'Är du säker på att du vill ta bort den här rapporten?',
    fi: 'Haluatko varmasti poistaa tämän raportin?',
    nb: 'Er du sikker på at du vil slette denne rapporten?',
  },
  confirmDeleteSensor: {
    cz: 'Opravdu chcete smazat senzor {{localId}}?',
    de: 'Möchten Sie den Sensor {{localId}} wirklich löschen?',
    en: 'Are you sure you want to delete sensor {{localId}}?',
    sv: 'Är du säker på att du vill ta bort sensor {{localId}}?',
    fi: 'Haluatko varmasti poistaa anturin {{localId}}?',
    nb: 'Er du sikker på at du vil slette sensor {{localId}}?',
  },
  confirmDeleteUploadedImage: {
    cz: 'Opravdu chcete smazat tento nahraný obrázek?',
    de: 'Möchten Sie dieses hochgeladene Bild wirklich löschen?',
    en: 'Are you sure you want to delete this uploaded image?',
    sv: 'Är du säker på att du vill ta bort denna uppladdade bild?',
    fi: 'Haluatko varmasti poistaa tämän ladatun kuvan?',
    nb: 'Er du sikker på at du vil slette dette opplastede bildet?',
  },
  confirmDeleteUser: {
    cz: 'Opravdu chcete smazat uživatele {{- name}}?',
    de: 'Möchten Sie den Benutzer {{- name}} wirklich löschen?',
    en: 'Are you sure you want to delete user {{- name}}?',
    sv: 'Är du säker på att du vill ta bort användaren {{- name}}?',
    fi: 'Haluatko varmasti poistaa käyttäjän {{- name}}?',
    nb: 'Er du sikker på at du vil slette brukeren {{- name}}?',
  },
  confirmDeleteInvitation: {
    cz: 'Opravdu chcete smazat toto pozvání?',
    de: 'Möchten Sie diese Einladung wirklich löschen?',
    en: 'Are you sure you want to delete this invitation?',
    sv: 'Är du säker på att du vill ta bort den här inbjudan?',
    fi: 'Haluatko varmasti poistaa tämän kutsun?',
    nb: 'Er du sikker på at du vil slette denne invitasjonen?',
  },
  confirmRemove: {
    cz: 'Opravdu chcete odstranit?',
    de: 'Möchten Sie wirklich entfernen?',
    en: 'Are you sure you want to remove?',
    sv: 'Är du säker på att du vill ta bort?',
    fi: 'Siirrä',
    nb: 'Er du sikker på at du vil fjerne?',
  },
  confirmRemoveDistributorUser: {
    cz: 'Opravdu chcete odstranit {{- name}} jako uživatele distributora?',
    de: 'Möchten Sie {{- name}} wirklich als Distributor-Benutzer entfernen?',
    en: 'Are you sure you want to remove {{- name}} as a distributor user?',
    sv: 'Är du säker på att du vill ta bort {{- name}} som distributöranvändare?',
    fi: 'Haluatko varmasti poistaa {{- name}} jakelijakäyttäjänä?',
    nb: 'Er du sikker på at du vil fjerne {{- name}} som distributørbrukeren?',
  },
  confirmRemoveUser: {
    cz: 'Opravdu chcete odstranit tohoto uživatele z projektu?',
    de: 'Möchten Sie diesen Benutzer wirklich aus dem Projekt entfernen?',
    en: 'Are you sure you want to remove this user from the project?',
    sv: 'Är du säker på att du vill ta bort den här användaren från projektet?',
    fi: 'Haluatko varmasti poistaa tämän käyttäjän projektista?',
    nb: 'Er du sikker på at du vil fjerne denne brukeren fra prosjektet?',
  },
  contactInfo: {
    cz: 'Kontaktní informace',
    de: 'Kontaktinformationen',
    en: 'Contact information',
    sv: 'Kontaktinformation',
    fi: 'Yhteystiedot',
    nb: 'Kontaktinformasjon',
  },
  contextImg: {
    cz: 'Obrázek kontextu',
    de: 'Kontextbild',
    en: 'Context image',
    sv: 'Kontextbild',
    fi: 'Yleiskuva',
    nb: 'Kontekstbilde',
  },
  nextImg: {
    cz: 'Další obrázek',
    de: 'Nächstes Bild',
    en: 'Next image',
    sv: 'Nästa bild',
    fi: 'Seuraava kuva',
    nb: 'Neste bilde',
  },
  noteSerialNumbers: {
    cz: 'Poznámka: Pokud plánujete zařízení znovu použít, zapište si jejich sériová čísla před odstraněním.',
    de: 'Hinweis: Wenn Sie die Geräte später verwenden möchten, notieren Sie sich deren Seriennummern, bevor Sie sie entfernen.',
    en: 'Note: If you plan to use the devices later, make note of their serial numbers before removing them.',
    sv: 'Obs: Om du planerar att använda enheterna senare, notera serienumren innan du tar bort dem.',
    fi: 'Huomaa: Jos aiot käyttää laitteita myöhemmin, kirjoita ylös niiden sarjanumerot ennen niiden poistamista.',
    nb: 'Merk: Hvis du planlegger å bruke enhetene senere, noter serienumrene før du fjerner dem.',
  },
  previousImg: {
    cz: 'Předchozí obrázek',
    de: 'Vorheriges Bild',
    en: 'Previous image',
    sv: 'Föregående bild',
    fi: 'Edellinen kuva',
    nb: 'Forrige bilde',
  },
  contextImgHelperText: {
    cz: 'Kontextový obrázek je obvykle obrázek celého místa, tj. 3D obrázek budovy nebo Google Street View.',
    de: 'Kontextbild ist normalerweise ein Bild des gesamten Standorts, d.h. 3D-Bild des Gebäudekomplexes oder Google Street View.',
    en: 'Context image is usually an image of the whole site, i.e. 3D image of project complex or Google Street View.',
    sv: 'Kontextbild är vanligtvis en bild av hela området, dvs. en 3D-bild av byggnadskomplexet eller Google Street View.',
    fi: 'Yleiskuva on yleensä kuva koko alueesta, esimerkiksi projektikokonaisuuden 3D-kuva tai Google Street View.',
    nb: 'Kontekstbilde er vanligvis et bilde av hele området, dvs. 3D-bilde av bygningskompleks eller Google Street View.',
  },
  conventionalCompactRoof: {
    cz: 'Klasická kompaktní střecha',
    de: 'Konventionelles Kompaktdach',
    en: 'Conventional compact roof',
    sv: 'Omvänt kompakttak',
    fi: 'Perinteinen tasakatto',
    nb: 'Rettvendt kompakttak',
  },
  correlationAnalysisrelativeHumidityAndMoisture: {
    cz: 'Korelační analýza relativní vlhkosti a vlhkosti',
    de: 'Korrelationsanalyse von relativer Luftfeuchtigkeit und Feuchtigkeit',
    en: 'Correlation analysis of relative humidity and moisture',
    sv: 'Korrelationsanalys av relativ luftfuktighet och fuktighetsmätning',
    fi: 'Suhteellisen kosteuden ja kosteuden korrelaatioanalyysi',
    nb: 'Korrelasjonsanalyse av relativ fuktighet og fukt',
  },
  createReport: {
    cz: 'Vytvořit zprávu',
    de: 'Bericht erstellen',
    en: 'Create report',
    sv: 'Skapa rapport',
    fi: 'Luo raportti',
    nb: 'Opprett rapport',
  },
  createdAt: {
    cz: 'Vytvořeno',
    de: 'Erstellt',
    en: 'Created',
    sv: 'Skapat',
    fi: 'Luotu',
    nb: 'Opprettet',
  },
  createdTime: {
    cz: 'Vytvořeno: {{ date }}',
    de: 'Erstellt: {{ date }}',
    en: 'Created: {{ date }}',
    sv: 'Skapat: {{ date }}',
    fi: 'Ei: {{ date }}',
    nb: 'Opprettet: {{ date }}',
  },
  criticalMoistureDevelopment: {
    cz: 'Kritický vývoj vlhkosti',
    de: 'Kritische Feuchtigkeitsentwicklung',
    en: 'Critical moisture development',
    sv: 'Kritisk fuktighetsutveckling',
    fi: 'Kriittinen kosteuden kehittyminen',
    nb: 'Kritisk fuktutvikling',
  },
  crmReference: {
    cz: 'CRM systémová reference',
    de: 'CRM-System-Referenz',
    en: 'CRM system reference',
    sv: 'CRM-systemreferens',
    fi: 'CRM-järjestelmän viite',
    nb: 'CRM systemreferanse',
  },
  ctm: {
    cz: 'CTM',
    de: 'CTM',
    en: 'CTM',
    sv: 'CTM',
    fi: 'CTM',
    nb: 'CTM',
  },
  currentDistributors: {
    cz: 'Aktuální distributoři',
    de: 'Aktuelle Distributoren',
    en: 'Current distributors',
    sv: 'Nuvarande distributörer',
    fi: 'Nykyiset jakelijat',
    nb: 'Nåværende distributører',
  },
  customTimeRange: {
    cz: 'Vlastní (max. 1 rok)',
    de: 'Benutzerdefiniert (max. 1 Jahr)',
    en: 'Custom (max one year)',
    sv: 'Anpassad (max 1 år)',
    fi: 'Mukautettu (enintään 1 vuosi)',
    nb: 'Tilpasset (maks 1 år)',
  },
  custom: {
    cz: 'Vlastní',
    de: 'Benutzerdefiniert',
    en: 'Custom',
    sv: 'Anpassad',
    fi: 'Mukautettu',
    nb: 'Egendefinert',
  },
  dark: {
    cz: 'Tmavá',
    de: 'Dunkel',
    en: 'Dark',
    sv: 'Mörk',
    fi: 'Tumma',
    nb: 'Mørk',
  },
  dashboard: {
    cz: 'Řídicí panel',
    de: 'Armaturenbrett',
    en: 'Dashboard',
    sv: 'Dashbord',
    fi: 'Kojelauta',
    nb: 'Dashbord',
  },
  date: {
    cz: 'Datum',
    de: 'Datum',
    en: 'Date',
    sv: 'Datum',
    fi: 'Päivämäärä',
    nb: 'Dato',
  },
  daysAgo: {
    cz: 'den(ů) zpět',
    de: 'Tag(e) her',
    en: 'day(s) ago',
    sv: 'dag(ar) sedan',
    fi: 'päivä(ä) sitten',
    nb: 'dag(er) siden',
  },
  deck: {
    cz: 'Paluba',
    de: 'Deck',
    en: 'Deck',
    sv: 'Däck',
    fi: 'Kansi',
    nb: 'Dekke',
  },
  definitions: {
    cz: 'Definice',
    de: 'Definitionen',
    en: 'Definitions',
    sv: 'Definitioner',
    fi: 'Määritelmät',
    nb: 'Definisjoner',
  },
  delete: {
    cz: 'Odstranit',
    de: 'Löschen',
    en: 'Delete',
    sv: 'Ta bort',
    fi: 'Poista',
    nb: 'Slett',
  },
  deleteInstallation: {
    cz: 'Odstranit instalační',
    de: 'Installation löschen',
    en: 'Delete installation',
    sv: 'Ta bort installation',
    fi: 'Poista asennus',
    nb: 'Slett installasjon',
  },
  deleteReport: {
    cz: 'Smazat zprávu',
    de: 'Bericht löschen',
    en: 'Delete report',
    sv: 'Ta bort rapport',
    fi: 'Poista raportti',
    nb: 'Slett rapport',
  },
  deleteSensor: {
    cz: 'Odstranit senzor',
    de: 'Sensor löschen',
    en: 'Delete sensor',
    sv: 'Ta bort sensor',
    fi: 'Poista anturi',
    nb: 'Slett sensor',
  },
  deleteGateway: {
    cz: 'Odstranit bránu',
    de: 'Gateway löschen',
    en: 'Delete gateway',
    sv: 'Ta bort gateway',
    fi: 'Poista portti',
    nb: 'Slett gateway',
  },
  deleteUser: {
    cz: 'Smazat uživatele',
    de: 'Benutzer löschen',
    en: 'Delete user',
    sv: 'Ta bort användare',
    fi: 'Poista käyttäjä',
    nb: 'Slett bruker',
  },
  demo: {
    cz: 'Demo',
    de: 'Demo',
    en: 'Demo',
    sv: 'Demo',
    fi: 'Demo',
    nb: 'Demo',
  },
  demoProject: {
    cz: 'Demo projekt',
    de: 'Demo Projekt',
    en: 'Demo project',
    sv: 'Demo projekt',
    fi: 'Demoprojekti',
    nb: 'Demo prosjekt',
  },
  device: {
    cz: 'Zařízení',
    de: 'Gerät',
    en: 'Device',
    sv: 'Enhet',
    fi: 'Laite',
    nb: 'Enhet',
  },
  deviceType: {
    cz: 'Typ zařízení',
    de: 'Gerätetyp',
    en: 'Device type',
    sv: 'Enhetstyp',
    fi: 'Laitetyyppi',
    nb: 'Enhetstype',
  },
  devices: {
    cz: 'Zařízení',
    de: 'Geräte',
    en: 'Devices',
    sv: 'Enheter',
    fi: 'Laitteet',
    nb: 'Enheter',
  },
  distributor: {
    cz: 'Distributor',
    de: 'Distributor',
    en: 'Distributor',
    sv: 'Distributör',
    fi: 'Jakelija',
    nb: 'Distributør',
  },
  distributorUsers: {
    cz: 'Uživatelé distributora',
    de: 'Distributor-Benutzer',
    en: 'Distributor users',
    sv: 'Distributöranvändare',
    fi: 'Jakelijakäyttäjät',
    nb: 'Distributørbrukere',
  },
  distributorWithNameAlreadyExist: {
    cz: 'Distributor s tímto názvem již existuje',
    de: 'Distributor mit diesem Namen existiert bereits',
    en: 'Distributor with this name already exists',
    sv: 'Distributör med detta namn finns redan',
    fi: 'Jakelija tällä nimellä on jo olemassa',
    nb: 'Distributør med dette navnet eksisterer allerede',
  },
  distributors: {
    cz: 'Distributoři',
    de: 'Distributoren',
    en: 'Distributors',
    sv: 'Distributörer',
    fi: 'Jakelijat',
    nb: 'Distributører',
  },
  documentation: {
    cz: 'Dokumentace',
    de: 'Dokumentation',
    en: 'Documentation',
    sv: 'Dokumentation',
    fi: 'Dokumentaatio',
    nb: 'Dokumentasjon',
  },
  download: {
    cz: 'Stáhnout',
    de: 'Herunterladen',
    en: 'Download',
    sv: 'Ladda ner',
    fi: 'Lataa',
    nb: 'Last ned',
  },
  downloadReport: {
    cz: 'Stáhnout zprávu',
    de: 'Bericht herunterladen',
    en: 'Download report',
    sv: 'Ladda ner rapport',
    fi: 'Lataa raportti',
    nb: 'Last ned rapport',
  },
  duoCompactRoof: {
    cz: 'Duo kompaktní střecha',
    de: 'Duo Kompaktdach',
    en: 'Duo compact roof',
    sv: 'Duo kompakttak',
    fi: 'Duo-kompakti katto',
    nb: 'Duo kompakttak',
  },
  edit: {
    cz: 'Upravit',
    de: 'Bearbeiten',
    en: 'Edit',
    sv: 'Redigera',
    fi: 'Muokkaa',
    nb: 'Rediger',
  },
  editAccess: {
    cz: 'Upravit přístup',
    de: 'Zugriff bearbeiten',
    en: 'Edit access',
    sv: 'Redigera åtkomst',
    fi: 'Muokkaa käyttöoikeuksia',
    nb: 'Rediger tilgang',
  },
  editAccessNotAvailable: {
    cz: 'Přístup tohoto uživatele nelze změnit. Projekt musí mít alespoň jednoho správce a jednoho distributora.',
    de: 'Der Zugriff dieses Benutzers kann nicht geändert werden. Das Projekt muss mindestens einen Administrator und einen Distributor haben.',
    en: "This user's access cannot be changed. The project must have at least one administrator and one distributor.",
    sv: 'Den här användarens åtkomst kan inte ändras. Projektet måste ha minst én administrator och én distributör.',
    fi: 'Tämän käyttäjän käyttöoikeutta ei voi muuttaa. Projektissa on oltava vähintään yksi ylläpitäjä ja yksi jakelija.',
    nb: 'Denne brukerens tilgang kan ikke endres. Prosjektet må ha minst én administrator og én distributør.',
  },
  editCompany: {
    cz: 'Upravit společnost',
    de: 'Firma bearbeiten',
    en: 'Edit company',
    sv: 'Redigera företag',
    fi: 'Muokkaa yritystä',
    nb: 'Rediger selskap',
  },
  editDevice: {
    cz: 'Upravit zařízení',
    de: 'Gerät bearbeiten',
    en: 'Edit device',
    sv: 'Redigera enhet',
    fi: 'Muokkaa laitetta',
    nb: 'Rediger enhet',
  },
  editInstallation: {
    cz: 'Změnit instalaci',
    de: 'Installation ändern',
    en: 'Edit installation',
    sv: 'Ändra installation',
    fi: 'Muokkaa asennusta',
    nb: 'Endre installasjon',
  },
  editProject: {
    cz: 'Upravit projekt',
    de: 'Projekt bearbeiten',
    en: 'Edit project',
    sv: 'Redigera projekt',
    fi: 'Muokkaa projektia',
    nb: 'Rediger prosjekt',
  },
  editUser: {
    cz: 'Upravit uživatele',
    de: 'Benutzer bearbeiten',
    en: 'Edit user',
    sv: 'Redigera användare',
    fi: 'Muokkaa käyttäjää',
    nb: 'Rediger bruker',
  },
  email: {
    cz: 'E-mail',
    de: 'E-Mail',
    en: 'Email',
    sv: 'E-post',
    fi: 'Sähköposti',
    nb: 'E-post',
  },
  endDate: {
    cz: 'Koncové datum',
    de: 'Enddatum',
    en: 'End date',
    sv: 'Sluttdato',
    fi: 'Päättymispäivä',
    nb: 'Sluttdato',
  },
  enforcedMembrane: {
    cz: 'Vynucená membrána',
    de: 'Erzwungene Membran',
    en: 'Enforced Membrane',
    sv: 'Förstärkt membran',
    fi: 'Vahvistettu kermi',
    nb: 'Forsterket membran',
  },
  enforcedMembraneAluminium: {
    cz: 'Vynucená membrána (hliník)',
    de: 'Erzwungene Membran (Aluminium)',
    en: 'Enforced Membrane (aluminium)',
    sv: 'Förstärkt membran (aluminium)',
    fi: 'Vahvistettu kermi (alumiini)',
    nb: 'Forsterket membran (aluminium)',
  },
  error: {
    cz: 'Upozornění',
    de: 'Alarm',
    en: 'Alert',
    sv: 'Alarm',
    fi: 'Hälytys',
    nb: 'Alarm',
  },
  errorMessage: {
    cz: 'Chyba',
    de: 'Fehler',
    en: 'Error',
    sv: 'Fel',
    fi: 'Virhe',
    nb: 'Feil',
  },
  exactCharacters: {
    cz: '{{ field }} musí být přesně {{ exact }} znaků',
    de: '{{ field }} muss genau {{ exact }} Zeichen lang sein',
    en: '{{ field }} must be exactly {{ exact }} characters',
    sv: '{{ field }} måste vara exakt {{ exact }} tecken',
    fi: '{{ field }} on oltava täsmälleen {{ exact }} merkkiä',
    nb: '{{ field }} må være nøyaktig {{ exact }} tegn',
  },
  excellent: {
    cz: 'Vynikající',
    de: 'Ausgezeichnet',
    en: 'Excellent',
    sv: 'Utmerket',
    fi: 'Erinomainen',
    nb: 'Utmerket',
  },
  fair: {
    cz: 'Uspokojivé',
    de: 'Befriedigend',
    en: 'Fair',
    sv: 'Rimlig',
    fi: 'Kohtalainen',
    nb: 'Rimelig',
  },
  fdv: {
    cz: 'Operations and Maintenance Manual (OMM)',
    de: 'Operations and Maintenance Manual (OMM)',
    en: 'Operations and Maintenance Manual (OMM)',
    sv: 'Förvaltning, Drift och Underhåll (FDV)',
    fi: 'Käyttö- ja ylläpito-ohje (OMM)',
    nb: 'Forvaltning, Drift og Vedlikehold (FDV)',
  },
  fieldInvalid: {
    cz: '{{field}} je neplatné',
    de: '{{field}} ist ungültig',
    en: '{{field}} is invalid',
    sv: '{{field}} är ogiltigt',
    fi: '{{field}} on virheellinen',
    nb: '{{field}} er ugyldig',
  },
  fieldMustBeAfter: {
    cz: '{{ field }} musí být po {{ after }}',
    de: '{{ field }} muss nach {{ after }} liegen',
    en: '{{ field }} must be after {{ after }}',
    sv: '{{ field }} måste vara efter {{ after }}',
    fi: '{{ field }} on oltava {{ after }} jälkeen',
    nb: '{{ field }} må være etter {{ after }}',
  },
  fieldMustBeBefore: {
    cz: '{{ field }} musí být před {{ before }}',
    de: '{{ field }} muss vor {{ before }} liegen',
    en: '{{ field }} must be before {{ before }}',
    sv: '{{ field }} måste vara före {{ before }}',
    fi: '{{ field }} on oltava ennen {{ before }}',
    nb: '{{ field }} må være før {{ before }}',
  },
  fieldRequired: {
    cz: '{{ field }} je povinné pole',
    de: '{{ field }} ist ein Pflichtfeld',
    en: '{{ field }} is a required field',
    sv: '{{ field }} är ett obligatoriskt fält',
    fi: '{{ field }} on pakollinen kenttä',
    nb: '{{ field }} er et påkrevd felt',
  },
  fileInputActionLabel: {
    cz: 'Vybrat soubor',
    de: 'Datei auswählen',
    en: 'Select file',
    sv: 'Välj fil',
    fi: 'Valitse tiedosto',
    nb: 'Velg fil',
  },
  fileInputActionLabelMultiple: {
    cz: 'Vybrat soubory',
    de: 'Dateien auswählen',
    en: 'Select files',
    sv: 'Välj filer',
    fi: 'Valitse tiedostot',
    nb: 'Velg filer',
  },
  fileSize: {
    cz: 'Velikost souboru',
    de: 'Dateigröße',
    en: 'File size',
    sv: 'Filstorlek',
    fi: 'Tiedostokoko',
    nb: 'Filstørrelse',
  },
  fileType: {
    cz: 'Typ souboru',
    de: 'Dateityp',
    en: 'File type',
    sv: 'Filtyp',
    fi: 'Tiedostotyyppi',
    nb: 'Filtype',
  },
  filename: {
    cz: 'Název souboru',
    de: 'Dateiname',
    en: 'Filename',
    sv: 'Filnamn',
    fi: 'Nimi',
    nb: 'Filnavn',
  },
  files: {
    cz: 'Soubory',
    de: 'Dateien',
    en: 'Files',
    sv: 'Filer',
    fi: 'Tiedostot',
    nb: 'Filer',
  },
  fire: {
    cz: 'Oheň',
    de: 'Feuer',
    en: 'Fire',
    sv: 'Brand',
    fi: 'Palo',
    nb: 'Brann',
  },
  firstName: {
    cz: 'Jméno',
    de: 'Vorname',
    en: 'First name',
    sv: 'Förnamn',
    fi: 'Etunimi',
    nb: 'Fornavn',
  },
  flammable: {
    cz: 'Hořlavý',
    de: 'Brennbar',
    en: 'Flammable',
    sv: 'Brännbart',
    fi: 'Syttyvä',
    nb: 'Brennbart',
  },
  foil: {
    cz: 'Fólie / PVC',
    de: 'Folie / PVC',
    en: 'Foil / PVC',
    sv: 'Folie / PVC',
    fi: 'PVC',
    nb: 'Folie / PVC',
  },
  freeze: {
    cz: 'Zmrazit',
    de: 'Einfrieren',
    en: 'Freeze',
    sv: 'Fryse',
    fi: 'Jäädytä',
    nb: 'Fryse',
  },
  from: {
    cz: 'Od',
    de: 'Von',
    en: 'From',
    sv: 'Från',
    fi: 'Alkaen',
    nb: 'Fra',
  },
  gateway: {
    cz: 'Brána',
    de: 'Gateway',
    en: 'Gateway',
    sv: 'Gateway',
    fi: 'Reititin',
    nb: 'Gateway',
  },
  gatewayPro: {
    cz: 'Gateway Pro',
    de: 'Gateway Pro',
    en: 'Gateway Pro',
    sv: 'Gateway Pro',
    fi: 'Gateway Pro',
    nb: 'Gateway Pro',
  },
  ghostBusting: {
    cz: 'Lov duchů',
    de: 'Geisterjagd',
    en: 'Ghost busting',
    sv: 'Spökjakt',
    fi: 'Aavejahti',
    nb: 'Spøkelsesjakt',
  },
  ghostBustingExcludedImportCount: {
    cz: 'Lov duchů vyloučí z tohoto importu {{count}} importovaných zařízení.',
    de: 'Die Geisterjagd schließt {{count}} importierte Geräte von diesem Import aus.',
    en: 'Ghost busting will exclude {{count}} imported devices from this import.',
    sv: 'Spökjakten kommer att utesluta {{count}} importerade enheter från denna import.',
    fi: 'Aavejahti jättää {{count}} tuotua laitetta pois tästä tuonnista.',
    nb: 'Spøkelsesjakten vil utelate {{count}} importerte enheter fra denne importen.',
  },
  ghostBustingExisting: {
    cz: 'Již plánováno',
    de: 'Bereits geplant',
    en: 'Existing planned',
    sv: 'Redan planerad',
    fi: 'Jo suunniteltu',
    nb: 'Planlagt fra før',
  },
  ghostBustingFindings: {
    cz: 'Nálezy duchů',
    de: 'Geisterfunde',
    en: 'Ghost findings',
    sv: 'Spökfynd',
    fi: 'Aavelöydökset',
    nb: 'Spøkelsesfunn',
  },
  ghostBustingExactMatch: {
    cz: 'Přesná shoda',
    de: 'Exakte Übereinstimmung',
    en: 'Exact match',
    sv: 'Exakt träff',
    fi: 'Täsmälleen sama',
    nb: 'Eksakt treff',
  },
  ghostBustingGroupLabels: {
    cz: 'Skupina duchů {{labels}}',
    de: 'Geistergruppe {{labels}}',
    en: 'Ghost group {{labels}}',
    sv: 'Spökgrupp {{labels}}',
    fi: 'Aaveryhmä {{labels}}',
    nb: 'Spøkelsesgruppe {{labels}}',
  },
  ghostBustingImported: {
    cz: 'Importováno',
    de: 'Importiert',
    en: 'Imported',
    sv: 'Importerad',
    fi: 'Tuotu',
    nb: 'Importert',
  },
  ghostBustingImportSummary: {
    cz: 'Lov duchů našel {{groupCount}} překrývajících se umístění zahrnujících {{importCount}} importovaných zařízení a {{existingCount}} již plánovaných zařízení.',
    de: 'Die Geisterjagd hat {{groupCount}} überlappende Positionen gefunden, mit {{importCount}} importierten Geräten und {{existingCount}} bereits geplanten Geräten.',
    en: 'Ghost busting found {{groupCount}} overlapping locations involving {{importCount}} imported devices and {{existingCount}} existing planned devices.',
    sv: 'Spökjakten hittade {{groupCount}} överlappande placeringar med {{importCount}} importerade enheter och {{existingCount}} redan planerade enheter.',
    fi: 'Aavejahti löysi {{groupCount}} päällekkäistä sijaintia, joissa on {{importCount}} tuotua laitetta ja {{existingCount}} jo suunniteltua laitetta.',
    nb: 'Spøkelsesjakten fant {{groupCount}} overlappende plasseringer som involverer {{importCount}} importerte enheter og {{existingCount}} planlagte enheter fra før.',
  },
  ghostBustingNoGhosts: {
    cz: 'Všechny duchy se podařilo zlikvidovat!',
    de: 'Alle Geister beseitigt!',
    en: 'All ghosts busted!',
    sv: 'Alla spöken är borta!',
    fi: 'Kaikki aaveet häädetty!',
    nb: 'Alle spøkelser er jaget bort!',
  },
  ghostBustingPlannedSummary: {
    cz: 'Lov duchů našel {{groupCount}} překrývajících se umístění zahrnujících {{deviceCount}} plánovaných zařízení.',
    de: 'Die Geisterjagd hat {{groupCount}} überlappende Positionen mit {{deviceCount}} geplanten Geräten gefunden.',
    en: 'Ghost busting found {{groupCount}} overlapping locations involving {{deviceCount}} planned devices.',
    sv: 'Spökjakten hittade {{groupCount}} överlappande placeringar med {{deviceCount}} planerade enheter.',
    fi: 'Aavejahti löysi {{groupCount}} päällekkäistä sijaintia, joissa on {{deviceCount}} suunniteltua laitetta.',
    nb: 'Spøkelsesjakten fant {{groupCount}} overlappende plasseringer som involverer {{deviceCount}} planlagte enheter.',
  },
  ghostBustingShowOnMap: {
    cz: 'Zobrazit na mapě',
    de: 'Auf Karte zeigen',
    en: 'Show on map',
    sv: 'Visa på kartan',
    fi: 'Näytä kartalla',
    nb: 'Vis på kart',
  },
  ghostBustingWithinTolerance: {
    cz: 'Blízká shoda',
    de: 'Nahe Übereinstimmung',
    en: 'Close match',
    sv: 'Nära träff',
    fi: 'Lähellä oleva osuma',
    nb: 'Nært treff',
  },
  ghostBustingSkipImportGhosts: {
    cz: 'Přeskočit importovaná ghost zařízení',
    de: 'Importierte Ghost-Geräte überspringen',
    en: 'Skip imported ghost devices',
    sv: 'Hoppa över importerade ghost-enheter',
    fi: 'Ohita tuodut aavelaitteet',
    nb: 'Hopp over importerte ghost-enheter',
  },
  gatewayCount: {
    cz: 'Počet bran',
    de: 'Gateway-Anzahl',
    en: 'Gateway count',
    sv: 'Gateway-antal',
    fi: 'Reitittimien määrä',
    nb: 'Gateway-antall',
  },
  gatewayId: {
    cz: 'ID brány',
    de: 'Gateway ID',
    en: 'Gateway ID',
    sv: 'Gateway ID',
    fi: 'Reitittimen tunnus',
    nb: 'Gateway ID',
  },
  gatewayInto: {
    cz: 'into® Gateway',
    de: 'into® Gateway',
    en: 'into® Gateway',
    sv: 'into® Gateway',
    fi: 'into® Gateway',
    nb: 'into® Gateway',
  },
  gatewayProInto: {
    cz: 'into® Gateway Pro',
    de: 'into® Gateway Pro',
    en: 'into® Gateway Pro',
    sv: 'into® Gateway Pro',
    fi: 'into® Gateway Pro',
    nb: 'into® Gateway Pro',
  },
  gatewayOffPower: {
    cz: 'Brána nemá napájení',
    de: 'Gateway hat keine Stromversorgung',
    en: 'Gateway off power',
    sv: 'Gateway saknar ström',
    fi: 'Reititin ei saa virtaa',
    nb: 'Gateway mangler strøm',
  },
  gatewayOffPowerDescription: {
    cz: 'Notifikace, když brána ztratí napájení',
    de: 'Benachrichtigung, wenn das Gateway die Stromversorgung verliert',
    en: 'Notification when gateway loses power',
    sv: 'Varning när gateway förlorar ström',
    fi: 'Ilmoitus, kun reititin menettää virran',
    nb: 'Varsel når gateway mister strøm',
  },
  gateways: {
    cz: 'Brány',
    de: 'Gateways',
    en: 'Gateways',
    sv: 'Gatewayer',
    fi: 'Reitittimet',
    nb: 'Gatewayer',
  },
  generateAsBuilt: {
    cz: 'Vytvořit as-built',
    de: 'As-built erstellen',
    en: 'Generate as-built',
    sv: 'Generera as-built',
    fi: 'Luo as-built',
    nb: 'Generere as-built',
  },
  generateInstallationPlan: {
    cz: 'Vytvořit plán instalace',
    de: 'Installationsplan erstellen',
    en: 'Generate installation plan',
    sv: 'Generera installationsplan',
    fi: 'Luo asennussuunnitelma',
    nb: 'Generer installasjonsplan',
  },
  generateReport: {
    cz: 'Generovat zprávu',
    de: 'Bericht generieren',
    en: 'Generate report',
    sv: 'Generera rapport',
    fi: 'Luo raportti',
    nb: 'Generer rapport',
  },
  good: {
    cz: 'Dobré',
    de: 'Gut',
    en: 'Good',
    sv: 'God',
    fi: 'Hyvä',
    nb: 'God',
  },
  green: {
    cz: 'Zelená',
    de: 'Grün',
    en: 'Green',
    sv: 'Grön',
    fi: 'Vihreä',
    nb: 'Grønn',
  },
  greenRoof: {
    cz: 'Zelená střecha',
    de: 'Gründach',
    en: 'Green roof',
    sv: 'Grönt tak',
    fi: 'Viherkatto',
    nb: 'Grønt tak',
  },
  grey: {
    cz: 'Šedá',
    de: 'Grau',
    en: 'Grey',
    sv: 'Grå',
    fi: 'Harmaa',
    nb: 'Grå',
  },
  guidesAndChecklists: {
    cz: 'Příručky a kontrolní seznamy',
    de: 'Anleitungen und Checklisten',
    en: 'Guides and checklists',
    sv: 'Guider och checklistor',
    fi: 'Oppaat ja tarkistuslistat',
    nb: 'Veiledninger og sjekklister',
  },
  help: {
    cz: 'Pomoc',
    de: 'Hilfe',
    en: 'Help',
    sv: 'Hjälp',
    fi: 'Ohje',
    nb: 'Hjelp',
  },
  hidden: {
    cz: 'Skrýt',
    de: 'Verstecken',
    en: 'Hide',
    sv: 'Dölj',
    fi: 'Piilota',
    nb: 'Skjul',
  },
  hiddenProjects: {
    en: 'Hidden projects',
    nb: 'Skjulte prosjekter',
    de: 'Ausgeblendete Projekte',
    sv: 'Dolda projekt',
    fi: 'Piilotetut projektit',
    cz: 'Skryté projekty',
  },
  hideFromUsers: {
    cz: 'Skrýt před uživateli',
    de: 'Vor Benutzern ausblenden',
    en: 'Hide from users',
    sv: 'Dölj för användare',
    fi: 'Piilota käyttäjiltä',
    nb: 'Skjul for brukere',
  },
  hideProjects: {
    cz: 'Skrýt projekty',
    de: 'Projekte ausblenden',
    en: 'Hide projects',
    sv: 'Skjul projekter',
    fi: 'Piilota projektit',
    nb: 'Skjul prosjekter',
  },
  history: {
    cz: 'Historie',
    de: 'Historie',
    en: 'History',
    sv: 'Historik',
    fi: 'Historia',
    nb: 'Historie',
  },
  icon: {
    cz: 'Ikona',
    de: 'Symbol',
    en: 'Icon',
    sv: 'Ikon',
    fi: 'Ikoni',
    nb: 'Ikon',
  },
  imageOfInstalledDevice: {
    cz: 'Obrázek nainstalovaného zařízení',
    de: 'Bild des installierten Geräts',
    en: 'Image of installed device',
    sv: 'Bild av installerad enhet',
    fi: 'Asennetun laitteen kuva',
    nb: 'Bilde av installert enhet',
  },
  inactive: {
    cz: 'Offline',
    de: 'Offline',
    en: 'Offline',
    sv: 'Offline',
    fi: 'Offline',
    nb: 'Offline',
  },
  inactiveGateways: {
    cz: 'Neaktivní brány',
    de: 'Inaktive Gateways',
    en: 'Inactive gateways',
    sv: 'Inaktiva gatewayer',
    fi: 'Passiiviset reitittimet',
    nb: 'Inaktive gateways',
  },
  includeInstallationInstructions: {
    cz: 'Zahrnout instalační pokyny (norština)',
    de: 'Installationsanweisungen einbeziehen (norwegisch)',
    en: 'Include installation instructions (norwegian)',
    sv: 'Inkludera monteringsanvisningar (norska)',
    fi: 'Sisällytä asennusohjeet (norjaksi)',
    nb: 'Inkluder montasjeinstruksjoner (norsk)',
  },
  includeLegendInReport: {
    cz: 'Zahrnout legendu do zprávy',
    de: 'Legende in den Bericht einbeziehen',
    en: 'Include legend in report',
    sv: 'Inkludera förklaring i rapport',
    fi: 'Sisällytä selite raporttiin',
    nb: 'Inkluder tegnforklaring i rapport',
  },
  includePlotInReport: {
    cz: 'Zahrnout "{{ plot }}" do zprávy',
    de: 'Fügen Sie "{{ plot }}" in den Bericht ein',
    en: 'Include "{{ plot }}" in report',
    sv: 'Inkluder "{{ plot }}" i rapport',
    fi: 'Sisällytä "{{ plot }}" raporttiin',
    nb: 'Inkluder "{{ plot }}" i rapport',
  },
  includeRelativeHumidityInReport: {
    cz: 'Zahrnout "Relativní vlhkost" do zprávy',
    de: 'Fügen Sie "Relative Luftfeuchtigkeit" in den Bericht ein',
    en: 'Include "Relative humidity" in report',
    sv: 'Inkludera "Relativ fuktighet" i rapporten',
    fi: 'Sisällytä raporttiin "Suhteellinen kosteus"',
    nb: 'Inkluder "Relativ fuktighet" i rapport',
  },
  insideBox: {
    cz: 'Uvnitř boxu',
    de: 'Im Schrank',
    en: 'Inside box',
    sv: 'Inne i lådan',
    fi: 'Laatikon sisällä',
    nb: 'I boks',
  },
  insideCeiling: {
    cz: 'Uvnitř stropu',
    de: 'In der Decke',
    en: 'Inside ceiling',
    sv: 'Inne i taket',
    fi: 'Sisäkaton sisällä',
    nb: 'I himling',
  },
  insideFloor: {
    cz: 'Uvnitř podlahy',
    de: 'Im Boden',
    en: 'Inside floor',
    sv: 'Inne i golvet',
    fi: 'Lattian sisällä',
    nb: 'I gulv',
  },
  insideRoof: {
    cz: 'Uvnitř střechy',
    de: 'Im Dach',
    en: 'Inside roof',
    sv: 'Inne i taket',
    fi: 'Katon sisällä',
    nb: 'Inne i tak',
  },
  insideWall: {
    cz: 'Uvnitř zdi',
    de: 'In der Wand',
    en: 'Inside wall',
    sv: 'Inne i väggen',
    fi: 'Seinän sisällä',
    nb: 'I vegg',
  },
  installation: {
    cz: 'Instalace',
    de: 'Installation',
    en: 'Installation',
    sv: 'Installation',
    fi: 'Asennus',
    nb: 'Installasjon',
  },
  installationBracket: {
    cz: 'into® Bracket (slukvakt) namontovaný na střeše',
    de: 'into® Bracket (Abflusswächter) auf dem Dach montiert',
    en: 'into® Bracket (drain guard) mounted on the roof',
    sv: 'into® Bracket (avloppsväkt) monterad i avloppsrinna',
    fi: 'into® Bracket (tulvavahti) asennettuna katolle',
    nb: 'into® Bracket (slukvakt) montert i slukrenne',
  },
  installationComment: {
    cz: 'Komentář k instalaci',
    de: 'Installationskommentar',
    en: 'Installation comment',
    sv: 'Installationskommentar',
    fi: 'Asennuskommentti',
    nb: 'Installasjonskommentar',
  },
  installationGateway: {
    cz: 'into® Gateway namontovaný na stožáru proti římsu (elektřina je připojena v schválené krabici a umístěna vysoko na římsu. Kromě toho je žádoucí, aby byla příruba pokryta)',
    de: 'into® Gateway auf dem Mast gegen die Traufe montiert (Strom wird in einer genehmigten Box angeschlossen und hoch an der Traufe platziert. Außerdem ist es wünschenswert, dass die Flansch abgedeckt wird)',
    en: 'into® Gateway mounted on mast against the eaves (electricity is connected in an approved box and placed high on the eaves. In addition, it is desirable that the flange is covered)',
    sv: 'into® Gateway monterad på syll mot taklistta (ström ansluts i godkänd låda och placeras högt på taklistta. Dessutom är det önskvärt att flänsen täcks)',
    fi: 'asennettuna mastoon räystäslinjan viereen (sähkö kytketään hyväksyttyyn koteloon ja asennetaan korkealle räystäälle. Lisäksi on suositeltavaa että laippa peitetään)',
    nb: 'into® Gateway montert pa mast mot gesims (strom kobles i godkjent boks og settes hoyt pa gesims. I tillegg er det onskelig at flens tekkes)',
  },
  installationGuides: {
    cz: 'Instalační návody',
    de: 'Installationsanleitungen',
    en: 'Installation guides',
    sv: 'Installationsguider',
    fi: 'Asennusoppaat',
    nb: 'Installasjonsveiledninger',
  },
  installationInstruction: {
    cz: 'Instalační instrukce',
    de: 'Installationsanleitung',
    en: 'Installation instruction',
    sv: 'Installationsinstruktion',
    fi: 'Asennusohje',
    nb: 'Monteringsinstruksjon',
  },
  installationInstruction1: {
    cz: 'Všechny senzory umístěné v blízkosti rohů nebo stěn by měly být umístěny ve vzdálenosti 0,6 m od římsy.',
    de: 'Alle Sensoren, die in der Nähe von Ecken oder Wänden platziert werden, sollten einen Abstand von 0,6 m zur Decke haben.',
    en: 'All sensors placed near corners or walls should be positioned 0.6 m away from the ceiling.',
    sv: 'Alla sensorer som placeras nära hörn eller väggar ska placeras 0,6 m från takfoten.',
    fi: 'Kaikki anturit',
    nb: 'Alle sensorer som plasseres i tilknytning til hjørne eller vegg skal ha 0.6 m avstand fra gesims.',
  },
  installationInstruction2: {
    cz: 'Všechny umístění senzorů by měla být označena sprejovou barvou (kříž a číslo) před pokládkou parotěsné zábrany, což usnadní pokrývači sledovat, kde a kdy má být senzor namontován.',
    de: 'Alle Sensorplatzierungen sollten vor der Verlegung der Dampfsperre mit Sprühfarbe (Kreuz und Nummer) markiert werden, damit der Dachdecker leichter verfolgen kann, wo und wann ein Sensor montiert werden soll.',
    en: 'All sensor placements should be marked with spray paint (cross and number) before the vapor barrier is laid, making it easier for the roofer to keep track of where and when a sensor should be installed.',
    sv: 'Alla sensorplaceringar ska markeras med sprayfärg (kryss och nummer) innan ångspärren läggs, så att takläggaren lättare kan hålla reda på var och när en sensor ska monteras.',
    fi: 'Kaikki anturien sijoituskohdat tulisi merkitä spray-maalilla (risti ja numero) ennen höyrynsulun asettamista, jotta kattotyöntekijän on helpompi seurata, mihin ja milloin anturi pitäisi asentaa.',
    nb: 'Alle sensorplasseringer skal merkes med sprayboks (kryss og nummer) på dekke før dampsperren legges, dermed er det enklere for taktekker å holde styr på hvor og når en sensor skal monteres.',
  },
  installationInstruction3: {
    cz: 'Pro senzory umístěné na parotěsné zábraně je důležité odstranit izolaci kolem a nad senzorem, aby nebyl senzor izolací tlačen proti parotěsné zábraně. Viz pokyny níže na stránce (*)',
    de: 'Bei Sensoren, die auf der Dampfsperre montiert sind, ist es wichtig, die Isolierung um den Sensor herum und über dem Sensor abzuschneiden, damit der Sensor nicht von der Isolierung gegen die Dampfsperre gedrückt wird. Siehe Anleitung weiter unten auf der Seite (*)',
    en: 'For sensors mounted on the vapor barrier, it is important to cut away insulation around and above the sensor so that the sensor is not pressed against the vapor barrier by the insulation. See instructions further down on the page (*)',
    sv: 'För sensorer som monteras på ångspärren är det viktigt att skära bort isolering runt och ovanför sensorn så att den inte pressas mot ångspärren av isoleringen. Se anvisning längre ner på sidan (*)',
    fi: 'Höyrynsulkuun asennettavien anturien osalta on tärkeää leikata eristettä anturin ympäriltä ja yläpuolelta niin, ettei eriste paina anturia höyrynsulkua vasten. Katso ohjeet sivun alaosasta (*).',
    nb: 'For sensorer som monteres på dampsperren er det viktig å skjære vekk isolasjon rundt og over sensoren slik at den ikke presses mot dampsperren av isolasjonen. Se anvisning lengre ned på siden (*)',
  },
  installationInstruction4: {
    cz: 'Brána (trojúhelníková ikona) by měla být vždy připojena k trvalému napájení, toto provádíte na vlastní riziko. iCS nebude moci přijímat, zpracovávat data a posílat upozornění, pokud toto pravidlo nebude dodrženo. Dočasné napájení funguje ve fázi výstavby, ale ujistěte se, že toto řešení je stabilní, aby brána měla napájení kdykoli.',
    de: 'Gateway (Dreieck-Symbol) sollte immer an eine dauerhafte Stromversorgung angeschlossen sein, dies erfolgt auf eigene Verantwortung. iCS kann keine Daten empfangen, verarbeiten und Warnungen senden, wenn dies nicht beachtet wird. Temporäre Stromversorgung funktioniert in der Bauphase, aber stellen Sie sicher, dass diese Lösung stabil ist, damit die Gateway jederzeit Strom hat.',
    en: 'Gateway (triangle icon) should always be connected to a permanent power supply, this is done at your own risk. iCS will not be able to receive, process data and send alerts if this is not followed. Temporary power works in a construction phase, but make sure this solution is stable so that the gateway has power at all times.',
    sv: 'Gateway (triangulär ikon) ska alltid vara ansluten till fast ström, vilket görs på eget ansvar. iCS kan inte ta emot eller visa data och skicka aviseringar om detta inte följs. Tillfällig ström fungerar under byggfasen, men se till att lösningen är stabil så att gatewayen har ström hela tiden.',
    fi: 'Reititin (kolmion muotoinen kuvake) tulee aina liittää pysyvään virtalähteeseen, ja tämä tehdään omalla vastuulla. iCS ei pysty vastaanottamaan tai käsittelemään tietoja tai lähettämään hälytyksiä, jos tätä ei noudateta. Väliaikainen virransyöttö toimii rakennusvaiheessa, mutta varmista, että tämä ratkaisu on vakaa, jotta gateway saa virtaa jatkuvasti.',
    nb: 'Gateway (trekantet ikon) skal stå på faststrøm til en hver tid, dette utføres på eget ansvar. iCS vil ikke kunne motta, fremstille data og gi varslinger hvis dette ikke overholdes. Provisjon fungerer i en byggefase, men prov å sørge for at denne løsningen er stabil slik at gateway har strøm til enhver tid.',
  },
  installationInstruction5: {
    cz: 'Slukvakter by měly být dodatečně namontovány, když je střecha dokončena a umístěny v blízkosti odtoků. Použijte TEC7 pro zajištění dobrého přilnutí mezi do into® Bracket a podkladem.',
    de: 'Die Abflusswächter sollten nach Fertigstellung des Daches nachgerüstet und in der Nähe der Abflüsse platziert werden. Verwenden Sie TEC7, um eine gute Haftung zwischen into® Bracket und Untergrund zu gewährleisten.',
    en: 'Drain guards should be retrofitted when the roof is completed and placed near the drains. Use TEC7 to ensure good adhesion between into® Bracket and the substrate.',
    sv: 'Brunnsvakter ska eftermonteras när taket färdigställs och placeras nära brunnar. Använd TEC7 för att säkerställa god vidhäftning mellan into® Bracket och underlaget.',
    fi: 'Tulvavahdit tulisi asentaa jälkikäteen katon valmistuttua ja sijoittaa lähelle kaivoja. Käytä TEC7:ää varmistamaan hyvä tartunta into® Bracketin ja alustan välillä.',
    nb: 'Slukvakter skal ettermonteres når taket ferdigstilles og plasseres i nærheten av sluker. Bruk TEC7 for å sikre god heft mellom into® Bracket og underlaget.',
  },
  installationInstruction6: {
    cz: 'Je důležité umístit správně číslovaný senzor na správné místo na mapě. Pokud toto pravidlo nebude dodrženo, můžete detekovat úniky na nesprávném místě.',
    de: 'Es ist wichtig, den korrekt nummerierten Sensor am richtigen Ort auf der Karte zu platzieren. Wenn dies nicht beachtet wird, können Sie Lecks am falschen Ort erkennen.',
    en: 'It is important to place the correctly numbered sensor in the right place on the map. If this is not followed, you may detect leaks in the wrong location.',
    sv: 'Det är viktigt att placera rätt numrerad sensor på rätt plats i kartan. Om detta inte följs kan läckage upptäckas på fel plats.',
    fi: 'On tärkeää sijoittaa oikein numeroitu anturi oikeaan kohtaan kartalla. Jollei tätä noudateta vuodoista, voidaan saada havainto väärästä sijainnista.',
    nb: 'Ønsker å presisere viktigheten av å plassere riktig nummerert sensor på riktig sted i kartet. Hvis dette ikke overholdes vil man kunne oppdage lekkasjer på feil lokasjon.',
  },
  installationMap: {
    cz: 'Mapa instalace',
    de: 'Installationskarte',
    en: 'Installation map',
    sv: 'Installationskarta',
    fi: 'Asennuskartta',
    nb: 'Installasjonskart',
  },
  installationMapMaxFileSize: {
    cz: 'Maximální velikost souboru: 20 MB',
    de: 'Maximale Dateigröße: 20 MB',
    en: 'Max file size: 20 MB',
    sv: 'Max filstorlek: 20 MB',
    fi: 'Tiedoston enimmäiskoko: 20 Mt',
    nb: 'Maks filstørrelse: 20 MB',
  },
  installationName: {
    cz: 'Název instalace',
    de: 'Installationsname',
    en: 'Installation name',
    sv: 'Installationsnamn',
    fi: 'Asennuksen nimi',
    nb: 'Installasjonsnavn',
  },
  installationPhotos: {
    cz: 'Instalační fotografie',
    de: 'Installationsfotos',
    en: 'Installation photos',
    sv: 'Installationsbilder',
    fi: 'Asennusvalokuvat',
    nb: 'Installasjonsbilder',
  },
  installationPlan: {
    cz: 'Plán instalace',
    de: 'Installationsplan',
    en: 'Installation plan',
    sv: 'Installationsplan',
    fi: 'Asennussuunnitelma',
    nb: 'Installasjonsplan',
  },
  installationPlans: {
    cz: 'Plány instalací',
    de: 'Installationspläne',
    en: 'Installation plans',
    sv: 'Installationsplaner',
    fi: 'Asennussuunnitelmat',
    nb: 'Installasjonsplaner',
  },
  installationSensor: {
    cz: 'into® Sensor namontovaný na parotěsné zábraně',
    de: 'into® Sensor auf der Dampfsperre montiert',
    en: 'into® Sensor mounted on the vapor barrier',
    sv: 'into® Sensor monterad på ångspärren',
    fi: 'into® Sensor asennettuna höyrynsulun päälle',
    nb: 'into® Sensor ettermontert pả dampsperren',
  },
  length: {
    cz: 'Délka',
    de: 'Länge',
    en: 'Length',
    sv: 'Längd',
    fi: 'Pituus',
    nb: 'Lengde',
  },
  insulatedElectrode: {
    cz: 'Izolovaná elektroda',
    de: 'Isolierte Elektrode',
    en: 'Insulated electrode',
    sv: 'Isolerad elektrod',
    fi: 'Eristetty elektrodi',
    nb: 'Isolert elektrode',
  },
  applyWoodSettingsToAllInstallationWoodSensors: {
    cz: 'Použít délku šroubu a izolovanou elektrodu pro všechny dřevěné senzory v této instalaci',
    de: 'Schraubenlänge und isolierte Elektrode auf alle Holzsensoren in dieser Installation anwenden',
    en: 'Apply screw length and insulated electrode to all wood sensors in this installation',
    sv: 'Använd skruvlängd och isolerad elektrod för alla träsensorer i denna installation',
    fi: 'Käytä ruuvin pituutta ja eristettyä elektrodia kaikille tämän asennuksen puuantureille',
    nb: 'Bruk skruelengde og isolert elektrode på alle tresensorer i denne installasjonen',
  },
  applyToAll: {
    cz: 'Použít na všechny',
    de: 'Auf alle anwenden',
    en: 'Apply to all',
    sv: 'Använd för alla',
    fi: 'Käytä kaikille',
    nb: 'Bruk på alle',
  },
  installations: {
    cz: 'Instalace',
    de: 'Installationen',
    en: 'Installations',
    sv: 'Installationer',
    fi: 'Asennukset',
    nb: 'Installasjoner',
  },
  installer: {
    cz: 'Instalatér',
    de: 'Installateur',
    en: 'Installer',
    sv: 'Installatör',
    fi: 'Asentaja',
    nb: 'Installatør',
  },
  instant: {
    cz: 'Okamžitý',
    de: 'Sofort',
    en: 'Instant',
    sv: 'Omedelbar',
    fi: 'Välitön',
    nb: 'Umiddelbar',
  },
  insulationThickness: {
    cz: 'Tloušťka izolace',
    de: 'Dämmstärke',
    en: 'Insulation thickness',
    sv: 'Isolationstjocklek',
    fi: 'Eristyksen paksuus',
    nb: 'Isolasjonstykkelse',
  },
  insulationThicknessHelperText: {
    cz: 'Použijte průměrnou tloušťku izolace [cm]',
    de: 'Verwenden Sie die durchschnittliche Dämmstärke [cm]',
    en: 'Use average insulation thickness [cm]',
    sv: 'Använd genomsnittlig isolationstjocklek [cm]',
    fi: 'Käytä keskimääräistä eristyspaksuutta [cm]',
    nb: 'Bruk gjennomsnittlig isolasjonstykkelse [cm]',
  },
  insulationType: {
    cz: 'Typ izolace',
    de: 'Isoliermaterial',
    en: 'Insulation type',
    sv: 'Isolationstyp',
    fi: 'Eristystyyppi',
    nb: 'Isolasjonstype',
  },
  introduction: {
    cz: 'Úvod',
    de: 'Einführung',
    en: 'Introduction',
    sv: 'Introduktion',
    fi: 'Johdanto',
    nb: 'Introduksjon',
  },
  invalidSizedFile: {
    cz: 'Následující soubor je příliš velký: {{tooLargeFiles}}.',
    de: 'Die folgende Datei ist zu groß: {{tooLargeFiles}}.',
    en: 'The following file is too large: {{tooLargeFiles}}.',
    sv: 'Följande fil är för stor: {{tooLargeFiles}}.',
    fi: 'Seuraava tiedosto on liian suuri: {{ tooLargeFiles }}.',
    nb: 'Følgende fil er for stor: {{tooLargeFiles}}.',
  },
  invalidSizedFiles: {
    cz: 'Následující soubory jsou příliš velké: {{tooLargeFiles}}.',
    de: 'Die folgenden Dateien sind zu groß: {{tooLargeFiles}}.',
    en: 'The following filer are too large: {{tooLargeFiles}}.',
    sv: 'Följande filer är för stora: {{tooLargeFiles}}.',
    fi: 'Seuraavat tiedostot ovat liian suuria: {{tooLargeFiles}}.',
    nb: 'Følgende filer er for store: {{tooLargeFiles}}.',
  },
  invalidTypedFile: {
    cz: 'Následující soubor má nepodporovaný typ souboru: {{disallowedTypedFiles}}.',
    de: 'Die folgende Datei hat einen nicht unterstützten Dateityp: {{disallowedTypedFiles}}.',
    en: 'The following file has an unsupported file type: {{disallowedTypedFiles}}.',
    sv: 'Följande fil har en filtyp som inte stöds: {{disallowedTypedFiles}}.',
    fi: 'Seuraavalla tiedostolla on tukematon tiedostotyyppi,  jota ei tueta: {{disallowedTypedFiles}}.',
    nb: 'Følgende fil har en filtype som ikke støttes: {{disallowedTypedFiles}}.',
  },
  invalidTypedFiles: {
    cz: 'Následující soubory mají nepodporovaný typ souboru: {{disallowedTypedFiles}}.',
    de: 'Die folgenden Dateien haben einen nicht unterstützten Dateityp: {{disallowedTypedFiles}}.',
    en: 'The following files have unsupported file types: {{disallowedTypedFiles}}.',
    sv: 'Följande filer har en filtyp som inte stöds: {{disallowedTypedFiles}}.',
    fi: 'Seuraavilla tiedostoilla on tukemattomia tiedostotyyppejä,  joita ei tueta: {{disallowedTypedFiles}}.',
    nb: 'Følgende filer har en filtype som ikke støttes: {{disallowedTypedFiles}}.',
  },
  invertedCompactRoof: {
    cz: 'Obrácená kompaktní střecha',
    de: 'Umgekehrtes Kompaktdach',
    en: 'Inverted compact roof',
    sv: 'Omvänt kompakttak',
    fi: 'Käännetty katto',
    nb: 'Omvent kompakttak',
  },
  label: {
    cz: 'Štítek',
    de: 'Etikett',
    en: 'Label',
    sv: 'Etikett',
    fi: 'Tunniste',
    nb: 'Etikett',
  },
  language: {
    cz: 'Jazyk',
    de: 'Sprache',
    en: 'Language',
    sv: 'Språk',
    fi: 'Kieli',
    nb: 'Språk',
  },
  dateAndTime: {
    cz: 'Datum a čas',
    de: 'Datum und Uhrzeit',
    en: 'Date and time',
    sv: 'Datum och tid',
    fi: 'Päivämäärä ja aika',
    nb: 'Dato og tid',
  },
  dateFormat: {
    cz: 'Formát data',
    de: 'Datumsformat',
    en: 'Date format',
    sv: 'Datumformat',
    fi: 'Päivämäärän muoto',
    nb: 'Datoformat',
  },
  dateFormatLocale: {
    cz: 'Podle zvoleného jazyka',
    de: 'Standard der gewählten Sprache',
    en: 'Default for selected language',
    sv: 'Standard för valt språk',
    fi: 'Valitun kielen oletus',
    nb: 'Standard for valgt språk',
  },
  dateFormatIso: {
    cz: 'Rok–měsíc–den (ISO)',
    de: 'Jahr–Monat–Tag (ISO)',
    en: 'Year–month–day (ISO)',
    sv: 'År–månad–dag (ISO)',
    fi: 'Vuosi–kuukausi–päivä (ISO)',
    nb: 'År–måned–dag (ISO)',
  },
  dateFormatShortMonth: {
    cz: 'Zkrácený název měsíce',
    de: 'Abgekürzter Monatsname',
    en: 'Abbreviated month name',
    sv: 'Förkortat månadsnamn',
    fi: 'Kuukauden lyhenne',
    nb: 'Forkortet månedsnavn',
  },
  dateFormatDmy: {
    cz: 'Den–měsíc–rok',
    de: 'Tag–Monat–Jahr',
    en: 'Day–month–year',
    sv: 'Dag–månad–år',
    fi: 'Päivä–kuukausi–vuosi',
    nb: 'Dag–måned–år',
  },
  dateFormatMdy: {
    cz: 'Měsíc–den–rok',
    de: 'Monat–Tag–Jahr',
    en: 'Month–day–year',
    sv: 'Månad–dag–år',
    fi: 'Kuukausi–päivä–vuosi',
    nb: 'Måned–dag–år',
  },
  dateFormatDmyShort: {
    cz: 'Den–měsíc–rok (dvoumístný rok)',
    de: 'Tag–Monat–Jahr (zweistelliges Jahr)',
    en: 'Day–month–year (two-digit year)',
    sv: 'Dag–månad–år (tvåsiffrigt år)',
    fi: 'Päivä–kuukausi–vuosi (2-numeroinen vuosi)',
    nb: 'Dag–måned–år (tosifret år)',
  },
  timeFormat: {
    cz: 'Formát času',
    de: 'Zeitformat',
    en: 'Time format',
    sv: 'Tidsformat',
    fi: 'Ajan muoto',
    nb: 'Tidsformat',
  },
  timeFormat24h: {
    cz: '24hodinový formát',
    de: '24-Stunden-Format',
    en: '24-hour clock',
    sv: '24-timmarsformat',
    fi: '24 tunnin kello',
    nb: '24-timersformat',
  },
  timeFormat12h: {
    cz: '12hodinový formát (AM/PM)',
    de: '12-Stunden-Format (AM/PM)',
    en: '12-hour clock (AM/PM)',
    sv: '12-timmarsformat (AM/PM)',
    fi: '12 tunnin kello (AM/PM)',
    nb: '12-timersformat (AM/PM)',
  },
  themeMode: {
    cz: 'Téma',
    de: 'Design',
    en: 'Theme',
    sv: 'Tema',
    fi: 'Teema',
    nb: 'Tema',
  },
  themeModeDescription: {
    cz: 'Vyberte mezi světlým a tmavým motivem.',
    de: 'Wähle zwischen hellem und dunklem Design.',
    en: 'Choose between the light and dark appearance.',
    sv: 'Välj mellan ljust och mörkt tema.',
    fi: 'Valitse vaalean ja tumman teeman välillä.',
    nb: 'Velg mellom lyst og mørkt tema.',
  },
  lastHalfYear: {
    cz: 'Poslední půlrok',
    de: 'Letzte sechs Monate',
    en: 'Last half year',
    sv: 'Senaste halvåret',
    fi: 'Edelliset puoli vuotta',
    nb: 'Siste halvår',
  },
  lastMonth: {
    cz: 'Poslední měsíc',
    de: 'Letzter Monat',
    en: 'Last month',
    sv: 'Senaste månaden',
    fi: 'Edellinen kuukausi',
    nb: 'Siste måned',
  },
  lastName: {
    cz: 'Příjmení',
    de: 'Nachname',
    en: 'Last name',
    sv: 'Efternamn',
    fi: 'Sukunimi',
    nb: 'Etternavn',
  },
  lastThreeMonths: {
    cz: 'Poslední 3 měsíce',
    de: 'Letzte 3 Monate',
    en: 'Last 3 months',
    sv: 'Senaste 3 månaderna',
    fi: 'Edelliset 3 kuukautta',
    nb: 'Siste 3 måneder',
  },
  lastSixMonths: {
    cz: 'Posledních 6 měsíců',
    de: 'Letzte 6 Monate',
    en: 'Last 6 months',
    sv: 'Senaste 6 månaderna',
    fi: 'Viimeiset 6 kuukautta',
    nb: 'Siste 6 måneder',
  },
  lastSevenDays: {
    cz: 'Posledních 7 dní',
    de: 'Letzte 7 Tage',
    en: 'Last 7 days',
    sv: 'Senaste 7 dagarna',
    fi: 'Viimeiset 7 päivää',
    nb: 'Siste 7 dager',
  },
  lastFourteenDays: {
    cz: 'Posledních 14 dní',
    de: 'Letzte 14 Tage',
    en: 'Last 14 days',
    sv: 'Siste 14 dagar',
    fi: 'Viimeiset 14 päivää',
    nb: 'Siste 14 dager',
  },
  lastThirtyDays: {
    cz: 'Posledních 30 dní',
    de: 'Letzte 30 Tage',
    en: 'Last 30 days',
    sv: 'Siste 30 dagar',
    fi: 'Viimeiset 30 päivää',
    nb: 'Siste 30 dager',
  },
  lastNinetyDays: {
    cz: 'Posledních 90 dní',
    de: 'Letzte 90 Tage',
    en: 'Last 90 days',
    sv: 'Siste 90 dagar',
    fi: 'Viimeiset 90 päivää',
    nb: 'Siste 90 dager',
  },
  lastWeek: {
    cz: 'Minulý týden',
    de: 'Letzte Woche',
    en: 'Last week',
    sv: 'Siste uke',
    fi: 'Edellinen viikko',
    nb: 'Siste uke',
  },
  lastYear: {
    cz: 'Poslední rok',
    de: 'Letztes Jahr',
    en: 'Last year',
    sv: 'Senaste året',
    fi: 'Edellinen vuosi',
    nb: 'Siste år',
  },
  lastTwelveMonths: {
    cz: 'Posledních 12 měsíců',
    de: 'Letzte 12 Monate',
    en: 'Last 12 months',
    sv: 'Senaste 12 månaderna',
    fi: 'Viimeiset 12 kuukautta',
    nb: 'Siste 12 måneder',
  },
  latestMeasurement: {
    cz: 'Nejnovější Data',
    de: 'Neueste Daten',
    en: 'Latest Data',
    sv: 'Senaste Data',
    fi: 'Viimeisimmät tiedot',
    nb: 'Nyeste Data',
  },
  light: {
    cz: 'Světlá',
    de: 'Hell',
    en: 'Light',
    sv: 'Ljus',
    fi: 'Vaalea',
    nb: 'Lys',
  },
  live: {
    cz: 'Živě',
    de: 'Live',
    en: 'Live',
    sv: 'Live',
    fi: 'Live',
    nb: 'Live',
  },
  loading: {
    cz: 'Načítání...',
    de: 'Laden...',
    en: 'Loading...',
    sv: 'Laddar...',
    fi: 'Ladataan...',
    nb: 'Laster...',
  },
  localId: {
    cz: 'Místní ID',
    de: 'Lokale ID',
    en: 'Local ID',
    sv: 'Lokal ID',
    fi: 'Paikallinen tunnus',
    nb: 'Lokal ID',
  },
  logIn: {
    cz: 'Přihlásit se',
    de: 'Einloggen',
    en: 'Log in',
    sv: 'Logga in',
    fi: 'Kirjaudu sisään',
    nb: 'Logg inn',
  },
  logout: {
    cz: 'Odhlásit se',
    de: 'Abmelden',
    en: 'Log out',
    sv: 'Logga ut',
    fi: 'Kirjaudu ulos',
    nb: 'Logg ut',
  },
  map: {
    cz: 'Mapa',
    de: 'Karte',
    en: 'Map',
    sv: 'Karta',
    fi: 'Kartta',
    nb: 'Kart',
  },
  maps: {
    cz: 'Mapy',
    de: 'Karten',
    en: 'Maps',
    sv: 'Kartor',
    fi: 'Kartat',
    nb: 'Kart',
  },
  maintenanceBannerDescription: {
    cz: 'Služba může být během údržby nestabilní.',
    de: 'Der Dienst kann während der Wartungsarbeiten instabil sein.',
    en: 'The service may be unstable while maintenance work is ongoing.',
    sv: 'Tjänsten kan vara instabil medan underhållsarbetet pågår.',
    fi: 'Palvelu voi olla epävakaa huoltotöiden aikana.',
    nb: 'Tjenesten kan være ustabil mens vedlikeholdsarbeid pågår.',
  },
  maintenanceBannerTitle: {
    cz: 'Probíhá údržba',
    de: 'Wartungsarbeiten laufen',
    en: 'Maintenance in progress',
    sv: 'Underhåll pågår',
    fi: 'Huoltotyö käynnissä',
    nb: 'Vedlikehold pågår',
  },
  maxCharacters: {
    cz: '{{ field }} nesmí mít více než {{ max }} znaků',
    de: '{{ field }} darf nicht mehr als {{ max }} Zeichen lang sein',
    en: '{{ field }} cannot be more than {{ max }} characters',
    sv: '{{ field }} kan inte vara mer än {{ max }} tecken',
    fi: 'Kentän {{ field }} ei voi olla enempää kuin {{ max }} merkkiä',
    nb: '{{ field }} kan ikke være mer enn {{ max }} tegn',
  },
  maxDecimalPoints: {
    cz: '{{field}} nesmí mít více než {{max}} desetinných míst',
    de: '{{field}} darf nicht mehr als {{max}} Dezimalstellen haben',
    en: '{{field}} can have a maximum of {{max}} decimal points',
    sv: '{{field}} kan ha maximalt {{max}} desimaler',
    fi: 'Kentässä {{field}} voi olla enintään {{max}} desimaalia',
    nb: '{{field}} kan ha maksimalt {{max}} desimaler',
  },
  maxFileSize: {
    cz: 'Maximální velikost souboru na soubor je {{maxFileSize}}.',
    de: 'Maximale Dateigröße pro Datei beträgt {{maxFileSize}}.',
    en: 'Max file size per file is {{maxFileSize}}.',
    sv: 'Maximal filstorlek per fil är {{maxFileSize}}.',
    fi: 'Suurin tiedostokoko per tiedosto on {{maxFileSize}}.',
    nb: 'Maksimal filstørrelse per fil er {{maxFileSize}}.',
  },
  maxMoisture: {
    cz: 'Maximální vlhkost',
    de: 'Maximale Feuchtigkeit',
    en: 'Maximum Moisture',
    sv: 'Maximal fuktighet',
    fi: 'Maksimikosteus',
    nb: 'Maksimal fukt',
  },
  maxNumber: {
    cz: '{{ field }} nesmí být více než {{ max }}',
    de: '{{ field }} darf nicht mehr als {{ max }} sein',
    en: '{{ field }} cannot be more than {{ max }}',
    sv: '{{ field }} kan inte vara mer än {{ max }}',
    fi: 'Kentän {{ field }} arvo ei voi olla enempää kuin {{ max }}.',
    nb: '{{ field }} kan ikke være mer enn {{ max }}',
  },
  maxOneYearSpan: {
    cz: 'Zvolené období nesmí být delší než jeden rok',
    de: 'Der gewählte Zeitraum darf nicht länger als ein Jahr sein',
    en: 'The selected period cannot be longer than one year',
    sv: 'Vald tidsperiod kan inte vara längre än ett år',
    fi: 'Valittu ajanjakso ei saa olla pidempi kuin yksi vuosi',
    nb: 'Valgt tidsperiode kan ikke være lengre enn ett år',
  },
  maxTemperature: {
    cz: 'Maximální teplota',
    de: 'Maximaltemperatur',
    en: 'Maximum temperature',
    sv: 'Maximumstemperatur',
    fi: 'Maksimilämpötila',
    nb: 'Maksimumstemperatur',
  },
  maxWaterDetectedEachPeriod: {
    cz: 'Maximální množství vody detekováno pro každé období',
    de: 'Maximale Wassermenge für jeden Zeitraum gemessen',
    en: 'Maximum moisture measured for each period',
    sv: 'Maximal fuktighetsmätning för varje period',
    fi: 'Kullekin jaksolle mitattu maksimikosteus',
    nb: 'Maksimal vannmåling målt for hver periode',
  },
  menu: {
    cz: 'Menu',
    de: 'Menü',
    en: 'Menu',
    sv: 'Meny',
    fi: 'Valikko',
    nb: 'Meny',
  },
  millimeterShort: {
    cz: 'mm',
    de: 'mm',
    en: 'mm',
    sv: 'mm',
    fi: 'mm',
    nb: 'mm',
  },
  minCharacters: {
    cz: '{{ field }} musí mít alespoň {{ min }} znaků',
    de: '{{ field }} muss mindestens {{ min }} Zeichen lang sein',
    en: '{{ field }} must be at least {{ min }} characters',
    sv: '{{ field }} måste vara minst {{ min }} tecken',
    fi: 'Kentän {{ field }} on oltava vähintään {{ min }} merkkiä',
    nb: '{{ field }} må være minst {{ min }} tegn',
  },
  minNumber: {
    cz: '{{ field }} nesmí být méně než {{ min }}',
    de: '{{ field }} darf nicht weniger als {{ min }} sein',
    en: '{{ field }} cannot be less than {{ min }}',
    sv: '{{ field }} kan inte vara mindre än {{ min }}',
    fi: 'Kentän {{ field }} arvo ei voi olla alle {{ min }}',
    nb: '{{ field }} kan ikke være mindre enn {{ min }}',
  },
  minTemperature: {
    cz: 'Minimální teplota',
    de: 'Minimale Temperatur',
    en: 'Minimum temperature',
    sv: 'Minimumstemperatur',
    fi: 'Minimilämpötila',
    nb: 'Minimumstemperatur',
  },
  missing: {
    cz: 'Chybí',
    de: 'Fehlt',
    en: 'Missing',
    sv: 'Brister',
    fi: 'Puuttuu',
    nb: 'Mangler',
  },
  mixed: {
    cz: 'Smíšený',
    de: 'Gemischt',
    en: 'Mixed',
    sv: 'Blandet',
    fi: 'Sekalainen',
    nb: 'Blandet',
  },
  mode: {
    cz: 'Režim',
    de: 'Modus',
    en: 'Mode',
    sv: 'Modus',
    fi: 'Tila',
    nb: 'Modus',
  },
  moisture: {
    cz: 'Vlhkost',
    de: 'Feuchtigkeit',
    en: 'Moisture',
    sv: 'Fuktighet',
    fi: 'Kosteus',
    nb: 'Fukt',
  },
  moistureData: {
    cz: 'Sběr vody',
    de: 'Wassersammlung',
    en: 'Moisture data',
    sv: 'Fuktighetsdata',
    fi: 'Kosteustiedot',
    nb: 'Vannsamling',
  },
  more: {
    cz: 'Více',
    de: 'Mehr',
    en: 'More',
    sv: 'Mer',
    fi: 'Lisää',
    nb: 'Mer',
  },
  move: {
    cz: 'Změnit instalaci',
    de: 'Installation ändern',
    en: 'Change installation',
    sv: 'Byt installation',
    fi: 'Vaihda asennusta',
    nb: 'Bytt installasjon',
  },
  moveSensor: {
    cz: 'Změnit instalaci senzoru',
    de: 'Installation für Sensor ändern',
    en: 'Change installation for sensor',
    sv: 'Byt installation för sensor',
    fi: 'Vaihda anturin asennus',
    nb: 'Bytt installasjon for sensor',
  },
  moveSensorDescription: {
    cz: 'Vyberte novou instalaci, do které chcete senzor přesunout. Všechny historické údaje a nastavení senzoru budou zachovány.',
    de: 'Wählen Sie die neue Installation aus, in die Sie den Sensor verschieben möchten. Alle historischen Daten und Sensoreinstellungen bleiben erhalten.',
    en: 'Select the new installation to which you want to move the sensor. All historical data and sensor settings will be retained.',
    sv: 'Välj den nya installationen du vill flytta sensorn till. All historisk data och sensorinställningar behålls.',
    fi: 'Valitse uusi asennus, johon haluat siirtää anturin. Kaikki historialliset tiedot ja anturin asetukset säilyvät.',
    nb: 'Velg den nye installasjonen du vil flytte sensoren til. All historisk data og sensorinnstillinger beholdes.',
  },
  moveSensorSelectLabel: {
    cz: 'Vyberte novou instalaci senzoru',
    de: 'Wählen Sie eine neue Installation für den Sensor',
    en: 'Select a new installation for the sensor',
    sv: 'Välj en ny installation för sensorn',
    fi: 'Valitse anturin uusi asennuspaikka',
    nb: 'Velg en ny installasjon for sensoren',
  },
  moveGateway: {
    cz: 'Změnit instalaci gateway',
    de: 'Installation für Gateway ändern',
    en: 'Change installation for gateway',
    sv: 'Byt installation för gateway',
    fi: 'Vaihda gatewayn asennus',
    nb: 'Bytt installasjon for gateway',
  },
  moveGatewayDescription: {
    cz: 'Vyberte novou instalaci, do které chcete gateway přesunout. Všechna historická data a nastavení gateway budou zachována.',
    de: 'Wählen Sie die neue Installation aus, in die Sie das Gateway verschieben möchten. Alle historischen Daten und Gateway-Einstellungen bleiben erhalten.',
    en: 'Select the new installation to which you want to move the gateway. All historical data and gateway settings will be retained.',
    sv: 'Välj den nya installationen du vill flytta gatewayen till. All historisk data och gateway-inställningar behålls.',
    fi: 'Valitse uusi asennus, johon haluat siirtää gatewayn. Kaikki historialliset tiedot ja gatewayn asetukset säilyvät.',
    nb: 'Velg den nye installasjonen du vil flytte gatewayen til. All historisk data og gateway-innstillinger beholdes.',
  },
  moveGatewaySelectLabel: {
    cz: 'Vyberte novou instalaci gateway',
    de: 'Wählen Sie eine neue Installation für das Gateway',
    en: 'Select a new installation for the gateway',
    sv: 'Välj en ny installation för gatewayen',
    fi: 'Valitse gatewayn uusi asennuspaikka',
    nb: 'Velg en ny installasjon for gatewayen',
  },
  moveDown: {
    cz: 'Posunout dolů',
    de: 'Nach unten bewegen',
    en: 'Move down',
    sv: 'Flytt ner',
    fi: 'Siirrä alas',
    nb: 'Flytt ned',
  },
  moveProjectToStatusOperative: {
    cz: 'Přesunout projekt do stavu Provozní',
    de: 'Projekt in den Betriebsstatus verschieben',
    en: 'Move project to status Operative',
    sv: 'Flytt projekt till status Operativt',
    fi: 'Siirrä projekti tilaan Käytössä',
    nb: 'Flytt prosjekt til status Operativt',
  },
  moveUp: {
    cz: 'Posunout nahoru',
    de: 'Nach oben bewegen',
    en: 'Move up',
    sv: 'Flytt upp',
    fi: 'Siirrä ylös',
    nb: 'Flytt opp',
  },
  mustBeInteger: {
    cz: '{{ field }} musí být celé číslo',
    de: '{{ field }} muss eine ganze Zahl sein',
    en: '{{ field }} must be an integer',
    sv: '{{ field }} måste vara ett heltal',
    fi: 'Kentän {{ field }} arvon on oltava kokonaisluku',
    nb: '{{ field }} må være et heltall',
  },
  name: {
    cz: 'Jméno',
    de: 'Name',
    en: 'Name',
    sv: 'Namn',
    fi: 'Nimi',
    nb: 'Navn',
  },
  newAsBuilt: {
    cz: 'Nové jako-postavené',
    de: 'Neu als-gebaut',
    en: 'New as-built',
    sv: 'Ny som byggt',
    fi: 'Uusi as-built',
    nb: 'Ny som-bygget',
  },
  newDistributor: {
    cz: 'Nový distributor',
    de: 'Neuer Distributor',
    en: 'New distributor',
    sv: 'Ny distributör',
    fi: 'Uusi jakelija',
    nb: 'Ny distributør',
  },
  newInstallationPlan: {
    cz: 'Nový plán instalace',
    de: 'Neuer Installationsplan',
    en: 'New installation plan',
    sv: 'Ny installationsplan',
    fi: 'Uusi asennussuunnitelma',
    nb: 'Ny installasjonsplan',
  },
  newReport: {
    cz: 'Nová zpráva',
    de: 'Neuer Bericht',
    en: 'New report',
    sv: 'Ny rapport',
    fi: 'Uusi raportti',
    nb: 'Ny rapport',
  },
  newest: {
    cz: 'Nejnovější',
    de: 'Neueste',
    en: 'Newest',
    sv: 'Senaste',
    fi: 'Uusin',
    nb: 'Nyeste',
  },
  nextStep: {
    cz: 'Další krok',
    de: 'Nächster Schritt',
    en: 'Next step',
    sv: 'Nästa steg',
    fi: 'Seuraava vaihe',
    nb: 'Neste steg',
  },
  no: {
    cz: 'Ne',
    de: 'Nein',
    en: 'No',
    sv: 'Nej',
    fi: 'Ei',
    nb: 'Nei',
  },
  noAddress: {
    cz: 'Žádná adresa',
    de: 'Keine Adresse',
    en: 'No address',
    sv: 'Ingen adresse',
    fi: 'Ei osoitetta',
    nb: 'Ingen adresse',
  },
  noAsBuiltDocs: {
    cz: 'Žádné jako-postavené dokumenty',
    de: 'Keine Als-gebaut-Dokumente',
    en: 'No as-built documents',
    sv: 'Ingen som-bygget dokumenter',
    fi: 'Ei as-built-dokumentteja',
    nb: 'Ingen som-bygget dokumenter',
  },
  noCompanies: {
    cz: 'Žádné společnosti',
    de: 'Keine Firmen',
    en: 'No companies',
    sv: 'Ingen företager',
    fi: 'Ei yrityksiä',
    nb: 'Ingen selskaper',
  },
  noContextImg: {
    cz: 'Žádný kontextový obrázek',
    de: 'Kein Kontextbild',
    en: 'No context image',
    sv: 'Ingen kontextbild',
    fi: 'Ei yleiskuvaa',
    nb: 'Ingen kontextbild',
  },
  noDataAvailableForCurrentChoice: {
    cz: 'Pro aktuální výběr nejsou k dispozici žádná data',
    de: 'Keine Daten für die aktuelle Auswahl verfügbar',
    en: 'No data available for current choice',
    sv: 'Ingen data tillgänglig för aktuellt val',
    fi: 'Ei tietoja saatavilla nykyiselle valinnalle',
    nb: 'Ingen data tilgjengelig for gjeldende valg',
  },
  noDataForThisSensor: {
    cz: 'Pro tento senzor nejsou k dispozici žádná data',
    de: 'Für diesen Sensor sind keine Daten verfügbar',
    en: 'No data available for this sensor',
    sv: 'Ingen data tillgänglig för den här sensorn',
    fi: 'Tälle anturille ei ole tietoja',
    nb: 'Ingen data tilgjengelig for denne sensoren',
  },
  noDataTimePeriod: {
    cz: 'Pro vybrané období nejsou žádná data nebo filtry',
    de: 'Es gibt keine Daten für den ausgewählten Zeitraum oder die Filter',
    en: 'There is no data for the selected time period or filters',
    sv: 'Det finns inga data för vald tidsperiod eller filter',
    fi: 'Valitulle ajanjaksolle tai suodattimille ei ole tietoja',
    nb: 'Det er ingen data for valgt tidsperiode eller filtre',
  },
  noInstallationPlans: {
    cz: 'Žádné plány instalací',
    de: 'Keine Installationspläne',
    en: 'No installation plans',
    sv: 'Ingen installationsplaner',
    fi: 'Ei asennussuunnitelmia',
    nb: 'Ingen installasjonsplaner',
  },
  noProjects: {
    cz: 'Žádné projekty',
    de: 'Keine Projekte',
    en: 'No projects',
    sv: 'Ingen projekter',
    fi: 'Ei projekteja',
    nb: 'Ingen prosjekter',
  },
  noReports: {
    cz: 'Žádné zprávy',
    de: 'Keine Berichte',
    en: 'No reports',
    sv: 'Ingen rapporter',
    fi: 'Ei raportteja',
    nb: 'Ingen rapporter',
  },
  noResults: {
    cz: 'Žádné výsledky',
    de: 'Keine Ergebnisse',
    en: 'No results',
    sv: 'Ingen treff',
    fi: 'Ei tuloksia',
    nb: 'Ingen treff',
  },
  noUploads: {
    cz: 'Žádné nahrané obrázky',
    de: 'Keine hochgeladenen Bilder',
    en: 'No uploaded images',
    sv: 'Inga uppladdade bilder',
    fi: 'Ei ladattuja kuvia',
    nb: 'Ingen opplastede bilder',
  },
  nonFlammable: {
    cz: 'Nehořlavý',
    de: 'Nicht brennbar',
    en: 'Non-flammable',
    sv: 'Icke brännbar',
    fi: 'Palamaton',
    nb: 'Ikke brennbar',
  },
  normal: {
    cz: 'Normální',
    de: 'Normal',
    en: 'Normal',
    sv: 'Normal',
    fi: 'Normaali',
    nb: 'Normal',
  },
  notifications: {
    cz: 'Oznámení',
    de: 'Benachrichtigungen',
    en: 'Notifications',
    sv: 'Varsler',
    fi: 'Ilmoitukset',
    nb: 'Varsler',
  },
  projectNotifications: {
    cz: 'Oznámení projektu',
    de: 'Projektbenachrichtigungen',
    en: 'Project Notifications',
    sv: 'Projektvarsler',
    fi: 'Projekti-ilmoitukset',
    nb: 'Prosjektvarsler',
  },
  projectNotificationsDescription: {
    cz: 'Nakonfigurujte, jak přijímáte upozornění a aktualizace pro každý projekt',
    de: 'Konfigurieren Sie, wie Sie Warnungen und Updates für jedes Projekt erhalten',
    en: 'Configure how you receive alerts and updates for each project',
    sv: 'Konfigurera hur du tar emot varningar och uppdateringar för varje projekt',
    fi: 'Määritä, miten saat hälytyksiä ja päivityksiä jokaisesta projektista',
    nb: 'Konfigurer hvordan du mottar varsler og oppdateringer for hvert prosjekt',
  },
  observations: {
    cz: 'Pozorování',
    de: 'Beobachtungen',
    en: 'Observations',
    sv: 'Observationer',
    fi: 'Havainnot',
    nb: 'Observasjoner',
  },
  off: {
    cz: 'Vypnuto',
    de: 'Aus',
    en: 'Off',
    sv: 'Av',
    fi: 'Pois',
    nb: 'Av',
  },
  offline: {
    cz: 'Offline',
    de: 'Offline',
    en: 'Offline',
    sv: 'Frakoblet',
    fi: 'Offline',
    nb: 'Frakoblet',
  },
  ok: {
    cz: 'Normální',
    de: 'Normal',
    en: 'Normal',
    sv: 'Normal',
    fi: 'Normaali',
    nb: 'Normal',
  },
  okButton: {
    cz: 'OK',
    de: 'OK',
    en: 'OK',
    sv: 'OK',
    fi: 'OK',
    nb: 'OK',
  },
  oldest: {
    cz: 'Nejstarší',
    de: 'Älteste',
    en: 'Oldest',
    sv: 'Äldsta',
    fi: 'Vanhin',
    nb: 'Eldste',
  },
  onCeiling: {
    cz: 'Na stropě',
    de: 'An der Decke',
    en: 'On ceiling',
    sv: 'På taket',
    fi: 'Katossa',
    nb: 'På taket',
  },
  onFloor: {
    cz: 'Na podlaze',
    de: 'Auf dem Boden',
    en: 'On floor',
    sv: 'På golv',
    fi: 'Lattialla',
    nb: 'På gulv',
  },
  onPole: {
    cz: 'Na sloupu',
    de: 'An einem Pfosten',
    en: 'On pole',
    sv: 'På stolpe',
    fi: 'Tolpassa',
    nb: 'På stolpe',
  },
  onRoof: {
    cz: 'Na střeše',
    de: 'Auf dem Dach',
    en: 'On roof',
    sv: 'På tak',
    fi: 'Katolla',
    nb: 'På tak',
  },
  onWall: {
    cz: 'Na zdi',
    de: 'An der Wand',
    en: 'On wall',
    sv: 'På vägg',
    fi: 'Seinällä',
    nb: 'På vegg',
  },
  open: {
    cz: 'Otevřít',
    de: 'Öffnen',
    en: 'Open',
    sv: 'Öppna',
    fi: 'Avaa',
    nb: 'Åpne',
  },
  openEditMode: {
    cz: 'Úpravy',
    de: 'Bearbeiten',
    en: 'Edit',
    sv: 'Redigera',
    fi: 'Muokkaus',
    nb: 'Rediger',
  },
  openFullscreen: {
    cz: 'Otevřít na celou obrazovku',
    de: 'Vollbild öffnen',
    en: 'Open fullscreen',
    sv: 'Öppna fullskjerm',
    fi: 'Avaa koko näyttö',
    nb: 'Åpne fullskjerm',
  },
  openPlanningMode: {
    cz: 'Instalace',
    de: 'Installation',
    en: 'Installing',
    sv: 'Installering',
    fi: 'Asennus',
    nb: 'Installering',
  },
  openProject: {
    cz: 'Otevřít projekt',
    de: 'Projekt öffnen',
    en: 'Open project',
    sv: 'Öppna projekt',
    fi: 'Avaa projekti',
    nb: 'Åpne prosjekt',
  },
  openWater: {
    cz: 'Otevřít vodu',
    de: 'Wasser öffnen',
    en: 'Open water',
    sv: 'Öppna vatten',
    fi: 'Avaa vesi',
    nb: 'Åpne vann',
  },
  openWaterConfirmation: {
    cz: 'Opravdu chcete otevřít vodu na tomto zařízení?',
    de: 'Möchten Sie das Wasser auf diesem Gerät wirklich öffnen?',
    en: 'Are you sure you want to open water on this device?',
    sv: 'Är du säker på att du vill öppna vatten på den här enheten?',
    fi: 'Haluatko varmasti avata veden tästä laitteesta?',
    nb: 'Er du sikker på at du vil åpne vann på denne enheten?',
  },
  opened: {
    cz: 'Otevřeno',
    de: 'Geöffnet',
    en: 'Opened',
    sv: 'Öppnat',
    fi: 'Avattu',
    nb: 'Åpnet',
  },
  operationalDocuments: {
    cz: 'Provozní dokumenty',
    de: 'Betriebsdokumente',
    en: 'Operational documents',
    sv: 'Driftsdokumenter',
    fi: 'Käyttöasiakirjat',
    nb: 'Driftsdokumenter',
  },
  operative: {
    cz: 'Provozní',
    de: 'In Betrieb',
    en: 'Operative',
    sv: 'Operativt',
    fi: 'Käytössä',
    nb: 'Operativt',
  },
  orientationMap: {
    cz: 'Orientační mapa',
    de: 'Orientierungskarte',
    en: 'Orientation map',
    sv: 'Orienteringskart',
    fi: 'Suunnistuskartta',
    nb: 'Orienteringskart',
  },
  orientationMapInfo: {
    cz: 'Referenční obrázek projektu s označenými oblastmi pro všechny instalace, tj. půdorys nebo 3D obrázek, může pomoci lokalizovat umístění senzorů. To je zvláště užitečné pro větší nebo složitější projekty. Viz příklady níže.',
    de: 'Ein Referenzbild des Projekts mit markierten Bereichen für alle Installationen, d.h. Grundriss oder 3D-Bild, kann helfen, die Platzierung der Sensoren zu lokalisieren. Dies ist besonders hilfreich für größere oder komplexere Projekte. Siehe Beispiele unten.',
    en: 'A reference image of the project with marked areas for all installations, i.e. floor plan or 3D image, can help locate the placement of sensors. This is particularly helpful for larger or more complex projects. See examples below.',
    sv: 'Orienteringskartan är valfri och kan användas för att visa orienteringen av installationerna. En referensbild av byggnaden med markerat område för de olika installationerna, t.ex. planritning eller 3D-bild, kan hjälpa till att hitta sensorernas placering. Detta är särskilt användbart för större eller mer komplexa byggnader. Se exempel nedan.',
    fi: 'Projektin viitekuva, jossa on merkitty alueet kaikille asennuksille, eli pohjapiirros tai 3D-kuva, voi auttaa anturien sijoittelun paikantamisessa. Tämä on erityisen hyödyllistä suuremmissa tai monimutkaisemmissa projekteissa. Katso esimerkkejä alla.',
    nb: 'Orienteringskartet er valgfritt og kan brukes til å vise orienteringen av installasjonene. Et referansebilde av bygningen med merket område for de forskjellige installasjonene, dvs. plantegning eller 3D-bilde, kan hjelpe til med å finne plasseringen av sensorer. Dette er spesielt nyttig for større eller mer komplekse bygninger. Se eksempler nedenfor.',
  },
  other: {
    cz: 'Jiný',
    de: 'Andere',
    en: 'Other',
    sv: 'Annat',
    fi: 'Muu',
    nb: 'Annet',
  },
  otherRoofInstallations: {
    cz: 'Další střešní instalace',
    de: 'Weitere Dachinstallationen',
    en: 'Other roof installations',
    sv: 'Andra takinstallationer',
    fi: 'Muut kattorakenteet',
    nb: 'Andre takinstallasjoner',
  },
  otherWeatherConditions: {
    cz: 'Další meteorologické podmínky',
    de: 'Andere Wetterbedingungen',
    en: 'Other weather conditions',
    sv: 'Andra väderförhållanden',
    fi: 'Muut sääolosuhteet',
    nb: 'Andre værforhold',
  },
  partName: {
    cz: 'Název části',
    de: 'Teilname',
    en: 'Part name',
    sv: 'Delnamn',
    fi: 'Osan nimi',
    nb: 'Delnavn',
  },
  partNr: {
    cz: 'Část {{ nr }}',
    de: 'Teil {{ nr }}',
    en: 'Part {{ nr }}',
    sv: 'Del {{ nr }}',
    fi: 'Osa {{ nr }}',
    nb: 'Del {{ nr }}',
  },
  partSummary: {
    cz: 'Shrnutí části',
    de: 'Teilzusammenfassung',
    en: 'Part summary',
    sv: 'Deluppsummering',
    fi: 'Osan yhteenveto',
    nb: 'Deloppsummering',
  },
  parts: {
    cz: 'Části',
    de: 'Teile',
    en: 'Parts',
    sv: 'Delar',
    fi: 'Osat',
    nb: 'Deler',
  },
  password: {
    cz: 'Heslo',
    de: 'Passwort',
    en: 'Password',
    sv: 'Lösenord',
    fi: 'Salasana',
    nb: 'Passord',
  },
  permissions: {
    cz: 'Oprávnění',
    de: 'Berechtigungen',
    en: 'Permissions',
    sv: 'Tillatelser',
    fi: 'Käyttöoikeudet',
    nb: 'Tillatelser',
  },
  phoneNr: {
    cz: 'Telefonní číslo',
    de: 'Telefonnummer',
    en: 'Phone number',
    sv: 'Telefonnummer',
    fi: 'Puhelinnumero',
    nb: 'Telefonnummer',
  },
  'nordic pine': {
    cz: 'Severská borovice',
    de: 'Nordische Kiefer',
    en: 'Nordic Pine',
    sv: 'Nordisk furu',
    fi: 'Pohjoismainen mänty',
    nb: 'Nordisk furu',
  },
  'nordic spruce': {
    cz: 'Severský smrk',
    de: 'Nordische Fichte',
    en: 'Nordic Spruce',
    sv: 'Nordisk gran',
    fi: 'Pohjoismainen kuusi',
    nb: 'Nordisk gran',
  },
  'nz radiata pine': {
    cz: 'NZ borovice radiata',
    de: 'NZ Radiata-Kiefer',
    en: 'NZ Radiata Pine',
    sv: 'NZ Radiatafuru',
    fi: 'NZ Radiatamänty',
    nb: 'NZ Radiatafuru',
  },
  pine: {
    cz: 'Borovice',
    de: 'Kiefer',
    en: 'Pine',
    sv: 'Furu',
    fi: 'Mänty',
    nb: 'Furu',
  },
  placement: {
    cz: 'Umístění',
    de: 'Platzierung',
    en: 'Placement',
    sv: 'Placering',
    fi: 'Sijoitus',
    nb: 'Plassering',
  },
  planning: {
    cz: 'Plánování',
    de: 'Planung',
    en: 'Planning',
    sv: 'Planering',
    fi: 'Suunnittelu',
    nb: 'Planlegging',
  },
  plannedDevices: {
    cz: 'Plánované',
    de: 'Geplant',
    en: 'Planned',
    sv: 'Planerad',
    fi: 'Suunniteltu',
    nb: 'Planlagt',
  },
  plastic: {
    cz: 'Plast',
    de: 'Kunststoff',
    en: 'Plastic',
    sv: 'Plast',
    fi: 'Muovi',
    nb: 'Plast',
  },
  pleaseSendUsAnInquiry: {
    cz: 'Pošlete nám prosím dotaz na',
    de: 'Bitte senden Sie uns eine Anfrage an',
    en: 'Please send us an inquiry at',
    sv: 'Skicka gärna en förfrågan till oss på',
    fi: 'Lähetä meille tiedustelu osoitteeseen',
    nb: 'Vennligst send oss en henvendelse på',
  },
  plots: {
    cz: 'Grafy',
    de: 'Diagramme',
    en: 'Plots',
    sv: 'Grafik',
    fi: 'Kaaviot',
    nb: 'Grafikk',
  },
  poor: {
    cz: 'Špatné',
    de: 'Schlecht',
    en: 'Poor',
    sv: 'Dålig',
    fi: 'Heikko',
    nb: 'Dårlig',
  },
  position: {
    cz: 'Pozice',
    de: 'Position',
    en: 'Position',
    sv: 'Position',
    fi: 'Sijainti',
    nb: 'Posisjon',
  },
  positionData: {
    cz: 'Data o pozici',
    de: 'Positionsdaten',
    en: 'Position Data',
    sv: 'Positionsdata',
    fi: 'Sijaintitiedot',
    nb: 'Posisjonsdata',
  },
  precipitation: {
    cz: 'Srážky',
    de: 'Niederschlag',
    en: 'Precipitation',
    sv: 'Nederbörd',
    fi: 'Sademäärä',
    nb: 'Nedbør',
  },
  precipitationAggregated: {
    cz: 'Agregované srážky',
    de: 'Aggregierte Niederschläge',
    en: 'Aggregated precipitation',
    sv: 'Aggregerad nederbörd',
    fi: 'Kumulatiivinen sademäärä',
    nb: 'Aggregert nedbør',
  },
  precipitationExplanation: {
    cz: 'kontroluje úniky a variace vlhkosti proti datům o srážkách v oblasti, kde jsou senzory umístěny',
    de: 'überprüft auf Lecks und Feuchtigkeitsvariationen gegen Niederschlagsdaten in dem Bereich, in dem die Sensoren lokalisiert sind',
    en: 'checks for leaks and moisture variations against precipitation data in the area where the sensors are located',
    sv: 'kontrollerar läckage och fuktvariationer mot nederbördsdata i området där sensorerna är placerade',
    fi: 'vertaa vuotoja ja kosteuden vaihteluita alueen sademäärätietoihin antureiden sijaintialueella',
    nb: 'kontrollerer lekkasjer og fuktvariasjoner opp mot nedbørsdata i området sensorene er lokalisert',
  },
  preview: {
    cz: 'Náhled',
    de: 'Vorschau',
    en: 'Preview',
    sv: 'Förhandsvisning',
    fi: 'Esikatselu',
    nb: 'Forhåndsvisning',
  },
  previewUnavailable: {
    cz: 'Náhled této fotografie není k dispozici. Přesto ji můžete nahrát.',
    de: 'Für dieses Foto ist keine Vorschau verfügbar. Sie können es trotzdem hochladen.',
    en: 'Preview unavailable for this photo. You can still upload it.',
    sv: 'Förhandsvisning saknas för det här fotot. Du kan ändå ladda upp det.',
    fi: 'Kuvan esikatselu ei ole käytettävissä. Voit silti ladata sen.',
    nb: 'Forhåndsvisning er ikke tilgjengelig for dette bildet. Du kan fortsatt laste det opp.',
  },
  previousStep: {
    cz: 'Předchozí krok',
    de: 'Vorheriger Schritt',
    en: 'Previous step',
    sv: 'Föregående steg',
    fi: 'Edellinen vaihe',
    nb: 'Forrige steg',
  },
  product: {
    cz: 'Produkt',
    de: 'Produkt',
    en: 'Product',
    sv: 'Produkt',
    fi: 'Tuote',
    nb: 'Produkt',
  },
  productKey: {
    cz: 'Sériové číslo',
    de: 'Seriennummer',
    en: 'Serial Number',
    sv: 'Serienummer',
    fi: 'Sarjanumero',
    nb: 'Serienummer',
  },
  newProductKey: {
    cz: 'Sériové číslo nového senzoru',
    de: 'Seriennummer des neuen Sensors',
    en: 'Serial number of new sensor',
    sv: 'Serienummer på ny sensor',
    fi: 'Uuden anturin sarjanumero',
    nb: 'Serienummer på ny sensor',
  },
  newProductKeyGateway: {
    cz: 'Sériové číslo nové brány',
    de: 'Seriennummer des neuen Gateways',
    en: 'Serial number of new gateway',
    sv: 'Serienummer på ny gateway',
    fi: 'Uuden reitittimen sarjanumero',
    nb: 'Serienummer på ny gateway',
  },
  oldProductKey: {
    cz: 'Staré sériové číslo',
    de: 'Alte Seriennummer',
    en: 'Old serial number',
    sv: 'Gammalt serienummer',
    fi: 'Vanha sarjanumero',
    nb: 'Gammelt serienummer',
  },
  deleteSerialNumber: {
    cz: 'Sériové číslo: {{serialNumber}}',
    de: 'Seriennummer: {{serialNumber}}',
    en: 'Serial number: {{serialNumber}}',
    sv: 'Serienummer: {{serialNumber}}',
    fi: 'Sarjanumero: {{serialNumber}}',
    nb: 'Serienummer: {{serialNumber}}',
  },
  productKeyAlreadyInUse: {
    cz: 'Klíč produktu již je v použití',
    de: 'Produkt-Schlüssel ist bereits in Verwendung',
    en: 'Product key is already in use',
    sv: 'Produktnyckeln används redan',
    fi: 'Tuoteavain on jo käytössä',
    nb: 'Produktnøkkel er allerede i bruk',
  },
  productKeyMustDifferFromCurrent: {
    cz: 'Nové sériové číslo musí být odlišné od aktuálního sériového čísla nahrazovaného senzoru',
    de: 'Der neue Seriennummer muss sich von der aktuellen Seriennummer des ersetzten Sensors unterscheiden',
    en: "New serial number must differ from the replaced sensor's current serial number",
    sv: 'Nytt serienummer måste vara olika från den ersatta sensorns aktuella serienummer',
    fi: 'Uuden sarjanumeron on oltava erilainen kuin korvatun anturin nykyinen sarjanumero',
    nb: 'Nytt serienummer må være forskjellig fra den erstattede sensorens nåværende serienummer',
  },
  profile: {
    cz: 'Profil',
    de: 'Profil',
    en: 'Profile',
    sv: 'Profil',
    fi: 'Profiili',
    nb: 'Profil',
  },
  profileSettings: {
    cz: 'Nastavení profilu',
    de: 'Profil-Einstellungen',
    en: 'Profile Settings',
    sv: 'Profilinställningar',
    fi: 'Profiiliasetukset',
    nb: 'Profilinnstillinger',
  },
  profileSettingsSubtitle: {
    cz: 'Spravujte nastavení a předvolby svého účtu',
    de: 'Verwalten Sie Ihre Kontoeinstellungen und -präferenzen',
    en: 'Manage your account settings and preferences',
    sv: 'Hantera dina kontoinställningar och preferenser',
    fi: 'Hallitse tilin asetuksia ja mieltymyksiä',
    nb: 'Administrer kontoinnstillingene og preferansene dine',
  },
  profilePicture: {
    cz: 'Profilový obrázek',
    de: 'Profilbild',
    en: 'Profile picture',
    sv: 'Profilbild',
    fi: 'Profiilikuva',
    nb: 'Profilbilde',
  },
  uploadPhotoSubtitle: {
    cz: 'Nahrajte fotografii pro personalizaci vašeho profilu',
    de: 'Laden Sie ein Foto hoch, um Ihr Profil zu personalisieren',
    en: 'Upload a photo to personalize your profile',
    sv: 'Ladda upp ett foto för att personalisera din profil',
    fi: 'Lataa kuva personoidaksesi profiilisi',
    nb: 'Last opp et bilde for å tilpasse profilen din',
  },
  uploadPhoto: {
    cz: 'Nahrát fotografii',
    de: 'Foto hochladen',
    en: 'Upload photo',
    sv: 'Ladda upp foto',
    fi: 'Lataa kuva',
    nb: 'Last opp bilde',
  },
  replacePhoto: {
    cz: 'Nahradit',
    de: 'Ersetzen',
    en: 'Replace',
    sv: 'Ersätt',
    fi: 'Korvaa',
    nb: 'Erstatt',
  },
  recommendedImageSize: {
    cz: 'Doporučeno: Čtvercový obrázek, alespoň 256×256 pixelů',
    de: 'Empfohlen: Quadratisches Bild, mindestens 256×256 Pixel',
    en: 'Recommended: Square image, at least 256×256 pixels',
    sv: 'Rekommenderat: Kvadratisk bild, minst 256×256 pixlar',
    fi: 'Suositeltu: Neliönmuotoinen kuva, vähintään 256×256 pikseliä',
    nb: 'Anbefalt: Kvadratisk bilde, minst 256×256 piksler',
  },
  cropAndUpload: {
    cz: 'Oříznout a nahrát',
    de: 'Zuschneiden und hochladen',
    en: 'Crop & upload',
    sv: 'Beskär och ladda upp',
    fi: 'Rajaa ja lataa',
    nb: 'Beskjær og last opp',
  },
  zoom: {
    cz: 'Přiblížení',
    de: 'Zoom',
    en: 'Zoom',
    sv: 'Zoom',
    fi: 'Zoom',
    nb: 'Zoom',
  },
  project: {
    cz: 'Projekt',
    de: 'Projekt',
    en: 'Project',
    sv: 'Projekt',
    fi: 'Projekti',
    nb: 'Prosjekt',
  },
  projectCount: {
    cz: 'Projekty: {{count}}',
    de: 'Projekte: {{count}}',
    en: 'Projects: {{count}}',
    sv: 'Projekter: {{count}}',
    fi: 'Projektit: {{count}}',
    nb: 'Prosjekter: {{count}}',
  },
  projectDetails: {
    cz: 'Podrobnosti o projektu',
    de: 'Projektdetails',
    en: 'Project details',
    sv: 'Projektdetaljer',
    fi: 'Projektin tiedot',
    nb: 'Prosjektdetaljer',
  },
  projectName: {
    cz: 'Název projektu',
    de: 'Projektname',
    en: 'Project name',
    sv: 'Projektnamn',
    fi: 'Projektin nimi',
    nb: 'Prosjektnavn',
  },
  projectNameAsc: {
    cz: 'Název projektu ↑',
    de: 'Projektname ↑',
    en: 'Project name ↑',
    sv: 'Projekt namn ↑',
    fi: 'Projektin nimi ↑',
    nb: 'Prosjekt navn ↑',
  },
  projectNameDesc: {
    cz: 'Název projektu ↓',
    de: 'Projektname ↓',
    en: 'Project name ↓',
    sv: 'Projekt namn ↓',
    fi: 'Projektin nimi ↓',
    nb: 'Prosjekt navn ↓',
  },
  projectRoofSpecifications: {
    cz: 'Specifikace střechy projektu',
    de: 'Dach-Spezifikationen des Projekts',
    en: 'Project roof specifications',
    sv: 'Projektspecifikationer för tak',
    fi: 'Katon tekniset tiedot',
    nb: 'Prosjekt takspesifikasjoner',
  },
  projectSection: {
    cz: 'Budova / sekce',
    de: 'Gebäude / Abschnitt',
    en: 'Project / section',
    sv: 'Byggnad / sektion',
    fi: 'Projekti / osa',
    nb: 'Bygning / seksjon',
  },
  projectStage: {
    cz: 'Stavební fáze',
    de: 'Bauphase',
    en: 'Project stage',
    sv: 'Byggnadsfas',
    fi: 'Projektin vaihe',
    nb: 'Bygningsfase',
  },
  projectType: {
    cz: 'Typ projektu',
    de: 'Projekttyp',
    en: 'Project type',
    sv: 'Projekttyp',
    fi: 'Projektityyppi',
    nb: 'Prosjekttype',
  },
  projects: {
    cz: 'Projekty',
    de: 'Projekte',
    en: 'Projects',
    sv: 'Projekter',
    fi: 'Projektit',
    nb: 'Prosjekter',
  },
  questionsAboutData: {
    cz: 'Otázky týkající se dat?',
    de: 'Fragen zu Daten?',
    en: 'Questions related to data?',
    sv: 'Frågor om data?',
    fi: 'Kysymyksiä tiedoista?',
    nb: 'Spørsmål om data?',
  },
  readyToUpload: {
    cz: 'Připraveno k nahrání',
    de: 'Bereit zum Hochladen',
    en: 'Ready to upload',
    sv: 'Redo att ladda upp',
    fi: 'Valmis ladattavaksi',
    nb: 'Klar til opplasting',
  },
  recommendations: {
    cz: 'Doporučení',
    de: 'Empfehlungen',
    en: 'Recommendations',
    sv: 'Rekommendationer',
    fi: 'Suositukset',
    nb: 'Anbefalinger',
  },
  red: {
    cz: 'Červená',
    de: 'Rot',
    en: 'Red',
    sv: 'Röd',
    fi: 'Punainen',
    nb: 'Rød',
  },
  redAlarmDescription: {
    cz: 'Červený poplach indikuje přítomnost vody. To je často způsobeno vniknutím vody nebo zvýšenými hladinami vlhkosti ve stavebních materiálech během stavební fáze. Vysoké hladiny vlhkosti jsou obvykle způsobeny kondenzací způsobenou změnami počasí a vysokou vlhkostí nebo v nejhorším případě detekcí úniku souvisejícího s deštěm nebo testy vodního tlaku.',
    de: 'Der rote Alarm weist auf das Vorhandensein von Wasser hin. Dies wird häufig durch Wassereintritt oder erhöhte Feuchtigkeitswerte in den Baumaterialien während der Bauphase verursacht. Hohe Feuchtigkeitswerte sind in der Regel auf Kondensation durch Wetteränderungen und hohe Luftfeuchtigkeit zurückzuführen oder im schlimmsten Fall auf die Erkennung eines Lecks im Zusammenhang mit Regenfällen oder Wasserdrucktests.',
    en: 'Red alarm indicates the presence of water. This is often caused by water intrusion or elevated moisture levels in the construction materials during the construction phase. High moisture levels are commonly due to condensation caused by weather changes and high humidity, or—at worst—the detection of a leak related to rainfall or water pressure tests.',
    sv: 'Rött larm indikerar förekomst av vatten. Detta orsakas ofta av vatteninträngning eller förhöjda fuktnivåer i byggmaterial under byggfasen. Höga fuktnivåer beror vanligtvis på kondens till följd av väderförändringar och hög luftfuktighet, eller i värsta fall upptäckt av läckage relaterat till nederbörd eller vattentryckstester.',
    fi: 'Punainen hälytys osoittaa veden esiintymisen. Tämä johtuu usein veden tunkeutumisesta tai kohonneista kosteustasoista rakennusmateriaaleissa rakentamisvaiheen aikana. Korkeat kosteustasot johtuvat yleisesti kondensaatiosta, joka aiheutuu sään vaihteluista ja korkeasta ilmankosteudesta, tai pahimmassa tapauksessa vuodon havaitsemisesta, joka liittyy sateeseen tai vesipainetesteihin.',
    nb: 'Rød alarm indikerer tilstedeværelsen av vann. Dette skyldes ofte vanninntrengning eller forhøyede fuktnivåer i byggematerialene under byggefasen. Høye fuktnivåer skyldes vanligvis kondens som følge av værforandringer og høy luftfuktighet, eller i verste fall deteksjon av lekkasje relatert til nedbør eller vanntrykktester.',
  },
  refrigerator: {
    cz: 'Lednice',
    de: 'Kühlschrank',
    en: 'Refrigerator',
    sv: 'Kylskåp',
    fi: 'Jääkaappi',
    nb: 'Kjøleskap',
  },
  registeredCompaniesWithSimilarNames: {
    cz: 'Registrované společnosti se podobnými názvy',
    de: 'Registrierte Unternehmen mit ähnlichen Namen',
    en: 'Registered companies with similar names',
    sv: 'Registrerade företag med liknande namn',
    fi: 'Rekisteröidyt yritykset joilla on samankaltaiset nimet',
    nb: 'Registrerte selskaper med lignende navn',
  },
  relativeHumidity2: {
    cz: 'Relativní vlhkost',
    de: 'Relative Luftfeuchtigkeit',
    en: 'Relative Humidity',
    sv: 'Relativ fuktighet',
    fi: 'Suhteellinen kosteus',
    nb: 'Relativ fuktighet',
  },
  relativeHumidityAvg: {
    cz: 'Průměrná relativní vlhkost',
    de: 'Durchschnittliche relative Luftfeuchtigkeit',
    en: 'Average Relative Humidity',
    sv: 'Genomsnittlig relativ fuktighet',
    fi: 'Keskimääräinen suhteellinen kosteus',
    nb: 'Gjennomsnittlig relativ fuktighet',
  },
  relativeHumidityExplanation: {
    cz: 'měří okolní relativní vlhkost na místě, kde je senzor namontován',
    de: 'misst die Umgebungsrelative Luftfeuchtigkeit am Punkt, an dem der Sensor montiert ist',
    en: 'measures ambient relative humidity at the point where the sensor is mounted',
    sv: 'mäter omgivande relativ fuktighet vid den punkt där sensorn är monterad',
    fi: 'mittaa ympäröivän ilman suhteellista kosteutta kohdassa  johon anturi on asennettu',
    nb: 'måler omgivende relativ fuktighet i det punktet sensoren er montert',
  },
  remove: {
    cz: 'Odstranit',
    de: 'Entfernen',
    en: 'Remove',
    sv: 'Ta bort',
    fi: 'Poista',
    nb: 'Fjern',
  },
  removeDevicesBeforeDeleting: {
    cz: 'Před smazáním instalace musíte odstranit všechny brány a senzory z této instalace.',
    de: 'Sie müssen alle Gateways und Sensoren aus dieser Installation entfernen, bevor Sie sie löschen können.',
    en: 'You must remove all gateways and sensors from this installation before you can delete it.',
    sv: 'Du måste ta bort alla gateways och sensorer från den här installationen innan du kan ta bort den.',
    fi: 'Sinun on poistettava kaikki yhdyskäytävät ja anturit tästä asennuksesta ennen kuin voit poistaa sen.',
    nb: 'Du må fjerne alle gatewayer og sensorer fra denne installasjonen før du kan slette den.',
  },
  removeDistributorUser: {
    cz: 'Odebrat uživatele distributora',
    de: 'Distributor-Benutzer entfernen',
    en: 'Remove distributor user',
    sv: 'Ta bort distributöranvändare',
    fi: 'Poista jakelijakäyttäjä',
    nb: 'Fjern distributørbruker',
  },
  removeFromProject: {
    cz: 'Odebrat z projektu',
    de: 'Aus Projekt entfernen',
    en: 'Remove from project',
    sv: 'Ta bort från projekt',
    fi: 'Poista projektista',
    nb: 'Fjern fra prosjekt',
  },
  removeGateway: {
    cz: 'Odstranit bránu',
    de: 'Gateway entfernen',
    en: 'Remove gateway',
    sv: 'Ta bort gateway',
    fi: 'Poista yhdyskäytävä',
    nb: 'Fjern gateway',
  },
  removePart: {
    cz: 'Odstranit část',
    de: 'Teil entfernen',
    en: 'Remove part',
    sv: 'Ta bort del',
    fi: 'Poista osa',
    nb: 'Fjern del',
  },
  replace: {
    cz: 'Nahradit',
    de: 'Ersetzen',
    en: 'Replace',
    sv: 'Ersätt',
    fi: 'Korvaa',
    nb: 'Erstatt',
  },
  replaceContextImg: {
    cz: 'Nahraďte kontextový obrázek',
    de: 'Kontextbild ersetzen',
    en: 'Replace context image',
    sv: 'Ersätt kontextbild',
    fi: 'Korvaa yleiskuva',
    nb: 'Erstatt kontekstbilde',
  },
  replaceOrientationImg: {
    cz: 'Nahraďte orientační obrázek',
    de: 'Orientierungsbild ersetzen',
    en: 'Replace orientation image',
    sv: 'Ersätt orienteringskart',
    fi: 'Korvaa suunnistuskartta',
    nb: 'Erstatt orienteringskart',
  },
  replaceInstallationMap: {
    cz: 'Nahraďte instalační mapu',
    de: 'Installationskarte ersetzen',
    en: 'Replace installation map',
    sv: 'Ersätt installationskart',
    fi: 'Korvaa asennuskartta',
    nb: 'Erstatt installasjonskart',
  },
  report: {
    cz: 'Zpráva',
    de: 'Bericht',
    en: 'Report',
    sv: 'Rapport',
    fi: 'Raportti',
    nb: 'Rapport',
  },
  reportSummary: {
    cz: 'Shrnutí zprávy',
    de: 'Berichtszusammenfassung',
    en: 'Report summary',
    sv: 'Rapportuppsummering',
    fi: 'Raportin yhteenveto',
    nb: 'Rapportoppsummering',
  },
  reportGenerationPending: {
    cz: 'Generování zprávy probíhá. Velké zprávy mohou trvat několik minut.',
    de: 'Der Bericht wird generiert. Große Berichte können mehrere Minuten dauern.',
    en: 'Report generation is running. Large reports can take several minutes.',
    sv: 'Rapportgenerering pågår. Store rapporter kan ta flere minutter.',
    fi: 'Raportin luonti on käynnissä. Suuret raportit voivat kestää useita minuutteja.',
    nb: 'Rapportgenerering pågår. Store rapporter kan ta flere minutter.',
  },
  reportDraft: {
    cz: 'Koncept',
    de: 'Entwurf',
    en: 'Draft',
    sv: 'Utkast',
    fi: 'Luonnos',
    nb: 'Utkast',
  },
  reportDraftSaved: {
    cz: 'Koncept zprávy byl uložen.',
    de: 'Berichtsentwurf wurde gespeichert.',
    en: 'Report draft saved.',
    sv: 'Rapportutkast sparat.',
    fi: 'Raporttiluonnos tallennettu.',
    nb: 'Rapportutkast lagret.',
  },
  reportGenerationFailed: {
    cz: 'Generování zprávy selhalo',
    de: 'Berichtsgenerierung fehlgeschlagen',
    en: 'Report generation failed',
    sv: 'Rapportgenerering misslyckades',
    fi: 'Raportin luonti epäonnistui',
    nb: 'Rapportgenerering feilet',
  },
  reportGenerationStarted: {
    cz: 'Generování zprávy bylo spuštěno. Průběh můžete sledovat v seznamu zpráv.',
    de: 'Die Berichtsgenerierung wurde gestartet. Sie können den Fortschritt in der Berichtsliste verfolgen.',
    en: 'Report generation has started. You can follow progress in the report list.',
    sv: 'Rapportgenerering har startet. Du kan følge fremdriften i rapportlisten.',
    fi: 'Raportin luonti on aloitettu. Voit seurata etenemistä raporttiluettelossa.',
    nb: 'Rapportgenerering har startet. Du kan følge fremdriften i rapportlisten.',
  },
  reports: {
    cz: 'Zprávy',
    de: 'Berichte',
    en: 'Reports',
    sv: 'Rapporter',
    fi: 'Raportit',
    nb: 'Rapporter',
  },
  resendInvite: {
    cz: 'Znovu odeslat pozvánku',
    de: 'Einladung erneut senden',
    en: 'Resend invite',
    sv: 'Skicka inbjudan igen',
    fi: 'Lähetä kutsu uudelleen',
    nb: 'Send invitasjon på nytt',
  },
  copyInviteLink: {
    cz: 'Kopírovat odkaz na pozvánku',
    de: 'Einladungslink kopieren',
    en: 'Copy invite link',
    sv: 'Kopiera inbjudningslänk',
    fi: 'Kopioi kutsulinkki',
    nb: 'Kopier invitasjonslenke',
  },
  sendOnboardingReminder: {
    cz: 'Odeslat připomenutí nastavení',
    de: 'Einrichtungserinnerung senden',
    en: 'Send setup reminder',
    sv: 'Skicka påminnelse om konfigurering',
    fi: 'Lähetä käyttöönoton muistutus',
    nb: 'Send påminnelse om oppsett',
  },
  resetFilters: {
    cz: 'Resetovat filtry',
    de: 'Filter zurücksetzen',
    en: 'Reset filters',
    sv: 'Tilbakestill filtre',
    fi: 'Nollaa suodattimet',
    nb: 'Tilbakestill filtre',
  },
  resources: {
    cz: 'Zdroje',
    de: 'Ressourcen',
    en: 'Resources',
    sv: 'Ressurser',
    fi: 'Resurssit',
    nb: 'Ressurser',
  },
  retryGenerate: {
    cz: 'Znovu vygenerovat',
    de: 'Erneut generieren',
    en: 'Retry generate',
    sv: 'Försök att generera igen',
    fi: 'Yritä luoda uudelleen',
    nb: 'Prøv igjen å generere',
  },
  saveDraft: {
    cz: 'Uložit koncept',
    de: 'Entwurf speichern',
    en: 'Save draft',
    sv: 'Spara utkast',
    fi: 'Tallenna luonnos',
    nb: 'Lagre utkast',
  },
  role: {
    cz: 'Role',
    de: 'Rolle',
    en: 'Role',
    sv: 'Rolle',
    fi: 'Rooli',
    nb: 'Rolle',
  },
  roleDescription: {
    cz: 'Popis role',
    de: 'Rollenbeschreibung',
    en: 'Role description',
    sv: 'Rollbeskrivning',
    fi: 'Roolin kuvaus',
    nb: 'Rollebeskrivelse',
  },
  roleDescriptionAdmin: {
    cz: 'Administrátoři mohou plně spravovat projektové plány a členy týmu.',
    de: 'Administratoren können Projektpläne und Teammitglieder vollständig verwalten.',
    en: 'Administrators can fully manage project plans and team members.',
    sv: 'Administratörer kan helt administrera projektplaner och teammedlemmar.',
    fi: 'Ylläpitäjät voivat hallita täysin projektisuunnitelmia ja tiimin jäseniä.',
    nb: 'Administratorer kan fullt ut administrere prosjektplaner og teammedlemmer.',
  },
  roleDescriptionAllUsers: {
    cz: 'Všichni uživatelé mohou zobrazit projektové plány, podrobnosti o týmu a data senzorů.',
    de: 'Alle Benutzer können Projektpläne, Teamdetails und Sensordaten anzeigen.',
    en: 'All users can view project plans, team details, and sensor data.',
    sv: 'Alle användaree kan se projektplaner, teamdetaljer och sensordata.',
    fi: 'Kaikki käyttäjät voivat katsella projektisuunnitelmia, tiimitietoja ja anturitietoja.',
    nb: 'Alle brukere kan se prosjektplaner, teamdetaljer og sensordata.',
  },
  roleDescriptionInstaller: {
    cz: 'Instalatéři mohou upravit instalační plán a umístění senzorů.',
    de: 'Installateure können den Installationsplan und die Sensorplatzierungen ändern.',
    en: 'Installers can modify the installation plan and sensor placements.',
    sv: 'Installatörer kan ändra installationsplanen och sensorplaceringar',
    fi: 'Asentajat voivat muuttaa asennussuunnitelmaa ja antureiden sijoittelua.',
    nb: 'Installatører kan endre installasjonsplanen og sensorplasseringene.',
  },
  roof: {
    cz: 'Střecha',
    de: 'Dach',
    en: 'Roof',
    sv: 'Tak',
    fi: 'Katto',
    nb: 'Tak',
  },
  roofMembrane: {
    cz: 'Střešní membrána',
    de: 'Dachmembran',
    en: 'Roof membrane',
    sv: 'Takmembran',
    fi: 'Kattokermi',
    nb: 'Takmembran',
  },
  roofType: {
    cz: 'Typ střechy',
    de: 'Dachtyp',
    en: 'Roof type',
    sv: 'Taktype',
    fi: 'Kattotyyppi',
    nb: 'Taktype',
  },
  save: {
    cz: 'Uložit',
    de: 'Speichern',
    en: 'Save',
    sv: 'Spara',
    fi: 'Tallenna',
    nb: 'Lagre',
  },
  useAsTemplate: {
    cz: 'Upravit',
    de: 'Bearbeiten',
    en: 'Edit',
    sv: 'Redigera',
    fi: 'Muokkaa',
    nb: 'Rediger',
  },
  finish: {
    cz: 'Dokončit',
    de: 'Fertigstellen',
    en: 'Finish',
    sv: 'Slutför',
    fi: 'Valmis',
    nb: 'Fullfør',
  },
  scanSensor: {
    cz: 'Skenovat senzor',
    de: 'Sensor scannen',
    en: 'Scan sensor',
    sv: 'Skann sensor',
    fi: 'Skannaa anturi',
    nb: 'Skann sensor',
  },
  search: {
    cz: 'Hledat',
    de: 'Suchen',
    en: 'Search',
    sv: 'Sök',
    fi: 'Hae',
    nb: 'Søk',
  },
  seeContextImg: {
    cz: 'Viz obrázek kontextu',
    de: 'Siehe Kontextbild',
    en: 'See context image',
    sv: 'Se kontextbild',
    fi: 'Näytä yleiskuva',
    nb: 'Se kontextbild',
  },
  seeOrientationImg: {
    cz: 'Viz orientační obrázek',
    de: 'Siehe Orientierungsbild',
    en: 'See orientation image',
    sv: 'Se orienteringsbilde',
    fi: 'Näytä suuntauskuva',
    nb: 'Se orienteringsbilde',
  },
  selectAll: {
    cz: 'Vybrat vše',
    de: 'Alles auswählen',
    en: 'Select all',
    sv: 'Välj alla',
    fi: 'Valitse kaikki',
    nb: 'Velg alle',
  },
  selectCamera: {
    cz: 'Vyberte kameru',
    de: 'Kamera auswählen',
    en: 'Select camera',
    sv: 'Välj kamera',
    fi: 'Valitse kamera',
    nb: 'Velg kamera',
  },
  selectDevice: {
    cz: 'Vybrat zařízení',
    de: 'Gerät auswählen',
    en: 'Select device',
    sv: 'Välj enhet',
    fi: 'Valitse laite',
    nb: 'Velg enhet',
  },
  selectInstallationPlansToInclude: {
    cz: 'Vyberte instalační plány, které chcete zahrnout do zprávy',
    de: 'Wählen Sie die Installationspläne aus, die in den Bericht aufgenommen werden sollen',
    en: 'Select installation plans to include in document',
    sv: 'Välj installationsplaner som ska inkluderas i dokumentet',
    fi: 'Valitse asennussuunnitelmat,  jotka sisällytetään asiakirjaan',
    nb: 'Velg installasjonsplaner som skal inkluderes i dokumentet',
  },
  selectSpecificSensors: {
    cz: 'Vyberte konkrétní senzory',
    de: 'Wählen Sie spezifische Sensoren',
    en: 'Select specific sensors',
    sv: 'Välj specifika sensorer',
    fi: 'Valitse tietyt anturit',
    nb: 'Velg spesifikke sensorer',
  },
  selected: {
    cz: 'vybráno',
    de: 'ausgewählt',
    en: 'selected',
    sv: 'vald',
    fi: 'valittu',
    nb: 'valgt',
  },
  selectedSensors: {
    cz: 'Vybrané senzory',
    de: 'Ausgewählte Sensoren',
    en: 'Selected sensors',
    sv: 'Valda sensorer',
    fi: 'Valitut anturit',
    nb: 'Valgte sensorer',
  },
  send: {
    cz: 'Odeslat',
    de: 'Senden',
    en: 'Send',
    sv: 'Skicka',
    fi: 'Lähetä',
    nb: 'Send',
  },
  service: {
    cz: 'Servis',
    de: 'Service',
    en: 'Service',
    sv: 'Tjänst',
    fi: 'Palvelu',
    nb: 'Tjeneste',
  },
  sensor: {
    cz: 'Senzor',
    de: 'Sensor',
    en: 'Sensor',
    sv: 'Sensor',
    fi: 'Anturi',
    nb: 'Sensor',
  },
  sensorAlert: {
    cz: 'Kritická upozornění',
    de: 'Kritische Warnungen',
    en: 'Critical alerts',
    sv: 'Kritiska varningar',
    fi: 'Kriittiset hälytykset',
    nb: 'Kritiske varsler',
  },
  sensorAlertDescription: {
    cz: 'Okamžité oznámení o kritických událostech',
    de: 'Sofortige Benachrichtigung über kritische Ereignisse',
    en: 'Immediate notification for critical events',
    sv: 'Omedelbar varning för kritiska händelser',
    fi: 'Välitön ilmoitus kriittisistä tapahtumista',
    nb: 'Umiddelbar varsling for kritiske hendelser',
  },
  sensorAndGatewayVisualization: {
    cz: 'Vizualizace senzoru a brány',
    de: 'Sensor- und Gateway-Visualisierung',
    en: 'Sensor and gateway visualization',
    sv: 'Sensor- och gateway-visualisering',
    fi: 'Anturien ja yhdyskäytävien visualisointi',
    nb: 'Sensor- og gateway-visualisering',
  },
  sensorCount: {
    cz: 'Počet senzorů',
    de: 'Sensoranzahl',
    en: 'Sensor count',
    sv: 'Antal sensorer',
    fi: 'Anturien lukumäärä',
    nb: 'Sensorantall',
  },
  periodSummaryRequiresPeriod: {
    cz: 'Pro zobrazení souhrnu vyberte časové období.',
    de: 'Wählen Sie einen Zeitraum aus, um eine Zusammenfassung anzuzeigen.',
    en: 'Select a time period to view a summary.',
    sv: 'Välj en tidsperiod för att visa en sammanfattning.',
    fi: 'Valitse ajanjakso nähdäksesi yhteenvedon.',
    nb: 'Velg en tidsperiode for å vise et sammendrag.',
  },
  periodicSummary: {
    cz: 'Periodický souhrn',
    de: 'Zeitraumzusammenfassung',
    en: 'Period summary',
    sv: 'Periodsammanfattning',
    fi: 'Jaksoyhteenveto',
    nb: 'Periodesammendrag',
  },
  displaying: {
    cz: 'Zobrazuje se',
    de: 'Anzeige',
    en: 'Displaying',
    sv: 'Visar',
    fi: 'Näytetään',
    nb: 'Viser',
  },
  mapLegend: {
    cz: 'Legenda',
    de: 'Legende',
    en: 'Legend',
    sv: 'Teckenförklaring',
    fi: 'Selite',
    nb: 'Tegnforklaring',
  },
  sensorsCountOne: {
    cz: '1 senzor',
    de: '1 Sensor',
    en: '1 sensor',
    sv: '1 sensor',
    fi: '1 anturi',
    nb: '1 sensor',
  },
  sensorsCount: {
    cz: '{{count}} senzorů',
    de: '{{count}} Sensoren',
    en: '{{count}} sensors',
    sv: '{{count}} sensorer',
    fi: '{{count}} anturia',
    nb: '{{count}} sensorer',
  },
  displayingSensors: {
    cz: 'Zobrazuje se {{count}} senzorů',
    de: '{{count}} Sensoren werden angezeigt',
    en: 'Displaying {{count}} sensors',
    sv: 'Visar {{count}} sensorer',
    fi: 'Näytetään {{count}} anturia',
    nb: 'Viser {{count}} sensorer',
  },
  displayingOneSensor: {
    cz: 'Zobrazuje se 1 senzor',
    de: '1 Sensor wird angezeigt',
    en: 'Displaying 1 sensor',
    sv: 'Visar 1 sensor',
    fi: 'Näytetään 1 anturi',
    nb: 'Viser 1 sensor',
  },
  displayingSensorsOfTotal: {
    cz: 'Zobrazuje se {{count}} z {{total}} senzorů',
    de: '{{count}} von {{total}} Sensoren werden angezeigt',
    en: 'Displaying {{count}} of {{total}} sensors',
    sv: 'Visar {{count}} av {{total}} sensorer',
    fi: 'Näytetään {{count}} / {{total}} anturista',
    nb: 'Viser {{count}} av {{total}} sensorer',
  },
  displayingOneOfSensors: {
    cz: 'Zobrazuje se 1 z {{total}} senzorů',
    de: '1 von {{total}} Sensoren wird angezeigt',
    en: 'Displaying 1 of {{total}} sensors',
    sv: 'Visar 1 av {{total}} sensorer',
    fi: 'Näytetään 1 / {{total}} anturista',
    nb: 'Viser 1 av {{total}} sensorer',
  },
  totalSensors: {
    cz: 'Celkem senzorů',
    de: 'Sensoren gesamt',
    en: 'Total sensors',
    sv: 'Totalt antal sensorer',
    fi: 'Antureita yhteensä',
    nb: 'Totalt antall sensorer',
  },
  sensorData: {
    cz: 'Data senzoru',
    de: 'Sensordaten',
    en: 'Sensor data',
    sv: 'Sensordata',
    fi: 'Anturitiedot',
    nb: 'Sensordata',
  },
  sensorId: {
    cz: 'ID senzoru',
    de: 'Sensor-ID',
    en: 'Sensor ID',
    sv: 'Sensor-ID',
    fi: 'Anturin ID',
    nb: 'Sensor-ID',
  },
  sensorIdDoesNotExist: {
    cz: 'ID senzoru neexistuje',
    de: 'Sensor-ID existiert nicht',
    en: 'Sensor ID does not exist',
    sv: 'Sensor-ID finns inte',
    fi: 'Anturin ID:tä ei ole olemassa',
    nb: 'Sensor-ID finnes ikke',
  },
  sensorIdWithHighestIndicator: {
    cz: 'ID senzoru (nejvyšší indikátor)',
    de: 'Sensor-ID (höchster Indikator)',
    en: 'Sensor ID (most critical status indicated)',
    sv: 'Sensor-ID (mest kritisk status indikerad)',
    fi: 'Anturin ID (kriittisin tila)',
    nb: 'Sensor-ID (mest kritisk status indikert)',
  },
  sensorInto: {
    cz: 'into® Sensor',
    de: 'into® Sensor',
    en: 'into® Sensor',
    sv: 'into® Sensor',
    fi: 'into® Sensor',
    nb: 'into® Sensor',
  },
  sensorLabel: {
    cz: 'Štítek senzoru',
    de: 'Sensorbezeichnung',
    en: 'Sensor Label',
    sv: 'Sensor Etikett',
    fi: 'Anturietiketti',
    nb: 'Sensor Etikett',
  },
  sensorMode: {
    cz: 'Režim senzoru',
    de: 'Sensor Modus',
    en: 'Sensor Mode',
    sv: 'Sensor Modus',
    fi: 'Anturitila',
    nb: 'Sensor Modus',
  },
  sensorModeWrong: {
    cz: 'Režim senzoru neodpovídá instalačnímu úkolu.',
    de: 'Der Sensormodus stimmt nicht mit der Installationsaufgabe überein.',
    en: "The sensor mode doesn't match the installation task.",
    sv: 'Sensormodus samsvarer inte med installationsuppgaven.',
    fi: "Anturi mode doesn't match  installation task.",
    nb: 'Sensormodus samsvarer ikke med installasjonsoppgaven.',
  },
  sensorPlacement: {
    cz: 'Umístění senzoru',
    de: 'Sensorplatzierung',
    en: 'Sensor Placement',
    sv: 'Sensorplassering',
    fi: 'Anturin sijoitus',
    nb: 'Sensorplassering',
  },
  sensorPlus: {
    cz: 'Senzor Plus',
    de: 'Sensor Plus',
    en: 'Sensor Plus',
    sv: 'Sensor Plus',
    fi: 'Sensor Plus',
    nb: 'Sensor Plus',
  },
  sensorPlusInto: {
    cz: 'into® Sensor Plus',
    de: 'into® Sensor Plus',
    en: 'into® Sensor Plus',
    sv: 'into® Sensor Plus',
    fi: 'into® Sensor Plus',
    nb: 'into® Sensor Plus',
  },
  sensorPro: {
    cz: 'Sensor Pro',
    de: 'Sensor Pro',
    en: 'Sensor Pro',
    sv: 'Sensor Pro',
    fi: 'Sensor Pro',
    nb: 'Sensor Pro',
  },
  sensorProInto: {
    cz: 'into® Sensor Pro',
    de: 'into® Sensor Pro',
    en: 'into® Sensor Pro',
    sv: 'into® Sensor Pro',
    fi: 'into® Sensor Pro',
    nb: 'into® Sensor Pro',
  },
  sensorPosition: {
    cz: 'Pozice senzoru',
    de: 'Sensorposition',
    en: 'Sensor position',
    sv: 'Sensorposisjon',
    fi: 'Anturin sijainti',
    nb: 'Sensorposisjon',
  },
  sensorProduct: {
    cz: 'Produkt senzoru',
    de: 'Sensorprodukt',
    en: 'Sensor product',
    sv: 'Sensorprodukt',
    fi: 'Anturituote',
    nb: 'Sensorprodukt',
  },
  sensorProductNotFound: {
    cz: 'Produkt senzoru nebyl nalezen',
    de: 'Sensorprodukt nicht gefunden',
    en: 'Sensor product not found',
    sv: 'Sensorprodukt inte funnet',
    fi: 'Anturituotetta ei löydy',
    nb: 'Sensorprodukt ikke funnet',
  },
  gatewayProductNotFound: {
    cz: 'Produkt gateway nebyl nalezen',
    de: 'Gateway-Produkt nicht gefunden',
    en: 'Gateway product not found',
    sv: 'Gateway-produkt inte funnet',
    fi: 'Yhdyskäytävätuotetta ei löydy',
    nb: 'Gateway-produkt ikke funnet',
  },
  sensorStates: {
    cz: 'Stavy senzorů',
    de: 'Sensorstatus',
    en: 'Sensor statuses',
    sv: 'Sensorstatus',
    fi: 'Anturien tilat',
    nb: 'Sensorstatus',
  },
  sensorStatus: {
    cz: 'Stav senzoru',
    de: 'Sensorstatus',
    en: 'Sensor status',
    sv: 'Sensorstatus',
    fi: 'Anturin tila',
    nb: 'Sensorstatus',
  },
  sensorStatusReferenceDate: {
    cz: 'Datum referenčního stavu senzoru',
    de: 'Sensorstatus-Referenzdatum',
    en: 'Sensor status reference date',
    sv: 'Sensor status referansedato',
    fi: 'Anturin tilan viitepäivämäärä',
    nb: 'Sensor status referansedato',
  },
  screwLength: {
    cz: 'Délka šroubu',
    de: 'Schraubenlänge',
    en: 'Screw length',
    sv: 'Skruvlängd',
    fi: 'Ruuvin pituus',
    nb: 'Skruelengde',
  },
  sensorTemperature: {
    cz: 'Teplota senzoru',
    de: 'Sensor-Temperatur',
    en: 'Sensor Temperature',
    sv: 'Sensor temperatur',
    fi: 'Anturin lämpötila',
    nb: 'Sensor temperatur',
  },
  sensorType: {
    cz: 'Typ senzoru',
    de: 'Sensortyp',
    en: 'Sensor type',
    sv: 'Sensortype',
    fi: 'Anturityyppi',
    nb: 'Sensortype',
  },
  selectSensorTypePositionForCharts: {
    cz: 'Pro zobrazení grafů vyberte typ / pozici senzoru',
    de: 'Sensortyp / Position auswählen, um Diagramme anzuzeigen',
    en: 'Select sensor type/position to display charts',
    sv: 'Välj sensortyp / position för att visa diagram',
    fi: 'Valitse anturityyppi / sijainti näyttääksesi kaaviot',
    nb: 'Velg sensortype / posisjon for å vise grafer',
  },
  sensorMetricNotSupported: {
    cz: 'Senzor tuto metriku nepodporuje',
    de: 'Dieser Sensor unterstützt diesen Messwert nicht',
    en: 'This sensor does not support this metric',
    sv: 'Den här sensorn stöder inte detta mätvärde',
    fi: 'Tämä anturi ei tue tätä mittaria',
    nb: 'Denne sensoren støtter ikke denne målingen',
  },
  sensorTypePosition: {
    cz: 'Typ / pozice senzoru',
    de: 'Sensortyp / Position',
    en: 'Sensor type / position',
    sv: 'Sensortyp / position',
    fi: 'Anturityyppi / sijainti',
    nb: 'Sensortype / posisjon',
  },
  sensors: {
    cz: 'Senzory',
    de: 'Sensoren',
    en: 'Sensors',
    sv: 'Sensorer',
    fi: 'Anturit',
    nb: 'Sensorer',
  },
  settings: {
    cz: 'Nastavení',
    de: 'Einstellungen',
    en: 'Settings',
    sv: 'Inställningar',
    fi: 'Asetukset',
    nb: 'Innstillinger',
  },
  showCountOf: {
    cz: 'Zobrazení {{showCount}} z {{total}}',
    de: 'Anzeigen von {{showCount}} von {{total}}',
    en: 'Showing {{showCount}} of {{total}}',
    sv: 'Visaer {{showCount}} av {{total}}',
    fi: 'Näytetään {{showCount}} / {{total}}',
    nb: 'Viser {{showCount}} av {{total}}',
  },
  showProjects: {
    cz: 'Zobrazit projekty',
    de: 'Projekte anzeigen',
    en: 'Show projects',
    sv: 'Visa projekter',
    fi: 'Näytä projektit',
    nb: 'Vis prosjekter',
  },
  signalStrength: {
    cz: 'Síla Signálu',
    de: 'Signalstärke',
    en: 'Signal Strength',
    sv: 'Signalstyrke',
    fi: 'Signaalin voimakkuus',
    nb: 'Signalstyrke',
  },
  sms: {
    cz: 'SMS',
    de: 'SMS',
    en: 'SMS',
    sv: 'SMS',
    fi: 'SMS',
    nb: 'SMS',
  },
  solarPanels: {
    cz: 'Solární panely',
    de: 'Solarmodule',
    en: 'Solar panels',
    sv: 'Solcellepaneler',
    fi: 'Aurinkopaneelit',
    nb: 'Solcellepaneler',
  },
  sortBy: {
    cz: 'Seřadit podle',
    de: 'Sortieren nach',
    en: 'Sort by',
    sv: 'Sorter etter',
    fi: 'Lajittele',
    nb: 'Sorter etter',
  },
  sortOrder: {
    cz: 'Pořadí řazení',
    de: 'Sortierreihenfolge',
    en: 'Sort order',
    sv: 'Sorteringsordning',
    fi: 'Lajittelujärjestys',
    nb: 'Sorteringsrekkefølge',
  },
  spruce: {
    cz: 'Smrk',
    de: 'Fichte',
    en: 'Spruce',
    sv: 'Gran',
    fi: 'Kuusi',
    nb: 'Gran',
  },
  stage: {
    cz: 'Fáze',
    de: 'Phase',
    en: 'Stage',
    sv: 'Fas',
    fi: 'Vaihe',
    nb: 'Fase',
  },
  standardReportPartSummary: {
    cz: 'into® Control System vám poskytuje přehled o stavu budovy s ohledem na stavební vlhkost, teplotní odchylky, kondenzaci, přirozené sezónní výkyvy a úniková místa. Náš generátor zpráv využívá přizpůsobené algoritmy pro různé stavební části, což vám poskytuje přesné indikace příčinných souvislostí před vznikem větších škod a zároveň měří účinnost přijatých opatření.',
    de: 'Das into® Control System gibt Ihnen Einblick in den Zustand Ihres Gebäudes in Bezug auf Baufeuchte, Temperaturschwankungen, Kondensation, natürliche saisonale Veränderungen und Leckagestellen. Unser Berichtsgenerator verwendet maßgeschneiderte Algorithmen für verschiedene Gebäudeteile, die Ihnen präzise Hinweise auf Ursachen liefern, bevor größere Schäden entstehen, und gleichzeitig die Wirksamkeit ergriffener Maßnahmen messen.',
    en: 'The into® Control System provides insight into the condition of your project with regard to construction moisture, temperature deviations, condensation, natural seasonal variations, and leakage points. Our report generator uses tailored algorithms for different project components, giving you precise indications of causal relationships before major damage occurs, while also measuring the effectiveness of implemented measures.',
    sv: 'into® Control System ger dig insikt i projektets skick med avseende på byggfukt, temperaturavvikelser, kondens, naturliga säsongsvariationer och läckagepunkter. Vår rapportgenerator använder skräddarsydda algoritmer för olika projektdelar, vilket ger dig tydliga indikationer på orsakssamband innan större skador uppstår, samtidigt som effekten av genomförda åtgärder mäts.',
    fi: 'into® Control System tarjoaa näkymän projektisi tilaan rakennuskosteuden, lämpötilapoikkeamien, kondensaation, luonnollisten vuodenaikavaihtelujen ja vuotokohtien osalta. Raporttigeneraattorimme käyttää erilaisille projektin osille räätälöityjä algoritmeja, antaen sinulle tarkkoja indikaatioita syy-yhteyksistä ennen kuin suurempia vahinkoja syntyy, ja samalla mittaa toteutettujen toimenpiteiden vaikuttavuutta.',
    nb: 'into® Control System gir deg innsikt i byggets tilstand med hensyn til byggfukt, temperaturavvik, kondensering, naturlige årsvariasjoner og lekkasjepunkter. Vår rapportgenerator bruker skreddersydde algoritmer for ulike bygningsdeler, noe som gir deg presise indikasjoner på årsakssammenhenger før større skader oppstår, samt måler effekten av iverksatte tiltak.',
  },
  startDate: {
    cz: 'Počáteční datum',
    de: 'Startdatum',
    en: 'Start date',
    sv: 'Startdatum',
    fi: 'Aloituspäivä',
    nb: 'Startdato',
  },
  statistics: {
    cz: 'Statistiky',
    de: 'Statistiken',
    en: 'Statistics',
    sv: 'Statistik',
    fi: 'Tilastot',
    nb: 'Statistikk',
  },
  status: {
    cz: 'Stav',
    de: 'Status',
    en: 'Status',
    sv: 'Status',
    fi: 'Tila',
    nb: 'Status',
  },
  stopScan: {
    cz: 'Zastavit skenování',
    de: 'Scanvorgang stoppen',
    en: 'Stop scan',
    sv: 'Stupp skanning',
    fi: 'Lopeta skannaus',
    nb: 'Stopp skanning',
  },
  submit: {
    cz: 'Odeslat',
    de: 'Einreichen',
    en: 'Submit',
    sv: 'Skicka in',
    fi: 'Lähetä',
    nb: 'Skicka in',
  },
  summary: {
    cz: 'Shrnutí',
    de: 'Zusammenfassung',
    en: 'Summary',
    sv: 'Sammanfattning',
    fi: 'Yhteenveto',
    nb: 'Oppsummering',
  },
  tableOfContents: {
    cz: 'Obsah',
    de: 'Inhaltsverzeichnis',
    en: 'Table of contents',
    sv: 'Innehållsförteckning',
    fi: 'Sisällysluettelo',
    nb: 'Innholdsfortegnelse',
  },
  takePhoto: {
    cz: 'Pořídit fotografii',
    de: 'Foto aufnehmen',
    en: 'Take photo',
    sv: 'Ta foto',
    fi: 'Ota kuva',
    nb: 'Ta bilde',
  },
  team: {
    cz: 'Tým',
    de: 'Team',
    en: 'Team',
    sv: 'Team',
    fi: 'Tiimi',
    nb: 'Team',
  },
  technicalStatusReport: {
    cz: 'Technický stav zprávy',
    de: 'Technischer Statusbericht',
    en: 'Technical status report',
    sv: 'Teknisk statusrapport',
    fi: 'Tekninen tilanneraportti',
    nb: 'Teknisk statusrapport',
  },
  temperature: {
    cz: 'Teplota',
    de: 'Temperatur',
    en: 'Temperature',
    sv: 'Temperatur',
    fi: 'Lämpötila',
    nb: 'Temperatur',
  },
  temperatureAlert: {
    cz: 'Upoz o teplotě',
    de: 'Temperaturalarm',
    en: 'Temperature alert',
    sv: 'Temperaturalarm',
    fi: 'Lämpötilahälytys',
    nb: 'Temperaturalarm',
  },
  temperatureAvg: {
    cz: 'Průměrná teplota',
    de: 'Durchschnittstemperatur',
    en: 'Average temperature',
    sv: 'Genomsnittlig temperatur',
    fi: 'Keskimääräinen lämpötila',
    nb: 'Gjennomsnittstemperatur',
  },
  temperatureExplanation: {
    cz: 'měří okolní teplotu na místě, kde je senzor namontován',
    de: 'misst die Umgebungstemperatur am Punkt, an dem der Sensor montiert ist',
    en: 'measures ambient temperature at the point where the sensor is mounted',
    sv: 'mäter omgivningstemperaturen vid den punkt där sensorn är monterad',
    fi: 'mittaa ympäristön lämpötilaa kohdassa,  johon anturi on asennettu',
    nb: 'måler omgivende temperatur i det punktet sensoren er montert',
  },
  temperatureExplanation2: {
    cz: 'používá teplotu v oblasti, kde jsou senzory umístěny',
    de: 'verwendet die Temperatur in dem Bereich, in dem die Sensoren lokalisiert sind',
    en: 'uses the temperature in the area where the sensors are located',
    sv: 'använder temperaturen i området där sensorerna är placerade',
    fi: 'käyttää anturien sijaintialueen lämpötilaa',
    nb: 'benytter temperaturen i området sensorene er lokalisert',
  },
  terraceDeck: {
    cz: 'Terasové desky',
    de: 'Terrassedeck',
    en: 'Terrace deck',
    sv: 'Terrasse',
    fi: 'Terassi',
    nb: 'Terrasse',
  },
  thisActionCannotBeUndone: {
    cz: 'Tuto akci nelze vrátit zpět.',
    de: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    en: 'This action cannot be undone.',
    sv: 'Den här handlingen kan inte angres.',
    fi: 'Tätä toimintoa ei voi peruuttaa.',
    nb: 'Denne handlingen kan ikke angres.',
  },
  timePeriod: {
    cz: 'Časové období',
    de: 'Zeitraum',
    en: 'Time Period',
    sv: 'Tidsperiode',
    fi: 'Ajanjakso',
    nb: 'Tidsperiode',
  },
  timeRange: {
    cz: 'Časový rozsah',
    de: 'Zeitspanne',
    en: 'Time range',
    sv: 'Tidsperiode',
    fi: 'Aikaväli',
    nb: 'Tidsperiode',
  },
  timezone: {
    cz: 'Časové pásmo',
    de: 'Zeitzone',
    en: 'Timezone',
    sv: 'Tidssone',
    fi: 'Aikavyöhyke',
    nb: 'Tidssone',
  },
  to: {
    cz: 'Do',
    de: 'Bis',
    en: 'To',
    sv: 'Til',
    fi: 'Asti',
    nb: 'Til',
  },
  toMainContent: {
    cz: 'Přejít na hlavní obsah',
    de: 'Zum Hauptinhalt wechseln',
    en: 'Go to main content',
    sv: 'Gå till huvudinnehål',
    fi: 'Siirry pääsisältöön',
    nb: 'Gå til hovedinnhold',
  },
  trendAnalysis: {
    cz: 'Analýza trendů',
    de: 'Trendanalyse',
    en: 'Trend analysis',
    sv: 'Trendanalyse',
    fi: 'Trendianalyysi',
    nb: 'Trendanalyse',
  },
  trends: {
    cz: 'Trendy',
    de: 'Trends',
    en: 'Trends',
    sv: 'Trender',
    fi: 'Trendit',
    nb: 'Trender',
  },
  trp: {
    cz: 'TRP / Ocelový plech / Hluboké profily palub',
    de: 'TRP / Stahlblech / Tiefe Deckprofile',
    en: 'TRP / Steel sheet / Deep deck profiles',
    sv: 'TRP / Stålplater / Dype dekkprofiler',
    fi: 'TRP / poimulevy / syväkantiset profiilit',
    nb: 'TRP / Stålplater / Dype dekkprofiler',
  },
  trpSteelSheetDeepDecKProfiles: {
    cz: 'TRP / Ocelový plech / Hluboké profily palub',
    de: 'TRP / Stahlblech / Tiefe Deckprofile',
    en: 'TRP / Steel sheet / Deep deck profiles',
    sv: 'TRP / Stålplater / Dype dekkprofiler',
    fi: 'TRP / poimulevy / syväkantiset profiilit',
    nb: 'TRP / Stålplater / Dype dekkprofiler',
  },
  uValue: {
    cz: 'U-hodnota',
    de: 'U-Wert',
    en: 'U-value',
    sv: 'U-verdi',
    fi: 'U-arvo',
    nb: 'U-verdi',
  },
  undo: {
    cz: 'Zpět',
    de: 'Abbrechen',
    en: 'Undo',
    sv: 'Ångra',
    fi: 'Kumoa',
    nb: 'Angre',
  },
  unknown: {
    cz: 'Neznámý',
    de: 'Unbekannt',
    en: 'Unknown',
    sv: 'Okänd',
    fi: 'Tuntematon',
    nb: 'Ukjent',
  },
  unselectAll: {
    cz: 'Zrušit výběr všech',
    de: 'Auswahl aufheben',
    en: 'Unselect all',
    sv: 'Ta bort alla val',
    fi: 'Poista kaikki valinnat',
    nb: 'Fjern alle valg',
  },
  update: {
    cz: 'Aktualizovat',
    de: 'Aktualisieren',
    en: 'Update',
    sv: 'Uppdatera',
    fi: 'Päivitä',
    nb: 'Oppdater',
  },
  updated: {
    cz: 'Aktualizováno',
    de: 'Aktualisiert',
    en: 'Updated',
    sv: 'Uppdaterat',
    fi: 'Päivitetty',
    nb: 'Oppdatert',
  },
  updates: {
    cz: 'Aktualizace',
    de: 'Aktualisierungen',
    en: 'Updates',
    sv: 'Uppdaterainger',
    fi: 'Päivitykset',
    nb: 'Oppdateringer',
  },
  importJsonAddMode: {
    cz: 'Přidat importovaná zařízení do plánu',
    de: 'Importierte Geräte zur Planung hinzufügen',
    en: 'Add imported devices to planning',
    sv: 'Lägg till importerade enheter i planeringen',
    fi: 'Lisää tuodut laitteet suunnitelmaan',
    nb: 'Legg importerte enheter til planen',
  },
  importJsonApply: {
    cz: 'Importovat zařízení',
    de: 'Geräte importieren',
    en: 'Import devices',
    sv: 'Importera enheter',
    fi: 'Tuo laitteet',
    nb: 'Importer enheter',
  },
  importJsonFilterGroups: {
    cz: 'Filtrovat skupiny zařízení',
    de: 'Gerätegruppen filtern',
    en: 'Filter device groups',
    sv: 'Filtrera enhetsgrupper',
    fi: 'Suodata laiteryhmiä',
    nb: 'Filtrer enhetsgrupper',
  },
  importJsonFilterHelp: {
    cz: 'Ponechte prázdné pro zahrnutí všech importovatelných zařízení.',
    de: 'Leer lassen, um alle importierbaren Geräte einzubeziehen.',
    en: 'Leave empty to include all importable devices.',
    sv: 'Lämna tomt för att inkludera alla importerbara enheter.',
    fi: 'Jätä tyhjäksi, jos haluat sisällyttää kaikki tuotavat laitteet.',
    nb: 'La stå tomt for å inkludere alle importerbare enheter.',
  },
  importJsonFilterNoTags: {
    cz: 'V tomto souboru JSON nebyly nalezeny žádné IFC tagy.',
    de: 'In dieser JSON-Datei wurden keine IFC-Tags gefunden.',
    en: 'No IFC tags were found in this JSON file.',
    sv: 'Inga IFC-taggar hittades i den här JSON-filen.',
    fi: 'Tästä JSON-tiedostosta ei löytynyt IFC-tageja.',
    nb: 'Ingen IFC-tagger ble funnet i denne JSON-filen.',
  },
  importJsonFilterTags: {
    cz: 'Filtrovat IFC tagy',
    de: 'IFC-Tags filtern',
    en: 'Filter IFC tags',
    sv: 'Filtrera IFC-taggar',
    fi: 'Suodata IFC-tagit',
    nb: 'Filtrer IFC-tagger',
  },
  importJsonGroups: {
    cz: 'Importní skupiny',
    de: 'Importgruppen',
    en: 'Import groups',
    sv: 'Importgrupper',
    fi: 'Tuontiryhmät',
    nb: 'Importgrupper',
  },
  importJsonIgnoredRows: {
    cz: 'Ignorované řádky',
    de: 'Ignorierte Zeilen',
    en: 'Ignored rows',
    sv: 'Ignorerade rader',
    fi: 'Ohitetut rivit',
    nb: 'Ignorerte rader',
  },
  importJsonImportableRows: {
    cz: 'Importovatelné řádky',
    de: 'Importierbare Zeilen',
    en: 'Importable rows',
    sv: 'Importerbara rader',
    fi: 'Tuotavat rivit',
    nb: 'Importerbare rader',
  },
  importJsonMapNotReady: {
    cz: 'Před importem JSON počkejte, až se načte instalační mapa.',
    de: 'Warten Sie, bis die Installationskarte geladen ist, bevor Sie JSON importieren.',
    en: 'Wait for the installation map to load before importing JSON.',
    sv: 'Vänta tills installationskartan har laddats innan du importerar JSON.',
    fi: 'Odota, että asennuskartta latautuu ennen JSON-tuontia.',
    nb: 'Vent til installasjonskartet er lastet før du importerer JSON.',
  },
  importJsonMatchingExisting: {
    cz: 'Odpovídající již plánovaná zařízení',
    de: 'Passende bereits geplante Geräte',
    en: 'Matching existing planned devices',
    sv: 'Matchande redan planerade enheter',
    fi: 'Vastaavat jo suunnitellut laitteet',
    nb: 'Matchende eksisterende planlagte enheter',
  },
  importJsonNoImportableRows: {
    cz: 'V tomto souboru JSON nebyla nalezena žádná importovatelná zařízení.',
    de: 'In dieser JSON-Datei wurden keine importierbaren Geräte gefunden.',
    en: 'No importable devices were found in this JSON file.',
    sv: 'Inga importerbara enheter hittades i den här JSON-filen.',
    fi: 'Tästä JSON-tiedostosta ei löytynyt tuotavia laitteita.',
    nb: 'Ingen importerbare enheter ble funnet i denne JSON-filen.',
  },
  importJsonNoTag: {
    cz: 'Bez tagu',
    de: 'Kein Tag',
    en: 'No tag',
    sv: 'Ingen tagg',
    fi: 'Ei tagia',
    nb: 'Ingen tag',
  },
  importJsonOperation: {
    cz: 'Operace importu',
    de: 'Importvorgang',
    en: 'Import operation',
    sv: 'Importåtgärd',
    fi: 'Tuontitoiminto',
    nb: 'Importhandling',
  },
  importJsonReplaceMatchingMode: {
    cz: 'Smazat odpovídající plánovaná zařízení a poté importovat',
    de: 'Passende geplante Geräte löschen und dann importieren',
    en: 'Delete matching planned devices, then import',
    sv: 'Ta bort matchande planerade enheter och importera sedan',
    fi: 'Poista vastaavat suunnitellut laitteet ja tuo sen jälkeen',
    nb: 'Slett matchende planlagte enheter, og importer deretter',
  },
  importJsonReplaceMismatchWarning: {
    cz: 'Upozornění: tento nahrazovací import smaže {{deletedCount}} existujících plánovaných zařízení a přidá {{addedCount}} zařízení z JSON.',
    de: 'Warnung: Dieser Ersetzungsimport löscht {{deletedCount}} bestehende geplante Geräte und fügt {{addedCount}} Geräte aus der JSON-Datei hinzu.',
    en: 'Warning: this replace import will delete {{deletedCount}} existing planned devices and add {{addedCount}} devices from JSON.',
    sv: 'Varning: den här ersättningsimporten kommer att radera {{deletedCount}} befintliga planerade enheter och lägga till {{addedCount}} enheter från JSON.',
    fi: 'Varoitus: tämä korvaava tuonti poistaa {{deletedCount}} olemassa olevaa suunniteltua laitetta ja lisää {{addedCount}} laitetta JSON-tiedostosta.',
    nb: 'Advarsel: denne erstatningsimporten vil slette {{deletedCount}} eksisterende planlagte enheter og legge til {{addedCount}} enheter fra JSON.',
  },
  importJsonSaveTagAsLabel: {
    cz: 'Uložit IFC tag jako štítek zařízení',
    de: 'IFC-Tag als Gerätebezeichnung speichern',
    en: 'Save IFC tag as device label',
    sv: 'Spara IFC-tagg som enhetsetikett',
    fi: 'Tallenna IFC-tagi laitteen etiketiksi',
    nb: 'Lagre IFC-tag som enhetsetikett',
  },
  importJsonSourceObjectTypes: {
    cz: 'Typy zdrojových objektů',
    de: 'Quellobjekttypen',
    en: 'Source object types',
    sv: 'Källobjektstyper',
    fi: 'Lähdeobjektityypit',
    nb: 'Kildeobjekttyper',
  },
  importJsonSourceTags: {
    cz: 'Zdrojové tagy',
    de: 'Quell-Tags',
    en: 'Source tags',
    sv: 'Källtaggar',
    fi: 'Lähdetagit',
    nb: 'Kildetagger',
  },
  importJsonSummary: {
    cz: 'Souhrn importu',
    de: 'Importübersicht',
    en: 'Import summary',
    sv: 'Importsammanfattning',
    fi: 'Tuonnin yhteenveto',
    nb: 'Importsammendrag',
  },
  importJsonTotalRows: {
    cz: 'Celkový počet řádků',
    de: 'Gesamtzeilen',
    en: 'Total rows',
    sv: 'Totalt antal rader',
    fi: 'Rivejä yhteensä',
    nb: 'Totale rader',
  },
  importJsonUnsavedChanges: {
    cz: 'Před importem JSON uložte nebo vraťte své aktuální změny v plánu.',
    de: 'Speichern oder verwerfen Sie Ihre aktuellen Planungsänderungen, bevor Sie JSON importieren.',
    en: 'Save or undo your current planning changes before importing JSON.',
    sv: 'Spara eller ångra dina nuvarande planeringsändringar innan du importerar JSON.',
    fi: 'Tallenna tai kumoa nykyiset suunnittelumuutokset ennen JSON-tuontia.',
    nb: 'Lagre eller angre de nåværende planendringene før du importerer JSON.',
  },
  importJsonWarnings: {
    cz: 'Upozornění importu',
    de: 'Importwarnungen',
    en: 'Import warnings',
    sv: 'Importvarningar',
    fi: 'Tuonnin varoitukset',
    nb: 'Importadvarsler',
  },
  jsonFile: {
    cz: 'Soubor JSON',
    de: 'JSON-Datei',
    en: 'JSON file',
    sv: 'JSON-fil',
    fi: 'JSON-tiedosto',
    nb: 'JSON-fil',
  },
  upload: {
    cz: 'Nahrát',
    de: 'Hochladen',
    en: 'Upload',
    sv: 'Ladda upp',
    fi: 'Lataa',
    nb: 'Last opp',
  },
  uploadConnectionFailed: {
    cz: 'Spojení při nahrávání selhalo. Zkuste to znovu. Pokud problém přetrvává, kontaktujte podporu.',
    de: 'Die Verbindung beim Hochladen ist fehlgeschlagen. Versuchen Sie es erneut. Falls das Problem weiterhin besteht, kontaktieren Sie den Support.',
    en: 'The upload connection failed. Try again. If it keeps happening, contact support.',
    sv: 'Anslutningen misslyckades vid uppladdningen. Försök igen. Kontakta support om det fortsätter.',
    fi: 'Yhteys katkesi latauksen aikana. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä tukeen.',
    nb: 'Tilkoblingen feilet under opplasting. Prøv igjen. Kontakt brukerstøtte hvis det fortsetter.',
  },
  uploadDocumentation: {
    cz: 'Nahrát dokumentaci',
    de: 'Dokumentation hochladen',
    en: 'Upload documentation',
    sv: 'Ladda upp dokumentation',
    fi: 'Lataa dokumentaatio',
    nb: 'Last opp dokumentasjon',
  },
  uploadInstallationPhoto: {
    cz: 'Nahrát instalační fotografii',
    de: 'Installationsfoto hochladen',
    en: 'Upload installation photo',
    sv: 'Ladda upp installationsbild',
    fi: 'Lataa asennuskuva',
    nb: 'Last opp installasjonsbilde',
  },
  uploadJson: {
    cz: 'Nahrát plánovací JSON',
    de: 'Planungs-JSON hochladen',
    en: 'Upload planning JSON',
    sv: 'Ladda upp planerings-JSON',
    fi: 'Lataa suunnittelu-JSON',
    nb: 'Last opp planleggings-JSON',
  },
  uploadNewContextImg: {
    cz: 'Nahrajte nový kontextový obrázek',
    de: 'Neues Kontextbild hochladen',
    en: 'Upload new context image',
    sv: 'Ladda upp ny kontextbild',
    fi: 'Lataa uusi yleiskuva',
    nb: 'Last opp nytt kontekstbilde',
  },
  uploadNewInstallationMap: {
    cz: 'Nahrajte novou instalační mapu',
    de: 'Neue Installationskarte hochladen',
    en: 'Upload new installation map',
    sv: 'Ladda upp ny installationskarta',
    fi: 'Lataa uusi asennuskartta',
    nb: 'Last opp nytt installasjonskart',
  },
  uploadNotAllowed: {
    cz: 'Nemáte oprávnění nahrávat fotografie do tohoto projektu.',
    de: 'Sie haben keine Berechtigung, Fotos in dieses Projekt hochzuladen.',
    en: 'You do not have permission to upload photos to this project.',
    sv: 'Du har inte behörighet att ladda upp foton till det här projektet.',
    fi: 'Sinulla ei ole oikeutta ladata kuvia tähän projektiin.',
    nb: 'Du har ikke tilgang til å laste opp bilder til dette prosjektet.',
  },
  uploadTooLarge: {
    cz: 'Soubor je pro server příliš velký. Vyberte menší fotografii.',
    de: 'Die Datei ist für den Server zu groß. Wählen Sie ein kleineres Foto.',
    en: 'The file is too large for the server. Select a smaller photo.',
    sv: 'Filen är för stor för servern. Välj ett mindre foto.',
    fi: 'Tiedosto on liian suuri palvelimelle. Valitse pienempi kuva.',
    nb: 'Filen er for stor for serveren. Velg et mindre bilde.',
  },
  user: {
    cz: 'Uživatel',
    de: 'Benutzer',
    en: 'User',
    sv: 'Användare',
    fi: 'Käyttäjä',
    nb: 'Bruker',
  },
  userAlreadyExists: {
    cz: 'Uživatel již existuje',
    de: 'Benutzer existiert bereits',
    en: 'User already exists',
    sv: 'Användare finns redan',
    fi: 'Käyttäjä on jo olemassa',
    nb: 'Bruker eksisterer allerede',
  },
  users: {
    cz: 'Uživatelé',
    de: 'Benutzer',
    en: 'Users',
    sv: 'Användare',
    fi: 'Käyttäjät',
    nb: 'Brukere',
  },
  invites: {
    cz: 'Pozvánky',
    de: 'Einladungen',
    en: 'Invites',
    sv: 'Invitasjoner',
    fi: 'Kutsut',
    nb: 'Invitasjoner',
  },
  pendingInvitations: {
    cz: 'Čekající pozvánky',
    de: 'Ausstehende Einladungen',
    en: 'Pending invitations',
    sv: 'Väntande inbjudningar',
    fi: 'Odottavat kutsut',
    nb: 'Ventende invitasjoner',
  },
  pendingInvitationsDescription: {
    cz: 'Uživatelé se po přijetí pozvánky zobrazí níže.',
    de: 'Benutzer werden unten angezeigt, nachdem sie die Einladung angenommen haben.',
    en: 'Users appear below after accepting the invitation.',
    sv: 'Användare visas nedan efter att de har accepterat inbjudan.',
    fi: 'Käyttäjät näkyvät alla hyväksyttyään kutsun.',
    nb: 'Brukere vises nedenfor etter at de har akseptert invitasjonen.',
  },
  inviteUser: {
    cz: 'Pozvat uživatele',
    de: 'Benutzer einladen',
    en: 'Invite user',
    sv: 'Inviter användare',
    fi: 'Kutsu käyttäjä',
    nb: 'Inviter bruker',
  },
  inviteStatusPending: {
    cz: 'Čekající',
    de: 'Ausstehend',
    en: 'Pending',
    sv: 'Väntande',
    fi: 'Odottaa',
    nb: 'Venter',
  },
  inviteStatusRegistered: {
    cz: 'Nastavení není dokončeno',
    de: 'Einrichtung unvollständig',
    en: 'Setup incomplete',
    sv: 'Konfigurering ofullständig',
    fi: 'Käyttöönotto kesken',
    nb: 'Oppsett ikke fullført',
  },
  inviteStatusCompleted: {
    cz: 'Dokončeno',
    de: 'Abgeschlossen',
    en: 'Completed',
    sv: 'Slutförd',
    fi: 'Valmis',
    nb: 'Fullført',
  },
  inviteStatusCancelled: {
    cz: 'Zrušeno',
    de: 'Storniert',
    en: 'Cancelled',
    sv: 'Avbruten',
    fi: 'Peruttu',
    nb: 'Kansellert',
  },
  invitationDeletedSuccess: {
    cz: 'Pozvánka byla úspěšně smazána.',
    de: 'Einladung erfolgreich gelöscht.',
    en: 'Invitation deleted successfully.',
    sv: 'Invitasjonen ble ta bortt.',
    fi: 'Kutsu poistettu onnistuneesti.',
    nb: 'Invitasjonen ble slettet.',
  },
  invitationResentSuccess: {
    cz: 'Pozvánka byla úspěšně znovu odeslána.',
    de: 'Einladung erfolgreich erneut gesendet.',
    en: 'Invitation resent successfully.',
    sv: 'Invitasjonen ble sendt på nytt.',
    fi: 'Kutsu lähetetty uudelleen onnistuneesti.',
    nb: 'Invitasjonen ble sendt på nytt.',
  },
  inviteLinkCopiedSuccess: {
    cz: 'Odkaz na pozvánku byl zkopírován.',
    de: 'Einladungslink kopiert.',
    en: 'Invite link copied.',
    sv: 'Inbjudningslänken kopierades.',
    fi: 'Kutsulinkki kopioitu.',
    nb: 'Invitasjonslenken ble kopiert.',
  },
  inviteLinkCopyError: {
    cz: 'Odkaz na pozvánku se nepodařilo zkopírovat.',
    de: 'Einladungslink konnte nicht kopiert werden.',
    en: 'Could not copy invite link.',
    sv: 'Kunde inte kopiera inbjudningslänken.',
    fi: 'Kutsulinkin kopiointi epäonnistui.',
    nb: 'Kunne ikke kopiere invitasjonslenken.',
  },
  onboardingReminderSentSuccess: {
    cz: 'Připomenutí dokončení nastavení bylo odesláno.',
    de: 'Erinnerung zum Abschließen der Einrichtung gesendet.',
    en: 'Setup reminder sent successfully.',
    sv: 'Påminnelse om att slutföra konfigureringen skickades.',
    fi: 'Käyttöönoton viimeistelymuistutus lähetettiin.',
    nb: 'Påminnelse om å fullføre oppsettet ble sendt.',
  },
  invitationSentSuccess: {
    cz: 'Pozvánka byla úspěšně odeslána.',
    de: 'Einladung erfolgreich gesendet.',
    en: 'Invitation sent successfully.',
    sv: 'Invitasjonen ble sendt.',
    fi: 'Kutsu lähetetty onnistuneesti.',
    nb: 'Invitasjonen ble sendt.',
  },
  invitationSentSuccessUsersList: {
    cz: 'Pozvánka byla úspěšně odeslána. Uživatel se zobrazí v seznamu uživatelů po přijetí pozvánky.',
    de: 'Einladung erfolgreich gesendet. Der Benutzer wird in der Benutzerliste angezeigt, sobald die Einladung angenommen wurde.',
    en: 'Invitation sent successfully. The user will appear in the user list after the invitation is accepted.',
    sv: 'Invitasjonen ble sendt. Brukeren vises i brukerlisten når invitasjonen er akseptert.',
    fi: 'Kutsu lähetettiin onnistuneesti. Käyttäjä näkyy käyttäjälistassa, kun kutsu on hyväksytty.',
    nb: 'Invitasjonen ble sendt. Brukeren vises i brukerlisten når invitasjonen er akseptert.',
  },
  noPendingInvitations: {
    cz: 'Žádné čekající pozvánky',
    de: 'Keine ausstehenden Einladungen',
    en: 'No pending invitations',
    sv: 'Ingen ventende invitasjoner',
    fi: 'Ei odottavia kutsuja',
    nb: 'Ingen ventende invitasjoner',
  },
  projectUsers: {
    cz: 'Uživatelé projektu',
    de: 'Projektbenutzer',
    en: 'Project users',
    sv: 'Projektanvändare',
    fi: 'Projektin käyttäjät',
    nb: 'Prosjektbrukere',
  },
  projectUsersDescription: {
    cz: 'Aktivní uživatelé s přístupem k tomuto projektu.',
    de: 'Aktive Benutzer mit Zugriff auf dieses Projekt.',
    en: 'Active users with access to this project.',
    sv: 'Aktiva användare med åtkomst till detta projekt.',
    fi: 'Aktiiviset käyttäjät, joilla on pääsy tähän projektiin.',
    nb: 'Aktive brukere med tilgang til dette prosjektet.',
  },
  multiple: {
    cz: 'Více',
    de: 'Mehrere',
    en: 'Multiple',
    sv: 'Flera',
    fi: 'Useita',
    nb: 'Flere',
  },
  vacuumRoof: {
    cz: 'Vakuová střecha',
    de: 'Vakuumdach',
    en: 'Vacuum roof',
    sv: 'Vakuumtak',
    fi: 'Vakuumikatto',
    nb: 'Vakuumtak',
  },
  vaporBarrier: {
    cz: 'Parozábrana',
    de: 'Dampfsperre',
    en: 'Vapor barrier',
    sv: 'Fuktspärr',
    fi: 'Höyrynsulku',
    nb: 'Damp Sperre',
  },
  vatNr: {
    cz: 'DIČ',
    de: 'USt-IdNr.',
    en: 'VAT number',
    sv: 'Organisationsnummer',
    fi: 'ALV-numero',
    nb: 'Organisasjonsnummer',
  },
  ventCap: {
    cz: 'Větrací hlavice',
    de: 'Lüftungshaube',
    en: 'Ventilation cap',
    sv: 'Ventilasjonshette',
    fi: 'Tuuletushattu',
    nb: 'Ventilasjonshette',
  },
  ventCapInto: {
    cz: 'Větrací hlavice',
    de: 'Lüftungshaube',
    en: 'Ventilation cap',
    sv: 'Ventilasjonshette',
    fi: 'Tuuletushattu',
    nb: 'Ventilasjonshette',
  },
  ventCapType: {
    cz: 'Typ větrací hlavice',
    de: 'Typ Lüftungshaube',
    en: 'Ventilation cap type',
    sv: 'Type ventilasjonshette',
    fi: 'Tuuletushatun tyyppi',
    nb: 'Type ventilasjonshette',
  },
  installationDate: {
    cz: 'Datum instalace',
    de: 'Installationsdatum',
    en: 'Installation date',
    sv: 'Installationsdatum',
    fi: 'Asennuspäivä',
    nb: 'Monteringsdato',
  },
  ventCapSize: {
    cz: 'Velikost větrací hlavice (mm)',
    de: 'Größe der Lüftungshaube (mm)',
    en: 'Ventilation cap size (mm)',
    sv: 'Storlek på ventilationshatt (mm)',
    fi: 'Tuuletushatun koko (mm)',
    nb: 'Størrelse på ventilasjonshette (mm)',
  },
  ventCapCustomSize: {
    cz: 'Egen størrelse (mm)',
    de: 'Benutzerdefinierte Größe (mm)',
    en: 'Custom size (mm)',
    sv: 'Egendef inierad storlek (mm)',
    fi: 'Mukautettu koko (mm)',
    nb: 'Egendefinert størrelse (mm)',
  },
  customSize: {
    cz: 'Egen størrelse',
    de: 'Benutzerdefinierte Größe',
    en: 'Custom size',
    sv: 'Egendef inierad storlek',
    fi: 'Mukautettu koko',
    nb: 'Egendefinert størrelse',
  },
  ventilatedPitchedRoof: {
    cz: 'Větraná šikmá střecha',
    de: 'Belüftetes Satteldach',
    en: 'Ventilated pitched roof',
    sv: 'Luftet skråtak',
    fi: 'Tuulettuva harjakatto',
    nb: 'Luftet skråtak',
  },
  viewDetails: {
    cz: 'Zobrazit podrobnosti',
    de: 'Details anzeigen',
    en: 'View details',
    sv: 'Visa detaljer',
    fi: 'Näytä tiedot',
    nb: 'Vis detaljer',
  },
  viewer: {
    cz: 'Divák',
    de: 'Betrachter',
    en: 'Viewer',
    sv: 'Leseåtkomst',
    fi: 'Katselija',
    nb: 'Lesetilgang',
  },
  warning: {
    cz: 'Varování',
    de: 'Warnung',
    en: 'Warning',
    sv: 'Varning',
    fi: 'Varoitus',
    nb: 'Advarsel',
  },
  water: {
    cz: 'Voda',
    de: 'Wasser',
    en: 'Water',
    sv: 'Vann',
    fi: 'Vesi',
    nb: 'Vann',
  },
  waterExplanation: {
    cz: 'senzor vody měří vlhkost ve formě volné vody',
    de: 'Ein Wassersensor misst Feuchtigkeit in Form von freiem Wasser',
    en: 'a water sensor measures moisture in the form of free water',
    sv: 'en vattensensor måler fuktighet i form av fritt vatten',
    fi: 'vesianturi mittaa kosteutta vapaan veden muodossa',
    nb: 'en vannsensor måler fukt i form av fritt vann',
  },
  waterguard: {
    cz: 'Waterguard',
    de: 'Waterguard',
    en: 'Waterguard',
    sv: 'Waterguard',
    fi: 'Vesivahti',
    nb: 'Waterguard',
  },
  waterstop: {
    cz: 'Zastavit vodu',
    de: 'Wasserstopp',
    en: 'Waterstop',
    sv: 'Vannstupp',
    fi: 'Vedenkatkaisu',
    nb: 'Vannstopp',
  },
  waterstopType: {
    cz: 'Typ vodního zastavení',
    de: 'Wasserstoptyp',
    en: 'Waterstop type',
    sv: 'Vannstupptype',
    fi: 'Vedenkatkaisun tyyppi',
    nb: 'Vannstopptype',
  },
  weatherConditions: {
    cz: 'Meteorologické podmínky',
    de: 'Wetterbedingungen',
    en: 'Weather Conditions',
    sv: 'Väderförhållanden',
    fi: 'Sääolosuhteet',
    nb: 'Værforhold',
  },
  weatherPlotCaption: {
    cz: 'Levá osa Y představuje srážky (mm) a pravá osa Y zobrazuje teplotu (°C). Šedá tečkovaná čára označuje 0 °C. Symboly počasí jsou ve výchozím nastavení skryty pro období delší než 14 dní; pomocí přepínače je lze zobrazit.',
    de: 'Die linke Y-Achse stellt den Niederschlag (mm) dar, und die rechte Y-Achse zeigt die Temperatur (°C). Die graue gestrichelte Linie markiert 0 °C. Wettersymbole sind standardmäßig für Zeiträume von mehr als 14 Tagen ausgeblendet; verwenden Sie den Schalter, um sie anzuzeigen.',
    en: 'The left y-axis represents precipitation (mm), and the right y-axis shows the temperature (°C). The grey dotted line marks 0 °C. Weather symbols are hidden by default for periods longer than 14 days; use the toggle to show them.',
    sv: 'Den vänstra y-axeln visar nederbörd (mm), och den högra y-axeln visar temperatur (°C). Den grå streckade linjen markerar 0 °C. Vädersymboler är dolda som standard för perioder längre än 14 dagar; använd reglaget för att visa dem.',
    fi: 'Vasen Y-akseli esittää sademäärää (mm) ja oikea Y-akseli lämpötilaa (°C). Harmaa katkoviiva osoittaa 0 °C:n. Sääsymbolit on oletuksena piilotettu yli 14 päivän jaksoilta; ota ne käyttöön kytkimellä.',
    nb: 'Venstre Y-akse viser nedbør (mm), og høyre Y-akse viser temperatur (°C). Den grå stiplete linjen markerer 0 °C. Værsymboler er skjult som standard for perioder lengre enn 14 dager; bruk bryteren for å vise dem.',
  },
  weatherSymbolsToggleLabel: {
    cz: 'Symboly počasí',
    de: 'Wettersymbole',
    en: 'Weather symbols',
    sv: 'Vädersymboler',
    fi: 'Sääsymbolit',
    nb: 'Værsymboler',
  },
  weeklySummary: {
    cz: 'Týdenní souhrn',
    de: 'Wöchentliche Zusammenfassung',
    en: 'Weekly summary',
    sv: 'Veckosammanfattning',
    fi: 'Viikoittainen yhteenveto',
    nb: 'Ukentlig sammendrag',
  },
  weeklySummaryDescription: {
    cz: 'Týdenní shrnující e-mail každý pondělí v 07:30',
    de: 'Wöchentliche Zusammenfassungs-E-Mail jeden Montag um 07:30 Uhr',
    en: 'Summary email every Monday at 07:30',
    sv: 'Sammanfattning via e-post varje måndag 07:30',
    fi: 'Yhteenvetoposti joka maanantai klo 07:30',
    nb: 'Oppsummerings-e-post hver mandag kl. 07:30',
  },
  wood: {
    cz: 'Dřevo',
    de: 'Holz',
    en: 'Wood',
    sv: 'Tre',
    fi: 'Puu',
    nb: 'Tre',
  },
  woodInto: {
    cz: 'into® Sensor Wood',
    de: 'into® Sensor Wood',
    en: 'into® Sensor Wood',
    sv: 'into® Sensor Wood',
    fi: 'into® Sensor Wood',
    nb: 'into® Sensor Wood',
  },
  woodMoisture: {
    cz: 'Vlhkost dřeva',
    de: 'Holzfeuchtigkeit',
    en: 'Wood Moisture',
    sv: 'Tre fuktighet',
    fi: 'Puunkosteus',
    nb: 'Trefukt',
  },
  woodMoistureSettings: {
    cz: 'Nastavení vlhkosti dřeva',
    de: 'Einstellungen für Holzfeuchtigkeit',
    en: 'Wood moisture settings',
    sv: 'Inställningar för träfuktighet',
    fi: 'Puunkosteuden asetukset',
    nb: 'Innstillinger for trefukt',
  },
  yellowAlertThreshold: {
    cz: 'Prahová hodnota žlutého upozornění',
    de: 'Schwellenwert für gelbe Warnung',
    en: 'Yellow alert threshold',
    sv: 'Tröskelvärde för gul varning',
    fi: 'Keltaisen hälytyksen raja-arvo',
    nb: 'Terskel for gult varsel',
  },
  redAlertThreshold: {
    cz: 'Prahová hodnota červeného upozornění',
    de: 'Schwellenwert für roten Alarm',
    en: 'Red alert threshold',
    sv: 'Tröskelvärde för rött larm',
    fi: 'Punaisen hälytyksen raja-arvo',
    nb: 'Terskel for rødt varsel',
  },
  sendRedAlerts: {
    cz: 'Odesílat červená upozornění',
    de: 'Rote Alarme senden',
    en: 'Send red alerts',
    sv: 'Skicka röda larm',
    fi: 'Lähetä punaiset hälytykset',
    nb: 'Send røde varsler',
  },
  woodType: {
    cz: 'Typ dřeva',
    de: 'Holzart',
    en: 'Wood type',
    sv: 'Trätyp',
    fi: 'Puutyyppi',
    nb: 'Tretype',
  },
  woodActivationDataRequired: {
    cz: 'Před aktivací nastavte délku šroubu a izolovanou elektrodu.',
    de: 'Legen Sie Schraubenlänge und isolierte Elektrode vor der Aktivierung fest.',
    en: 'Set screw length and insulated electrode before activating.',
    sv: 'Ange skruvlängd och isolerad elektrod innan aktivering.',
    fi: 'Aseta ruuvin pituus ja eristetty elektrodi ennen aktivointia.',
    nb: 'Sett skruelengde og isolert elektrode før aktivering.',
  },
  woodActivationDataMustBeSaved: {
    cz: 'Před aktivací uložte změny.',
    de: 'Änderungen vor der Aktivierung speichern.',
    en: 'Save changes before activating.',
    sv: 'Spara ändringarna innan aktivering.',
    fi: 'Tallenna muutokset ennen aktivointia.',
    nb: 'Lagre endringer før aktivering.',
  },
  writeThreeCharsToSearch: {
    cz: 'Napište alespoň tři znaky pro vyhledávání',
    de: 'Geben Sie mindestens drei Zeichen zum Suchen ein',
    en: 'Write at least three characters to search',
    sv: 'Skriv minst tre tecken för att söka',
    fi: 'Kirjoita vähintään kolme merkkiä hakeaksesi',
    nb: 'Skriv minst tre tegn for å søke',
  },
  yellow: {
    cz: 'Žlutá',
    de: 'Gelb',
    en: 'Yellow',
    sv: 'Gul',
    fi: 'Keltainen',
    nb: 'Gul',
  },
  yellowWarningDescription: {
    cz: 'Žluté varování indikuje vysokou vlhkost nebo vlhkost budovy, což může v průběhu času vést k problémům. To je velmi běžné během stavební fáze a často se stabilizuje směrem k zelené, pokud je přirozená ventilace budovy správně funkční. Pokud žluté varování přetrvává po delší dobu (více než jeden rok), je vhodné přijmout korekční opatření.',
    de: 'Die gelbe Warnung weist auf hohe Luftfeuchtigkeit oder Gebäudefeuchtigkeit hin, die im Laufe der Zeit zu Problemen führen kann. Dies ist während der Bauphase sehr häufig und stabilisiert sich oft in Richtung Grün, wenn die natürliche Belüftung des Gebäudes ordnungsgemäß funktioniert. Wenn eine gelbe Warnung über einen längeren Zeitraum (über ein Jahr) bestehen bleibt, ist es ratsam, Korrekturmaßnahmen zu ergreifen.',
    en: 'Yellow warning indicates high humidity or project moisture, which can lead to issues over time. This is very common during the construction phase and often stabilizes towards green if the project’s natural ventilation is functioning properly. If a yellow warning persists for an extended period (over one year), it is advisable to take corrective action.',
    sv: 'Gul varning indikerar hög luftfuktighet eller byggfukt, vilket kan leda till problem över tid. Detta är mycket vanligt under byggfasen och stabiliseras ofta mot grönt om byggnadens naturliga ventilation fungerar korrekt. Om en gul varning kvarstår under en längre period (över ett år) rekommenderas korrigerande åtgärder.',
    fi: 'Keltainen varoitus ilmaisee korkeaa kosteutta tai rakennuskosteutta, joka voi ajan myötä aiheuttaa ongelmia. Tämä on hyvin yleistä rakennusvaiheen aikana ja usein vakiintuu vihreälle tasolle, jos rakennuksen luonnollinen tuuletus toimii oikein. Jos keltainen varoitus jatkuu pitkän aikaa (yli vuoden), on suositeltavaa ryhtyä korjaaviin toimenpiteisiin.',
    nb: 'Gul advarsel indikerer høy luftfuktighet eller bygningsfukt, som kan føre til problemer over tid. Dette er veldig vanlig under byggefasen og stabiliserer ofte mot grønt hvis bygningens naturlige ventilasjon fungerer som den skal. Hvis en gul advarsel vedvarer over en lengre periode (over ett år), er det tilrådelig å ta korrigerende tiltak.',
  },
  yes: {
    cz: 'Ano',
    de: 'Ja',
    en: 'Yes',
    sv: 'Ja',
    fi: 'Kyllä',
    nb: 'Ja',
  },
  zoomIn: {
    cz: 'Přiblížit',
    de: 'Vergrößern',
    en: 'Zoom in',
    sv: 'Zoom inn',
    fi: 'Lähennä',
    nb: 'Zoom inn',
  },
  zoomOut: {
    cz: 'Oddálit',
    de: 'Verkleinern',
    en: 'Zoom out',
    sv: 'Zoom ut',
    fi: 'Loitonna',
    nb: 'Zoom ut',
  },
  actualSize: {
    cz: 'Skutečná velikost (1:1)',
    de: 'Originalgröße (1:1)',
    en: 'Actual size (1:1)',
    sv: 'Verklig storlek (1:1)',
    fi: 'Todellinen koko (1:1)',
    nb: 'Faktisk størrelse (1:1)',
  },
  rotateMap: {
    cz: 'Otočit mapu o 90°',
    de: 'Karte um 90° drehen',
    en: 'Rotate map 90°',
    sv: 'Rotera karta 90°',
    fi: 'Kierrä karttaa 90°',
    nb: 'Roter kartet 90°',
  },
  yearToDate: {
    cz: 'Od začátku roku',
    de: 'Seit Jahresbeginn',
    en: 'Year to date',
    sv: 'Hittills i år',
    fi: 'Vuoden alusta',
    nb: 'Hittil i år',
  },
  next: {
    cz: 'Další',
    de: 'Nächste',
    en: 'Next',
    sv: 'Nästa',
    fi: 'Seuraava',
    nb: 'Neste',
  },
  previous: {
    cz: 'Předchozí',
    de: 'Vorherige',
    en: 'Previous',
    sv: 'Föregående',
    fi: 'Edellinen',
    nb: 'Forrige',
  },
  copy: {
    cz: 'Kopírovat',
    de: 'Kopieren',
    en: 'Copy',
    sv: 'Kopier',
    fi: 'Kopioi',
    nb: 'Kopier',
  },
  copied: {
    cz: 'Zkopírováno',
    de: 'Kopiert',
    en: 'Copied',
    sv: 'Kopiert',
    fi: 'Kopioitu',
    nb: 'Kopiert',
  },
  editModeInfoDragDrop: {
    cz: 'Zařízení lze přesouvat přetažením.',
    de: 'Geräte können per Drag & Drop verschoben werden.',
    en: 'Devices can be moved by drag and drop.',
    sv: 'Enheter kan flyttas genom att dra och släppa.',
    fi: 'Laitteita voidaan siirtää vetämällä ja pudottamalla.',
    nb: 'Enheter kan flyttes ved å dra og slippe.',
  },
  editModeInfoClickDevice: {
    cz: 'Klikněte na zařízení pro zobrazení podrobností.',
    de: 'Klicken Sie auf ein Gerät, um Details anzuzeigen.',
    en: 'Click on a device to view details.',
    sv: 'Klicka på en enhet för att se detaljer.',
    fi: 'Napsauta laitetta nähdäksesi tiedot.',
    nb: 'Klikk på en enhet for å se detaljer.',
  },
  planningModeClickToPlaceSelected: {
    cz: 'Klikněte pro umístění zařízení na mapu.',
    de: 'Klicken Sie, um das Gerät auf der Karte zu platzieren.',
    en: 'Click to place device on the map.',
    sv: 'Klicka för att placera enhet på kartan.',
    fi: 'Napsauta sijoittaaksesi laitteen kartalle.',
    nb: 'Klikk for å plassere enhet på kartet.',
  },
  planningModeClickToActivate: {
    cz: 'Klikněte na libovolné zařízení pro aktivaci (jednorázová aktivace).',
    de: 'Klicken Sie auf ein beliebiges Gerät, um es zu aktivieren (Einzelaktivierung).',
    en: 'Click any device to activate (single activation).',
    sv: 'Klicka på valfri enhet för att aktivera (enstaka aktivering).',
    fi: 'Napsauta mitä tahansa laitetta aktivoidaksesi (yksittäinen aktivointi).',
    nb: 'Klikk en hvilken som helst enhet for å aktivere (enkeltaktivering).',
  },
  planningModeSetActivationOrder: {
    cz: 'Klikněte na Změnit pořadí pro nastavení pořadí aktivace.',
    de: 'Klicken Sie auf Reihenfolge ändern, um die Aktivierungsreihenfolge festzulegen.',
    en: 'Click Change order to set activation order.',
    sv: 'Klicka på Ändra ordning för att ställa in aktiveringsordningen.',
    fi: 'Napsauta Muuta järjestystä asettaaksesi aktivointijärjestyksen.',
    nb: 'Klikk Endre rekkefølge for å sette aktiveringsrekkefølge.',
  },
  planningModeStartActivationFlow: {
    cz: 'Poté uložte změny a klikněte na Aktivovat pro spuštění aktivačního toku.',
    de: 'Speichern Sie dann Ihre Änderungen und klicken Sie auf Aktivieren, um den Aktivierungsablauf zu starten.',
    en: 'Then save your changes and click Activate to start activation flow.',
    sv: 'Spara sedan ändringarna och klicka på Aktivera för att starta aktiveringsflödet.',
    fi: 'Tallenna sitten muutokset ja napsauta Aktivoi käynnistääksesi aktivointiprosessin.',
    nb: 'Lagre deretter endringene og klikk Aktiver for å starte aktiveringsflyten.',
  },
  planningModeRightClickDelete: {
    cz: 'Pravým kliknutím na zařízení jej smažete.',
    de: 'Rechtsklick auf ein Gerät, um es zu löschen.',
    en: 'Right click on device to delete.',
    sv: 'Högerklicka på en enhet för att ta bort den.',
    fi: 'Napsauta laitetta hiiren oikealla painikkeella poistaaksesi sen.',
    nb: 'Høyreklikk på en enhet for å slette den.',
  },
  planningModeDragToMove: {
    cz: 'Přetažením přesunete zařízení.',
    de: 'Ziehen und ablegen, um Geräte zu verschieben.',
    en: 'Drag and drop to move devices.',
    sv: 'Dra och släpp för att flytta enheter.',
    fi: 'Siirrä laitteita vetämällä ja pudottamalla.',
    nb: 'Dra og slipp for å flytte enheter.',
  },
  planningModeShowActivationOrderLine: {
    cz: 'Zobrazit linii pořadí',
    de: 'Reihenfolgelinie anzeigen',
    en: 'Show order line',
    sv: 'Visa ordningslinje',
    fi: 'Näytä järjestysviiva',
    nb: 'Vis rekkefølgelinje',
  },
  planningModeHideActivationOrderLine: {
    cz: 'Skrýt linii pořadí',
    de: 'Reihenfolgelinie ausblenden',
    en: 'Hide order line',
    sv: 'Dölj ordningslinje',
    fi: 'Piilota järjestysviiva',
    nb: 'Skjul rekkefølgelinje',
  },
  planningModeSetOrderByClick: {
    cz: 'Nastavit pořadí kliknutím',
    de: 'Reihenfolge per Klick festlegen',
    en: 'Set order by click',
    sv: 'Ställ in ordning med klick',
    fi: 'Aseta järjestys napsauttamalla',
    nb: 'Sett rekkefølge med klikk',
  },
  planningModeSetOrderByClickOn: {
    cz: 'Nastavit pořadí kliknutím er på',
    de: 'Reihenfolge per Klick ist aktiviert',
    en: 'Set order by click is on',
    sv: 'Ställ in ordning med klick är på',
    fi: 'Aseta järjestys napsauttamalla on päällä',
    nb: 'Sett rekkefølge med klikk er på',
  },
  planningModeOrderPickInstruction: {
    cz: 'Klikněte na zařízení na mapě v požadovaném pořadí.',
    de: 'Klicken Sie die Geräte auf der Karte in der gewünschten Reihenfolge an.',
    en: 'Click devices on the map in the order you want.',
    sv: 'Klicka på enheterna på kartan i den ordning du vill ha.',
    fi: 'Napsauta laitteita kartalla haluamassasi järjestyksessä.',
    nb: 'Klikk enhetene på kartet i ønsket rekkefølge.',
  },
  planningModeOrderByRows: {
    cz: 'Seřadit po řádcích (zleva doprava)',
    de: 'Nach Reihen sortieren (links nach rechts)',
    en: 'Order by rows (left to right)',
    sv: 'Ordna efter rader (vänster till höger)',
    fi: 'Järjestä riveittäin (vasemmalta oikealle)',
    nb: 'Sorter etter rader (venstre til høyre)',
  },
  planningModeReverseRowOrder: {
    cz: 'Obrátit pořadí řádků',
    de: 'Reihenfolge der Reihen umkehren',
    en: 'Reverse row order',
    sv: 'Omvänd radordning',
    fi: 'Käännä rivijärjestys',
    nb: 'Reverser radrekkefølgen',
  },
  planningModeSnakeByRows: {
    cz: 'Cikcak po řádcích',
    de: 'Schlangenlinie nach Reihen',
    en: 'Snake by rows',
    sv: 'Zigzag per rad',
    fi: 'Siksak riveittäin',
    nb: 'Slangevis etter rader',
  },
  planningModeReverseSnakeByRows: {
    cz: 'Obrácený cikcak po řádcích',
    de: 'Umgekehrte Schlangenlinie nach Reihen',
    en: 'Reverse snake by rows',
    sv: 'Omvänd zigzag per rad',
    fi: 'Käänteinen siksak riveittäin',
    nb: 'Omvendt slangevis etter rader',
  },
  planningModeOrderByColumns: {
    cz: 'Seřadit po sloupcích (shora dolů)',
    de: 'Nach Spalten sortieren (oben nach unten)',
    en: 'Order by columns (top to bottom)',
    sv: 'Ordna efter kolumner (uppifrån och ned)',
    fi: 'Järjestä sarakkeittain (ylhäältä alas)',
    nb: 'Sorter etter kolonner (topp til bunn)',
  },
  planningModeReverseColumnOrder: {
    cz: 'Obrátit pořadí sloupců',
    de: 'Spaltenreihenfolge umkehren',
    en: 'Reverse column order',
    sv: 'Omvänd kolumnordning',
    fi: 'Käännä sarakejärjestys',
    nb: 'Reverser kolonnerekkefølgen',
  },
  planningModeSnakeByColumns: {
    cz: 'Cikcak po sloupcích',
    de: 'Schlangenlinie nach Spalten',
    en: 'Snake by columns',
    sv: 'Zigzag per kolumn',
    fi: 'Siksak sarakkeittain',
    nb: 'Slangevis etter kolonner',
  },
  planningModeReverseSnakeByColumns: {
    cz: 'Obrácený cikcak po sloupcích',
    de: 'Umgekehrte Schlangenlinie nach Spalten',
    en: 'Reverse snake by columns',
    sv: 'Omvänd zigzag per kolumn',
    fi: 'Käänteinen siksak sarakkeittain',
    nb: 'Omvendt slangevis etter kolonner',
  },
  planningModeShowDeviceList: {
    cz: 'Zobrazit seznam zařízení',
    de: 'Geräteliste anzeigen',
    en: 'Show device list',
    sv: 'Visa enhetslista',
    fi: 'Näytä laiteluettelo',
    nb: 'Vis enhetsliste',
  },
  planningModeHideDeviceList: {
    cz: 'Skrýt seznam zařízení',
    de: 'Geräteliste ausblenden',
    en: 'Hide device list',
    sv: 'Dölj enhetslista',
    fi: 'Piilota laiteluettelo',
    nb: 'Skjul enhetsliste',
  },
  planningModeActivateTooltipStart: {
    cz: 'Spustí aktivaci v nastaveném pořadí.',
    de: 'Startet die Aktivierung in der festgelegten Reihenfolge.',
    en: 'Starts activation in the set order.',
    sv: 'Startar aktivering i den valda ordningen.',
    fi: 'Aloittaa aktivoinnin asetetussa järjestyksessä.',
    nb: 'Starter aktivering i angitt rekkefølge.',
  },
  planningModeActivateTooltipUnsaved: {
    cz: 'Nejprve uložte změny.',
    de: 'Speichern Sie zuerst die Änderungen.',
    en: 'Save changes first.',
    sv: 'Spara ändringarna först.',
    fi: 'Tallenna muutokset ensin.',
    nb: 'Lagre endringene først.',
  },
  planningModeActivateTooltipNoOrder: {
    cz: 'Nejprve nastavte pořadí aktivace.',
    de: 'Legen Sie zuerst die Aktivierungsreihenfolge fest.',
    en: 'Set activation order first.',
    sv: 'Ange aktiveringsordning först.',
    fi: 'Määritä aktivointijärjestys ensin.',
    nb: 'Sett aktiveringsrekkefølge først.',
  },
  planningModeActivateTooltipPending: {
    cz: 'Počkejte, až se aktuální změny dokončí.',
    de: 'Warten Sie, bis die aktuellen Änderungen abgeschlossen sind.',
    en: 'Wait for current changes to finish.',
    sv: 'Vänta tills aktuella ändringar är klara.',
    fi: 'Odota, että nykyiset muutokset valmistuvat.',
    nb: 'Vent til pågående endringer er ferdige.',
  },
  showLabels: {
    cz: 'Zobrazit úkoly',
    de: 'Aufgaben anzeigen',
    en: 'Show tasks',
    sv: 'Visa uppgaver',
    fi: 'Näytä tehtävät',
    nb: 'Vis oppgaver',
  },
  securitySettings: {
    cz: 'Nastavení zabezpečení',
    de: 'Sicherheitseinstellungen',
    en: 'Security settings',
    sv: 'Säkerhetsinställningar',
    fi: 'Turvallisuusasetukset',
    nb: 'Sikkerhetsinnstillinger',
  },
  passkeys: {
    cz: 'Přístupové klíče',
    de: 'Passkeys',
    en: 'Passkeys',
    sv: 'Passkeys',
    fi: 'Pääsyavaimet',
    nb: 'Passnøkler',
  },
  authenticatorApp: {
    cz: 'Ověřovací aplikace (OTP)',
    de: 'Authenticator-App (OTP)',
    en: 'Authenticator app (OTP)',
    sv: 'Autentiseringsapp (OTP)',
    fi: 'Todennussovellus (OTP)',
    nb: 'Autentiseringsapp (OTP)',
  },
  changePassword: {
    cz: 'Změnit heslo',
    de: 'Passwort ändern',
    en: 'Change password',
    sv: 'Ändra lösenord',
    fi: 'Vaihda salasana',
    nb: 'Endre passord',
  },
  addPasskey: {
    cz: 'Vytvořit přístupový klíč',
    de: 'Passkey erstellen',
    en: 'Create passkey',
    sv: 'Skapa passkey',
    fi: 'Luo pääsyavain',
    nb: 'Opprett passnøkkel',
  },
  addAnotherPasskey: {
    cz: 'Přidat další přístupový klíč',
    de: 'Weiteren Passkey hinzufügen',
    en: 'Add another passkey',
    sv: 'Lägg till en till passkey',
    fi: 'Lisää toinen pääsyavain',
    nb: 'Legg til en annen passnøkkel',
  },
  noPasskeysConfigured: {
    cz: 'Žádné přístupové klíče nakonfigurovány. Přidejte jeden pro silnější zabezpečení.',
    de: 'Keine Passkeys konfiguriert. Fügen Sie einen für stärkere Sicherheit hinzu.',
    en: 'No passkeys configured. Add one for stronger security.',
    sv: 'Inga passkeys konfigurerade. Lägg till en för starkare säkerhet.',
    fi: 'Ei pääsyavaimia määritetty. Lisää yksi vahvempaa turvallisuutta varten.',
    nb: 'Ingen passnøkler konfigurert. Legg til en for sterkere sikkerhet.',
  },
  noOtpConfigured: {
    cz: 'Žádná ověřovací aplikace nakonfigurována.',
    de: 'Keine Authenticator-App konfiguriert.',
    en: 'No authenticator app configured.',
    sv: 'Ingen autentiseringsapp konfigurerad.',
    fi: 'Todennussovellusta ei ole määritetty.',
    nb: 'Ingen autentiseringsapp konfigurert.',
  },
  setUpAuthenticator: {
    cz: 'Nastavit ověřovací aplikaci',
    de: 'Authenticator-App einrichten',
    en: 'Set up authenticator app',
    sv: 'Konfigurera autentiseringsapp',
    fi: 'Määritä todennussovellus',
    nb: 'Konfigurer autentiseringsapp',
  },
  otpConfigured: {
    cz: 'Ověřovací aplikace je nakonfigurována',
    de: 'Authenticator-App ist konfiguriert',
    en: 'Authenticator app is configured',
    sv: 'Autentiseringsapp är konfigurerad',
    fi: 'Todennussovellus on määritetty',
    nb: 'Autentiseringsapp er konfigurert',
  },
  confirmDeletePasskey: {
    cz: 'Opravdu chcete odstranit tento přístupový klíč?',
    de: 'Möchten Sie diesen Passkey wirklich löschen?',
    en: 'Are you sure you want to delete this passkey?',
    sv: 'Är du säker på att du vill ta bort denna passkey?',
    fi: 'Haluatko varmasti poistaa tämän pääsyavaimen?',
    nb: 'Er du sikker på at du vil slette denne passnøkkelen?',
  },
  confirmDeleteOtp: {
    cz: 'Opravdu chcete odstranit ověřovací aplikaci?',
    de: 'Möchten Sie die Authenticator-App wirklich entfernen?',
    en: 'Are you sure you want to remove the authenticator app?',
    sv: 'Är du säker på att du vill ta bort autentiseringsappen?',
    fi: 'Haluatko varmasti poistaa todennussovelluksen?',
    nb: 'Er du sikker på at du vil fjerne autentiseringsappen?',
  },
  removeOtp: {
    cz: 'Odstranit ověřovací aplikaci',
    de: 'Authenticator-App entfernen',
    en: 'Remove authenticator app',
    sv: 'Ta bort autentiseringsapp',
    fi: 'Poista todennussovellus',
    nb: 'Fjern autentiseringsapp',
  },
  deletePasskey: {
    cz: 'Odstranit přístupový klíč',
    de: 'Passkey löschen',
    en: 'Delete passkey',
    sv: 'Ta bort passkey',
    fi: 'Poista pääsyavain',
    nb: 'Slett passnøkkel',
  },
  addedOn: {
    cz: 'Přidáno',
    de: 'Hinzugefügt am',
    en: 'Added',
    sv: 'Tillagd',
    fi: 'Lisätty',
    nb: 'Lagt til',
  },
  activeSessions: {
    cz: 'Aktivní relace',
    de: 'Aktive Sitzungen',
    en: 'Active sessions',
    sv: 'Aktiva sessioner',
    fi: 'Aktiiviset istunnot',
    nb: 'Aktive økter',
  },
  activeSessionsDescription: {
    cz: 'Sledujte, kdo je právě přihlášený do aplikace. Statistiky dotazů zahrnují pouze náročné analytické dotazy na projektová data.',
    de: 'Zeigt, wer aktuell in der App angemeldet ist. Die Abfragestatistiken umfassen nur umfangreiche Analyseabfragen für Projektdaten.',
    en: 'Monitor who is currently logged into the app. Query metrics only cover heavy project data data queries.',
    sv: 'Visar vem som för närvarande är inloggad i appen. Frågestatistiken omfattar bara tunga analysfrågor för projektdata.',
    fi: 'Näyttää, kuka on tällä hetkellä kirjautuneena sovellukseen. Kyselytilastot koskevat vain raskaita projektidatan analytiikkakyselyitä.',
    nb: 'Viser hvem som for øyeblikket er logget inn i appen. Spørringsstatistikken dekker bare tunge analyseforespørsler for prosjektdata.',
  },
  averageResponseTime: {
    cz: 'Průměrná doba odezvy',
    de: 'Durchschnittliche Antwortzeit',
    en: 'Average response time',
    sv: 'Genomsnittlig svarstid',
    fi: 'Keskimääräinen vasteaika',
    nb: 'Gjennomsnittlig responstid',
  },
  queriesToday: {
    cz: 'Dotazy dnes',
    de: 'Abfragen heute',
    en: 'Queries today',
    sv: 'Frågor idag',
    fi: 'Kyselyt tänään',
    nb: 'Spørringer i dag',
  },
  queriesLastHour: {
    cz: 'Dotazy za poslední hodinu',
    de: 'Abfragen letzte Stunde',
    en: 'Queries last hour',
    sv: 'Frågor senaste timmen',
    fi: 'Kyselyt viimeisen tunnin aikana',
    nb: 'Spørringer siste time',
  },
  lastQuery: {
    cz: 'Poslední dotaz',
    de: 'Letzte Abfrage',
    en: 'Last query',
    sv: 'Senaste fråga',
    fi: 'Viimeisin kysely',
    nb: 'Siste spørring',
  },
  responseTimes: {
    cz: 'Odezvy',
    de: 'Antwortzeiten',
    en: 'Response times',
    sv: 'Svarstider',
    fi: 'Vasteajat',
    nb: 'Responstider',
  },
  queryUsage: {
    cz: 'Využití dotazů',
    de: 'Abfragenutzung',
    en: 'Query usage',
    sv: 'Frågeanvändning',
    fi: 'Kyselyiden käyttö',
    nb: 'Spørringsbruk',
  },
  currentSession: {
    cz: 'Aktuální relace',
    de: 'Aktuelle Sitzung',
    en: 'Current session',
    sv: 'Nuvarande session',
    fi: 'Nykyinen istunto',
    nb: 'Nåværende økt',
  },
  thisDevice: {
    cz: 'Toto zařízení',
    de: 'Dieses Gerät',
    en: 'This device',
    sv: 'Den här enheten',
    fi: 'Tämä laite',
    nb: 'Denne enheten',
  },
  ipAddress: {
    cz: 'IP adresa',
    de: 'IP-Adresse',
    en: 'IP address',
    sv: 'IP-adress',
    fi: 'IP-osoite',
    nb: 'IP-adresse',
  },
  lastActive: {
    cz: 'Naposledy aktivní',
    de: 'Zuletzt aktiv',
    en: 'Last active',
    sv: 'Senast aktiv',
    fi: 'Viimeksi aktiivinen',
    nb: 'Sist aktiv',
  },
  noActiveSessionsFound: {
    cz: 'Nebyly nalezeny žádné aktivní relace.',
    de: 'Keine aktiven Sitzungen gefunden.',
    en: 'No active sessions found.',
    sv: 'Inga aktiva sessioner hittades.',
    fi: 'Aktiivisia istuntoja ei löytynyt.',
    nb: 'Ingen aktive økter funnet.',
  },
  otherSessions: {
    cz: 'Ostatní relace',
    de: 'Andere Sitzungen',
    en: 'Other sessions',
    sv: 'Andra sessioner',
    fi: 'Muut istunnot',
    nb: 'Andre økter',
  },
  bulkActions: {
    cz: 'Hromadné akce',
    de: 'Massenaktionen',
    en: 'Bulk actions',
    sv: 'Bulkåtgärder',
    fi: 'Joukkotoiminnot',
    nb: 'Massehandlinger',
  },
  refreshingSessions: {
    cz: 'Aktualizace relací...',
    de: 'Sitzungen werden aktualisiert...',
    en: 'Refreshing sessions...',
    sv: 'Uppdaterar sessioner...',
    fi: 'Päivitetään istuntoja...',
    nb: 'Oppdaterer økter...',
  },
  sessionsRefreshInterval: {
    cz: 'Seznam se automaticky obnovuje každých 30 sekund.',
    de: 'Die Liste wird alle 30 Sekunden automatisch aktualisiert.',
    en: 'This list refreshes automatically every 30 seconds.',
    sv: 'Listan uppdateras automatiskt var 30:e sekund.',
    fi: 'Lista päivittyy automaattisesti 30 sekunnin välein.',
    nb: 'Listen oppdateres automatisk hvert 30. sekund.',
  },
  logoutAllOtherDevices: {
    cz: 'Odhlásit všechna ostatní zařízení',
    de: 'Von allen anderen Geräten abmelden',
    en: 'Logout from all other devices',
    sv: 'Logga ut från alla andra enheter',
    fi: 'Kirjaudu ulos kaikista muista laitteista',
    nb: 'Logg ut fra alle andre enheter',
  },
  logoutAllDevices: {
    cz: 'Odhlásit všechna zařízení',
    de: 'Von allen Geräten abmelden',
    en: 'Logout from all devices',
    sv: 'Logga ut från alla enheter',
    fi: 'Kirjaudu ulos kaikista laitteista',
    nb: 'Logg ut fra alle enheter',
  },
  noOtherSessions: {
    cz: 'Nejsou k dispozici žádné další relace.',
    de: 'Keine anderen Sitzungen verfügbar.',
    en: 'No other sessions available.',
    sv: 'Inga andra sessioner tillgängliga.',
    fi: 'Ei muita istuntoja saatavilla.',
    nb: 'Ingen andre økter tilgjengelig.',
  },
  logoutFromDevice: {
    cz: 'Odhlásit z tohoto zařízení',
    de: 'Von diesem Gerät abmelden',
    en: 'Logout from this device',
    sv: 'Logga ut från den här enheten',
    fi: 'Kirjaudu ulos tästä laitteesta',
    nb: 'Logg ut fra denne enheten',
  },
  confirmLogoutSession: {
    cz: 'Opravdu chcete odhlásit tuto relaci?',
    de: 'Möchten Sie diese Sitzung wirklich abmelden?',
    en: 'Are you sure you want to logout from this session?',
    sv: 'Är du säker på att du vill logga ut från denna session?',
    fi: 'Haluatko varmasti kirjautua ulos tästä istunnosta?',
    nb: 'Er du sikker på at du vil logge ut fra denne økten?',
  },
  confirmLogoutAllOther: {
    cz: 'Všechna ostatní zařízení budou odhlášena. Zůstanete přihlášeni zde.',
    de: 'Alle anderen Geräte werden abgemeldet. Sie bleiben hier angemeldet.',
    en: "All other devices will be logged out. You'll remain logged in here.",
    sv: 'Alla andra enheter kommer att loggas ut. Du förblir inloggad här.',
    fi: 'Kaikki muut laitteet kirjataan ulos. Pysyt kirjautuneena täällä.',
    nb: 'Alle andre enheter vil bli logget ut. Du forblir innlogget her.',
  },
  confirmLogoutAll: {
    cz: 'Budete odhlášeni ze všech zařízení. Budete se muset znovu přihlásit.',
    de: 'Sie werden von allen Geräten abgemeldet. Sie müssen sich erneut anmelden.',
    en: "You will be logged out from all devices. You'll need to sign in again.",
    sv: 'Du kommer att loggas ut från alla enheter. Du måste logga in igen.',
    fi: 'Sinut kirjataan ulos kaikista laitteista. Sinun on kirjauduttava uudelleen.',
    nb: 'Du vil bli logget ut fra alle enheter. Du må logge inn på nytt.',
  },
  started: {
    cz: 'Zahájeno',
    de: 'Gestartet',
    en: 'Started',
    sv: 'Startad',
    fi: 'Aloitettu',
    nb: 'Startet',
  },
  expires: {
    cz: 'Vyprší',
    de: 'Läuft ab',
    en: 'Expires',
    sv: 'Upphör',
    fi: 'Vanhenee',
    nb: 'Utløper',
  },
  weeklySummaryTotalSensors: {
    cz: 'Celkem aktivních senzorů',
    de: 'Aktive Sensoren gesamt',
    en: 'Total active sensors',
    sv: 'Totalt aktiva sensorer',
    fi: 'Aktiiviset anturit yhteensä',
    nb: 'Totalt antall aktive sensorer',
  },
  weeklySummaryWeek: {
    cz: 'Týden',
    de: 'Woche',
    en: 'Week',
    sv: 'Vecka',
    fi: 'Viikko',
    nb: 'Uke',
  },
  weeklySummaryNewer: {
    cz: 'Novější týden',
    de: 'Neuere Woche',
    en: 'Newer week',
    sv: 'Nyare vecka',
    fi: 'Uudempi viikko',
    nb: 'Nyere uke',
  },
  weeklySummaryOlder: {
    cz: 'Starší týden',
    de: 'Ältere Woche',
    en: 'Older week',
    sv: 'Äldre vecka',
    fi: 'Vanhempi viikko',
    nb: 'Eldre uke',
  },
  weeklySummaryNewAlertSensors: {
    cz: 'Nové senzory v režimu Alarm',
    de: 'Neue Sensoren im Alarmzustand',
    en: 'New sensors in Alert',
    sv: 'Nya sensorer i Varsel',
    fi: 'Uudet anturit hälytyksessä',
    nb: 'Nye sensorer i alarm',
  },
  weeklySummaryAllAlertSensors: {
    cz: 'Všechny senzory v režimu Alarm',
    de: 'Alle Sensoren im Alarmzustand',
    en: 'All sensors in Alert',
    sv: 'Alla sensorer i Varsel',
    fi: 'Kaikki anturit hälytyksessä',
    nb: 'Alle sensorer i alarm',
  },
  weeklySummaryTransitions: {
    cz: 'Změny stavu',
    de: 'Statusübergänge',
    en: 'Status transitions',
    sv: 'Statusövergångar',
    fi: 'Tilasiirtymät',
    nb: 'Statusoverganger',
  },
  weeklySummaryCompletedWeekStatus: {
    cz: 'Stav senzorů',
    de: 'Sensorstatus',
    en: 'Sensor status',
    sv: 'Sensorstatus',
    fi: 'Anturitila',
    nb: 'Sensorstatus',
  },
  weeklySummaryUniqueAlertSensors: {
    cz: 'Unikátní senzory s alarmem',
    de: 'Eindeutige Alarmsensoren',
    en: 'Unique sensors entering alert',
    sv: 'Unika sensorer som gått i varsel',
    fi: 'Hälytykseen siirtyneet yksilölliset anturit',
    nb: 'Unike sensorer som gikk i alarm',
  },
  weeklySummaryAlertEntries: {
    cz: 'Vstupy do alarmu',
    de: 'Alarmeintritte',
    en: 'Alert entries',
    sv: 'Övergångar till varsel',
    fi: 'Siirtymiset hälytykseen',
    nb: 'Overganger til alarm',
  },
  weeklySummaryPeakAlertWeek: {
    cz: 'Nejhorší týden alarmů',
    de: 'Spitzenwoche der Alarme',
    en: 'Peak alert week',
    sv: 'Vecka med flest varsel',
    fi: 'Hälytysten huippuviikko',
    nb: 'Uke med flest alarmer',
  },
  weeklySummaryStatusOverTime: {
    cz: 'Vývoj stavu senzorů',
    de: 'Sensorstatus im Zeitverlauf',
    en: 'Sensor status over time',
    sv: 'Sensorstatus över tid',
    fi: 'Anturitila ajan kuluessa',
    nb: 'Sensorstatus over tid',
  },
  weeklySummaryAlertsOverTime: {
    cz: 'Nové alarmy v čase',
    de: 'Neue Alarme im Zeitverlauf',
    en: 'New alerts over time',
    sv: 'Nya varsel över tid',
    fi: 'Uudet hälytykset ajan kuluessa',
    nb: 'Nye alarmer over tid',
  },
  weeklySummaryTransitionsOverTime: {
    cz: 'Změny stavu v čase',
    de: 'Statusübergänge im Zeitverlauf',
    en: 'Status transitions over time',
    sv: 'Statusövergångar över tid',
    fi: 'Tilasiirtymät ajan kuluessa',
    nb: 'Statusoverganger over tid',
  },
  downtime: {
    cz: 'Doba výpadku',
    de: 'Ausfallzeit',
    en: 'Downtime',
    sv: 'Driftstopp',
    fi: 'Käyttökatko',
    nb: 'Nedetid',
  },
  noInstallationMapsAvailable: {
    cz: 'Pro tento projekt nejsou k dispozici žádné instalační mapy.',
    de: 'Für dieses Projekt sind keine Installationskarten verfügbar.',
    en: 'No installation maps are available for this project.',
    sv: 'Inga installationskartor är tillgängliga för det här projektet.',
    fi: 'Tälle projektille ei ole saatavilla asennuskarttoja.',
    nb: 'Ingen installasjonskart er tilgjengelig for dette prosjektet.',
  },
  showSelectedOnMap: {
    cz: 'Zobrazit vybrané na mapě ({{count}})',
    de: 'Ausgewählte auf Karte anzeigen ({{count}})',
    en: 'Show selected on map ({{count}})',
    sv: 'Visa valda på kartan ({{count}})',
    fi: 'Näytä valitut kartalla ({{count}})',
    nb: 'Vis valgte på kartet ({{count}})',
  },
  viewAsCharts: {
    cz: 'Zobrazit jako grafy',
    de: 'Als Diagramme anzeigen',
    en: 'View as charts',
    sv: 'Visa som diagram',
    fi: 'Näytä kaavioina',
    nb: 'Vis som diagrammer',
  },
  showAllSensors: {
    cz: 'Zobrazit všechny senzory',
    de: 'Alle Sensoren anzeigen',
    en: 'Show all sensors',
    sv: 'Visa alla sensorer',
    fi: 'Näytä kaikki anturit',
    nb: 'Vis alle sensorer',
  },
  loadingWeather: {
    cz: 'Načítání počasí…',
    de: 'Wetter wird geladen…',
    en: 'Loading weather…',
    sv: 'Laddar väder…',
    fi: 'Ladataan säätä…',
    nb: 'Laster vær…',
  },
  weatherLoadFailed: {
    cz: 'Počasí se nepodařilo načíst. Přehrávání mapy je stále k dispozici.',
    de: 'Wetter konnte nicht geladen werden. Die Kartenwiedergabe ist weiterhin verfügbar.',
    en: 'Weather could not be loaded. Map playback is still available.',
    sv: 'Vädret kunde inte laddas. Kartuppspelning är fortfarande tillgänglig.',
    fi: 'Säätä ei voitu ladata. Kartan toisto on edelleen käytettävissä.',
    nb: 'Været kunne ikke lastes. Kartavspilling er fortsatt tilgjengelig.',
  },
  noWeatherForPeriod: {
    cz: 'Pro vybrané období nejsou k dispozici žádná data o počasí.',
    de: 'Für den ausgewählten Zeitraum sind keine Wetterdaten verfügbar.',
    en: 'No weather data for the selected period.',
    sv: 'Inga väderdata för den valda perioden.',
    fi: 'Valitulta ajanjaksolta ei ole säätietoja.',
    nb: 'Ingen værdata for den valgte perioden.',
  },
  playbackWeather: {
    cz: 'Počasí při přehrávání',
    de: 'Wetter während der Wiedergabe',
    en: 'Playback weather',
    sv: 'Väder vid uppspelning',
    fi: 'Toiston sää',
    nb: 'Vær under avspilling',
  },
  playback: {
    cz: 'Přehrávání',
    de: 'Wiedergabe',
    en: 'Playback',
    sv: 'Uppspelning',
    fi: 'Toisto',
    nb: 'Avspilling',
  },
  noData: {
    cz: 'Žádná data',
    de: 'Keine Daten',
    en: 'No data',
    sv: 'Inga data',
    fi: 'Ei tietoja',
    nb: 'Ingen data',
  },
  ventCapsLoadFailed: {
    cz: 'Nepodařilo se načíst ventilační uzávěry.',
    de: 'Lüftungskappen konnten nicht geladen werden.',
    en: 'Could not load vent caps.',
    sv: 'Ventilkåpor kunde inte laddas.',
    fi: 'Venttiilikorkkeja ei voitu ladata.',
    nb: 'Kunne ikke laste ventilhetter.',
  },
  noInstallationMapAvailable: {
    cz: 'Instalační mapa není k dispozici.',
    de: 'Keine Installationskarte verfügbar.',
    en: 'No installation map is available.',
    sv: 'Ingen installationskarta är tillgänglig.',
    fi: 'Asennuskarttaa ei ole saatavilla.',
    nb: 'Ingen installasjonskart er tilgjengelig.',
  },
  noDataForPeriod: {
    cz: 'Pro toto období nejsou k dispozici žádná data.',
    de: 'Für diesen Zeitraum sind keine Daten verfügbar.',
    en: 'No data for this period.',
    sv: 'Inga data för denna period.',
    fi: 'Tältä ajanjaksolta ei ole tietoja.',
    nb: 'Ingen data for denne perioden.',
  },
  weather: {
    cz: 'Počasí',
    de: 'Wetter',
    en: 'Weather',
    sv: 'Väder',
    fi: 'Sää',
    nb: 'Vær',
  },
  outdoorTemperature: {
    cz: 'Venkovní teplota',
    de: 'Außentemperatur',
    en: 'Outdoor temperature',
    sv: 'Utomhustemperatur',
    fi: 'Ulkolämpötila',
    nb: 'Utetemperatur',
  },
  cloudCoverage: {
    cz: 'Oblačnost',
    de: 'Wolkenbedeckung',
    en: 'Cloud coverage',
    sv: 'Molntäcke',
    fi: 'Pilvipeite',
    nb: 'Skydekke',
  },
  peakHourlyPrecipitation: {
    cz: 'Nejvyšší hodinové srážky',
    de: 'Höchster stündlicher Niederschlag',
    en: 'Peak hourly precipitation',
    sv: 'Högsta nederbörd per timme',
    fi: 'Suurin tuntisade',
    nb: 'Høyeste nedbør per time',
  },
  averageOutdoorTemperature: {
    cz: 'Průměrná venkovní teplota',
    de: 'Durchschnittliche Außentemperatur',
    en: 'Average outdoor temperature',
    sv: 'Genomsnittlig utomhustemperatur',
    fi: 'Keskimääräinen ulkolämpötila',
    nb: 'Gjennomsnittlig utetemperatur',
  },
  precipitationThreeHours: {
    cz: 'Srážky [mm / 3 h]',
    de: 'Niederschlag [mm / 3 Std.]',
    en: 'Precipitation [mm / 3h]',
    sv: 'Nederbörd [mm / 3 h]',
    fi: 'Sademäärä [mm / 3 h]',
    nb: 'Nedbør [mm / 3 t]',
  },
  temperatureCelsius: {
    cz: 'Teplota [°C]',
    de: 'Temperatur [°C]',
    en: 'Temperature [°C]',
    sv: 'Temperatur [°C]',
    fi: 'Lämpötila [°C]',
    nb: 'Temperatur [°C]',
  },
  individualSensorChartDescription: {
    cz: 'Každý senzor je pro vybrané období zobrazen jako samostatná čára. Rozlišení: {{resolution}}.',
    de: 'Jeder Sensor wird für den ausgewählten Zeitraum als eigene Linie dargestellt. Auflösung: {{resolution}}.',
    en: 'Every sensor is shown as an individual line for the selected period. Resolution: {{resolution}}.',
    sv: 'Varje sensor visas som en enskild linje för den valda perioden. Upplösning: {{resolution}}.',
    fi: 'Jokainen anturi näytetään omana viivanaan valitulta ajanjaksolta. Tarkkuus: {{resolution}}.',
    nb: 'Hver sensor vises som en egen linje for den valgte perioden. Oppløsning: {{resolution}}.',
  },
  showScatterChart: {
    cz: 'Zobrazit bodový graf',
    de: 'Streudiagramm anzeigen',
    en: 'Show scatter chart',
    sv: 'Visa punktdiagram',
    fi: 'Näytä hajontakaavio',
    nb: 'Vis punktdiagram',
  },
  hideScatterChart: {
    cz: 'Skrýt bodový graf',
    de: 'Streudiagramm ausblenden',
    en: 'Hide scatter chart',
    sv: 'Dölj punktdiagram',
    fi: 'Piilota hajontakaavio',
    nb: 'Skjul punktdiagram',
  },
  limitedCoverageLegend: {
    cz: 'Senzory s omezeným pokrytím jsou zobrazeny jako prázdné symboly.',
    de: 'Sensoren mit eingeschränkter Abdeckung werden als hohle Symbole angezeigt.',
    en: 'Sensors with limited coverage are shown as hollow symbols.',
    sv: 'Sensorer med begränsad täckning visas som ihåliga symboler.',
    fi: 'Anturit, joilla on rajallinen kattavuus, näytetään onttoina symboleina.',
    nb: 'Sensorer med begrenset dekning vises som hule symboler.',
  },
  showPeriodSummary: {
    cz: 'Zobrazit souhrn vybraného období',
    de: 'Zusammenfassung des ausgewählten Zeitraums anzeigen',
    en: 'Show the selected-period summary',
    sv: 'Visa sammanfattning för vald period',
    fi: 'Näytä valitun jakson yhteenveto',
    nb: 'Vis sammendrag for valgt periode',
  },
  showLatestReadings: {
    cz: 'Zobrazit nejnovější dostupná měření (nyní)',
    de: 'Neueste verfügbare Messwerte anzeigen (Jetzt)',
    en: 'Show the latest available readings (Now)',
    sv: 'Visa de senaste tillgängliga mätningarna (Nu)',
    fi: 'Näytä uusimmat saatavilla olevat lukemat (Nyt)',
    nb: 'Vis de nyeste tilgjengelige målingene (Nå)',
  },
  periodSummary: {
    cz: 'Souhrn období',
    de: 'Zeitraumzusammenfassung',
    en: 'Period summary',
    sv: 'Periodsammanfattning',
    fi: 'Jaksoyhteenveto',
    nb: 'Periodesammendrag',
  },
  previousReading: {
    cz: 'Předchozí měření',
    de: 'Vorheriger Messwert',
    en: 'Previous reading',
    sv: 'Föregående avläsning',
    fi: 'Edellinen lukema',
    nb: 'Forrige avlesning',
  },
  nextReading: {
    cz: 'Další měření',
    de: 'Nächster Messwert',
    en: 'Next reading',
    sv: 'Nästa avläsning',
    fi: 'Seuraava lukema',
    nb: 'Neste avlesning',
  },
  pausePlayback: {
    cz: 'Pozastavit přehrávání',
    de: 'Wiedergabe pausieren',
    en: 'Pause playback',
    sv: 'Pausa uppspelning',
    fi: 'Keskeytä toisto',
    nb: 'Pause avspilling',
  },
  playCondensationTimeline: {
    cz: 'Přehrát časovou osu možné kondenzace',
    de: 'Zeitleiste möglicher Kondensation abspielen',
    en: 'Play possible condensation timeline',
    sv: 'Spela upp tidslinje för möjlig kondens',
    fi: 'Toista mahdollisen kondensaation aikajana',
    nb: 'Spill av tidslinje for mulig kondens',
  },
  playMetricDevelopment: {
    cz: 'Přehrát vývoj {{metric}}',
    de: 'Entwicklung von {{metric}} abspielen',
    en: 'Play {{metric}} development',
    sv: 'Spela upp utveckling för {{metric}}',
    fi: 'Toista {{metric}}-kehitys',
    nb: 'Spill av utvikling for {{metric}}',
  },
  pauseMetricPlayback: {
    cz: 'Pozastavit přehrávání {{metric}}',
    de: 'Wiedergabe von {{metric}} pausieren',
    en: 'Pause {{metric}} playback',
    sv: 'Pausa uppspelning av {{metric}}',
    fi: 'Keskeytä {{metric}}-toisto',
    nb: 'Pause avspilling av {{metric}}',
  },
  playbackSpeed: {
    cz: 'Rychlost přehrávání: {{speed}}×',
    de: 'Wiedergabegeschwindigkeit: {{speed}}×',
    en: 'Playback speed: {{speed}}×',
    sv: 'Uppspelningshastighet: {{speed}}×',
    fi: 'Toistonopeus: {{speed}}×',
    nb: 'Avspillingshastighet: {{speed}}×',
  },
  moistureActivityTimeline: {
    cz: 'Aktivita vlhkosti v čase',
    de: 'Feuchtigkeitsaktivität im Zeitverlauf',
    en: 'Moisture activity over time',
    sv: 'Fuktaktivitet över tid',
    fi: 'Kosteusaktiivisuus ajan kuluessa',
    nb: 'Fuktaktivitet over tid',
  },
  aggregatedDataRawFallback: {
    cz: 'Agregovaná data nejsou k dispozici. Zobrazuje se posledních 7 dní původních měření.',
    de: 'Aggregierte Daten sind nicht verfügbar. Die letzten 7 Tage der Rohmessungen werden angezeigt.',
    en: 'Aggregated data is unavailable. Showing the last 7 days of raw readings.',
    sv: 'Aggregerade data är inte tillgängliga. Visar rådata för de senaste 7 dagarna.',
    fi: 'Koostettuja tietoja ei ole saatavilla. Näytetään viimeisten 7 päivän raakamittaukset.',
    nb: 'Aggregerte data er ikke tilgjengelige. Viser råmålinger fra de siste 7 dagene.',
  },
  activityMissingData: {
    cz: 'Chybějící data',
    de: 'Fehlende Daten',
    en: 'Missing data',
    sv: 'Data saknas',
    fi: 'Puuttuvat tiedot',
    nb: 'Manglende data',
  },
  periodMeanMoisture: {
    cz: 'Průměrná vlhkost za období',
    de: 'Durchschnittliche Feuchtigkeit im Zeitraum',
    en: 'Average moisture for the period',
    sv: 'Genomsnittlig fukt under perioden',
    fi: 'Keskimääräinen kosteus ajanjaksolla',
    nb: 'Gjennomsnittlig fukt i perioden',
  },
  periodMaximumMoisture: {
    cz: 'Nejvyšší vlhkost za období',
    de: 'Höchste Feuchtigkeit im Zeitraum',
    en: 'Highest moisture for the period',
    sv: 'Högsta fukt under perioden',
    fi: 'Suurin kosteus ajanjaksolla',
    nb: 'Høyeste fukt i perioden',
  },
  activityMaximum: {
    cz: 'Maximální vlhkost: {{value}}',
    de: 'Maximale Feuchtigkeit: {{value}}',
    en: 'Maximum moisture: {{value}}',
    sv: 'Maximal fukt: {{value}}',
    fi: 'Suurin kosteus: {{value}}',
    nb: 'Maksimal fukt: {{value}}',
  },
  activityAverage: {
    cz: 'Průměrná vlhkost: {{value}}',
    de: 'Durchschnittliche Feuchtigkeit: {{value}}',
    en: 'Average moisture: {{value}}',
    sv: 'Genomsnittlig fukt: {{value}}',
    fi: 'Keskimääräinen kosteus: {{value}}',
    nb: 'Gjennomsnittlig fukt: {{value}}',
  },
  activityRedSensors: {
    cz: 'Senzory s červeným stavem: {{count}}',
    de: 'Sensoren mit rotem Status: {{count}}',
    en: 'Sensors in red status: {{count}}',
    sv: 'Sensorer med röd status: {{count}}',
    fi: 'Punaisessa tilassa olevat anturit: {{count}}',
    nb: 'Sensorer med rød status: {{count}}',
  },
  mapTime: {
    cz: 'Čas mapy {{metric}}',
    de: 'Kartenzeit für {{metric}}',
    en: '{{metric}} map time',
    sv: 'Karttid för {{metric}}',
    fi: '{{metric}}-kartan aika',
    nb: 'Karttid for {{metric}}',
  },
  minimum: {
    cz: 'Minimum',
    de: 'Minimum',
    en: 'Minimum',
    sv: 'Minimum',
    fi: 'Vähimmäisarvo',
    nb: 'Minimum',
  },
  sensorSummary: {
    cz: 'Přehled senzorů',
    de: 'Sensorübersicht',
    en: 'Sensor summary',
    sv: 'Sensoröversikt',
    fi: 'Anturiyhteenveto',
    nb: 'Sensoroversikt',
  },
  summarySortMinimum: {
    cz: 'Min',
    de: 'Min',
    en: 'Min',
    sv: 'Min',
    fi: 'Min',
    nb: 'Min',
  },
  summarySortAverage: {
    cz: 'Průměr',
    de: 'Mittel',
    en: 'Avg',
    sv: 'Snitt',
    fi: 'Keskiarvo',
    nb: 'Snitt',
  },
  summarySortMaximum: {
    cz: 'Max',
    de: 'Max',
    en: 'Max',
    sv: 'Max',
    fi: 'Max',
    nb: 'Maks',
  },
  summarySortDowntime: {
    cz: 'Výpadky %',
    de: 'Ausfall %',
    en: 'Downtime %',
    sv: 'Avbrott %',
    fi: 'Katkos %',
    nb: 'Nedetid %',
  },
  summarySortLongestGap: {
    cz: 'Max výpadek',
    de: 'Längste Lücke',
    en: 'Max gap',
    sv: 'Max avbrott',
    fi: 'Pisin katko',
    nb: 'Lengste avbr.',
  },
  summarySortLongestElevated: {
    cz: 'Nejdéle zvýšené',
    de: 'Längste Erhöhung',
    en: 'Longest elevated',
    sv: 'Längst förhöjd',
    fi: 'Pisin koholla',
    nb: 'Lengst forhøyet',
  },
  summarySortLongestDetected: {
    cz: 'Nejdelší detekce',
    de: 'Längste Erkennung',
    en: 'Longest detected',
    sv: 'Längst upptäckt',
    fi: 'Pisin havainto',
    nb: 'Lengst oppdaget',
  },
  summarySortElevated: {
    cz: 'Zvýšené %',
    de: 'Erhöht %',
    en: 'Elevated %',
    sv: 'Förhöjd %',
    fi: 'Koholla %',
    nb: 'Forhøyet %',
  },
  summarySortDetected: {
    cz: 'Zjištěno %',
    de: 'Erkannt %',
    en: 'Detected %',
    sv: 'Upptäckt %',
    fi: 'Havaittu %',
    nb: 'Oppdaget %',
  },
  summarySortAscending: {
    cz: 'Seřadit vzestupně',
    de: 'Aufsteigend sortieren',
    en: 'Sort ascending',
    sv: 'Sortera stigande',
    fi: 'Lajittele nousevasti',
    nb: 'Sorter stigende',
  },
  summarySortDescending: {
    cz: 'Seřadit sestupně',
    de: 'Absteigend sortieren',
    en: 'Sort descending',
    sv: 'Sortera fallande',
    fi: 'Lajittele laskevasti',
    nb: 'Sorter synkende',
  },
  summaryDowntimeDetails: {
    cz: 'Nejdelší výpadek {{gap}} · pokrytí {{coverage}}',
    de: 'Längste Lücke {{gap}} · Abdeckung {{coverage}}',
    en: 'Longest gap {{gap}} · coverage {{coverage}}',
    sv: 'Längsta avbrott {{gap}} · täckning {{coverage}}',
    fi: 'Pisin katkos {{gap}} · kattavuus {{coverage}}',
    nb: 'Lengste avbrudd {{gap}} · dekning {{coverage}}',
  },
  summaryTemperatureDetails: {
    cz: 'Průměr {{average}} · Min {{min}} · Max {{max}}',
    de: 'Mittel {{average}} · Min {{min}} · Max {{max}}',
    en: 'Average {{average}} · Min {{min}} · Max {{max}}',
    sv: 'Snitt {{average}} · Min {{min}} · Max {{max}}',
    fi: 'Keskiarvo {{average}} · Min {{min}} · Max {{max}}',
    nb: 'Snitt {{average}} · Min {{min}} · Maks {{max}}',
  },
  summaryDetectedDetails: {
    cz: 'Zjištěno po {{percent}} sledované doby',
    de: 'Während {{percent}} der beobachteten Zeit erkannt',
    en: 'Detected {{percent}} of observed time',
    sv: 'Upptäckt under {{percent}} av observationstiden',
    fi: 'Havaittu {{percent}} seuranta-ajasta',
    nb: 'Registrert i {{percent}} av observert tid',
  },
  summaryElevatedDetails: {
    cz: 'Zvýšené po {{percent}} doby · Min {{min}} · Max {{max}}',
    de: 'Während {{percent}} der Zeit erhöht · Min {{min}} · Max {{max}}',
    en: 'Elevated {{percent}} of the time · Min {{min}} · Max {{max}}',
    sv: 'Förhöjd under {{percent}} av tiden · Min {{min}} · Max {{max}}',
    fi: 'Koholla {{percent}} ajasta · Min {{min}} · Max {{max}}',
    nb: 'Forhøyet {{percent}} av tiden · Min {{min}} · Maks {{max}}',
  },
  summaryCoverage: {
    cz: 'Pokrytí dat {{coverage}}',
    de: 'Datenabdeckung {{coverage}}',
    en: 'Data coverage {{coverage}}',
    sv: 'Datatäckning {{coverage}}',
    fi: 'Datan kattavuus {{coverage}}',
    nb: 'Datadekning {{coverage}}',
  },
  showSensorSummary: {
    cz: 'Zobrazit přehled senzorů',
    de: 'Sensorübersicht anzeigen',
    en: 'Show sensor summary',
    sv: 'Visa sensoröversikt',
    fi: 'Näytä anturiyhteenveto',
    nb: 'Vis sensoroversikt',
  },
  hideSensorSummary: {
    cz: 'Skrýt přehled senzorů',
    de: 'Sensorübersicht ausblenden',
    en: 'Hide sensor summary',
    sv: 'Dölj sensoröversikt',
    fi: 'Piilota anturiyhteenveto',
    nb: 'Skjul sensoroversikt',
  },
  installationMedian: {
    cz: 'Medián instalace {{value}}',
    de: 'Installationsmedian {{value}}',
    en: 'Installation median {{value}}',
    sv: 'Installationsmedian {{value}}',
    fi: 'Asennuksen mediaani {{value}}',
    nb: 'Installasjonsmedian {{value}}',
  },
  possibleCondensation: {
    cz: 'Možná kondenzace',
    de: 'Mögliche Kondensation',
    en: 'Possible condensation',
    sv: 'Möjlig kondens',
    fi: 'Mahdollinen kondensaatio',
    nb: 'Mulig kondens',
  },
  signalGaps: {
    cz: 'Mezery signálu',
    de: 'Signallücken',
    en: 'Signal gaps',
    sv: 'Signalavbrott',
    fi: 'Signaalikatkot',
    nb: 'Signalbrudd',
  },
  signalGap: {
    cz: 'Mezera signálu',
    de: 'Signallücke',
    en: 'Signal gap',
    sv: 'Signalavbrott',
    fi: 'Signaalikatko',
    nb: 'Signalbrudd',
  },
  noQualifyingSignalGap: {
    cz: 'Žádná vyhovující mezera signálu',
    de: 'Keine relevante Signallücke',
    en: 'No qualifying signal gap',
    sv: 'Inget kvalificerande signalavbrott',
    fi: 'Ei määritelmän mukaista signaalikatkoa',
    nb: 'Ingen kvalifiserende signalavbrudd',
  },
  downtimeOverview: {
    cz: 'Přehled výpadků',
    de: 'Ausfallzeitübersicht',
    en: 'Downtime overview',
    sv: 'Översikt över driftstopp',
    fi: 'Käyttökatkojen yleiskatsaus',
    nb: 'Oversikt over nedetid',
  },
  goodCoverage: {
    cz: 'Dobré pokrytí',
    de: 'Gute Abdeckung',
    en: 'Good coverage',
    sv: 'God täckning',
    fi: 'Hyvä kattavuus',
    nb: 'God dekning',
  },
  withGaps: {
    cz: 'S mezerami',
    de: 'Mit Lücken',
    en: 'With gaps',
    sv: 'Med avbrott',
    fi: 'Katkoja sisältävät',
    nb: 'Med avbrudd',
  },
  viewOnMap: {
    cz: 'Zobrazit {{count}} na mapě',
    de: '{{count}} auf Karte anzeigen',
    en: 'View {{count}} on map',
    sv: 'Visa {{count}} på kartan',
    fi: 'Näytä {{count}} kartalla',
    nb: 'Vis {{count}} på kartet',
  },
  analysis: {
    cz: 'Analýza',
    de: 'Analyse',
    en: 'Analysis',
    sv: 'Analys',
    fi: 'Analyysi',
    nb: 'Analyse',
  },
  grouped: {
    cz: 'Seskupené',
    de: 'Gruppiert',
    en: 'Grouped',
    sv: 'Grupperad',
    fi: 'Ryhmitelty',
    nb: 'Gruppert',
  },
  groupedChartModeDescription: {
    cz: 'Seskupí senzory v grafech níže podle stavu nebo podobného průběhu teploty.',
    de: 'Gruppiert Sensoren in den Diagrammen unten nach Status oder ähnlichem Temperaturverlauf.',
    en: 'Groups sensors by status or similar temperature patterns in the charts below.',
    sv: 'Grupperar sensorer efter status eller liknande temperaturmönster i diagrammen nedan.',
    fi: 'Ryhmittelee anturit tilan tai samankaltaisen lämpötilakehityksen mukaan alla olevissa kaavioissa.',
    nb: 'Grupperer sensorer etter status eller lignende temperaturmønstre i grafene nedenfor.',
  },
  relativeHumidity: {
    cz: 'Relativní vlhkost',
    de: 'Relative Luftfeuchtigkeit',
    en: 'Relative humidity',
    sv: 'Relativ luftfuktighet',
    fi: 'Suhteellinen kosteus',
    nb: 'Relativ luftfuktighet',
  },
  noMetricDataForPeriod: {
    cz: 'Pro toto období nejsou k dispozici data {{metric}}.',
    de: 'Für diesen Zeitraum sind keine {{metric}}-Daten verfügbar.',
    en: 'No {{metric}} data is available for this period.',
    sv: 'Inga {{metric}}data är tillgängliga för denna period.',
    fi: 'Tältä ajanjaksolta ei ole {{metric}}-tietoja.',
    nb: 'Ingen {{metric}}data er tilgjengelig for denne perioden.',
  },
  detected: {
    cz: 'Zjištěno',
    de: 'Erkannt',
    en: 'Detected',
    sv: 'Upptäckt',
    fi: 'Havaittu',
    nb: 'Oppdaget',
  },
  notDetected: {
    cz: 'Nezjištěno',
    de: 'Nicht erkannt',
    en: 'Not detected',
    sv: 'Inte upptäckt',
    fi: 'Ei havaittu',
    nb: 'Ikke oppdaget',
  },
  warmer: {
    cz: 'Teplejší',
    de: 'Wärmer',
    en: 'Warmer',
    sv: 'Varmare',
    fi: 'Lämpimämpi',
    nb: 'Varmere',
  },
  cooler: {
    cz: 'Chladnější',
    de: 'Kühler',
    en: 'Cooler',
    sv: 'Kallare',
    fi: 'Viileämpi',
    nb: 'Kaldere',
  },
  typical: {
    cz: 'Typické',
    de: 'Typisch',
    en: 'Typical',
    sv: 'Typisk',
    fi: 'Tyypillinen',
    nb: 'Typisk',
  },
  similarTemperatureProfiles: {
    cz: 'Podobné teplotní profily',
    de: 'Ähnliche Temperaturprofile',
    en: 'Similar temperature profiles',
    sv: 'Liknande temperaturprofiler',
    fi: 'Samankaltaiset lämpötilaprofiilit',
    nb: 'Lignende temperaturprofiler',
  },
  temperatureGroups: {
    cz: 'Teplotní skupiny',
    de: 'Temperaturgruppen',
    en: 'Temperature groups',
    sv: 'Temperaturgrupper',
    fi: 'Lämpötilaryhmät',
    nb: 'Temperaturgrupper',
  },
  sensorStatusGroups: {
    cz: 'Skupiny stavů senzorů',
    de: 'Sensorstatusgruppen',
    en: 'Sensor status groups',
    sv: 'Sensorstatusgrupper',
    fi: 'Anturien tilaryhmät',
    nb: 'Sensorstatusgrupper',
  },
  allYellowSensorsWarning: {
    cz: 'Všechny senzory, které dosáhly žlutého stavu, jsou zobrazeny jednotlivě jako varování.',
    de: 'Alle Sensoren, die den gelben Status erreicht haben, werden einzeln als Warnung angezeigt.',
    en: 'All sensors that reached yellow status are shown individually as Warning.',
    sv: 'Alla sensorer som nådde gul status visas individuellt som Varning.',
    fi: 'Kaikki keltaisen tilan saavuttaneet anturit näytetään yksittäin varoituksena.',
    nb: 'Alle sensorer som nådde gul status vises enkeltvis som advarsel.',
  },
  humidityWarningDescription: {
    cz: 'Žluté senzory jsou jednotlivě zobrazeny jako varování, když jejich maximum relativní vlhkosti ve vybraném období dosáhne alespoň {{threshold}} %.',
    de: 'Gelbe Sensoren werden einzeln als Warnung angezeigt, wenn ihre maximale relative Luftfeuchtigkeit im ausgewählten Zeitraum mindestens {{threshold}} % beträgt.',
    en: 'Yellow sensors are shown individually as Warning when their selected-period maximum RH is at least {{threshold}}%.',
    sv: 'Gula sensorer visas individuellt som Varning när deras högsta RH under vald period är minst {{threshold}}%.',
    fi: 'Keltaiset anturit näytetään yksittäin varoituksena, kun niiden valitun jakson suurin RH on vähintään {{threshold}} %.',
    nb: 'Gule sensorer vises enkeltvis som advarsel når maksimal RH i valgt periode er minst {{threshold}}%.',
  },
  moistureWarningDescription: {
    cz: 'Žluté senzory jsou jednotlivě zobrazeny jako varování, když jejich maximum vlhkosti ve vybraném období dosáhne alespoň {{threshold}}.',
    de: 'Gelbe Sensoren werden einzeln als Warnung angezeigt, wenn ihr maximaler Feuchtewert im ausgewählten Zeitraum mindestens {{threshold}} beträgt.',
    en: 'Yellow sensors are shown individually as Warning when their selected-period maximum moisture is at least {{threshold}}.',
    sv: 'Gula sensorer visas individuellt som Varning när deras högsta fuktvärde under vald period är minst {{threshold}}.',
    fi: 'Keltaiset anturit näytetään yksittäin varoituksena, kun niiden valitun jakson suurin kosteusarvo on vähintään {{threshold}}.',
    nb: 'Gule sensorer vises enkeltvis som advarsel når maksimal fukt i valgt periode er minst {{threshold}}.',
  },
  woodSensorGroupingDescription: {
    cz: 'Dřevěné senzory jsou seskupeny podle nejvyššího zaznamenaného stavu ve vybraném období.',
    de: 'Holzsensoren werden nach ihrem höchsten aufgezeichneten Status im ausgewählten Zeitraum gruppiert.',
    en: 'Wood sensors are grouped by their highest recorded status in the selected period.',
    sv: 'Träsensorer grupperas efter sin högsta registrerade status under vald period.',
    fi: 'Puuanturit ryhmitellään valitun ajanjakson korkeimman tallennetun tilan mukaan.',
    nb: 'Trefuktsensorer grupperes etter høyeste registrerte status i valgt periode.',
  },
  sensorFamily: {
    cz: 'Rodina senzoru',
    de: 'Sensorfamilie',
    en: 'Sensor family',
    sv: 'Sensorfamilj',
    fi: 'Anturiperhe',
    nb: 'Sensorfamilie',
  },
  analysisType: {
    cz: 'Typ analýzy',
    de: 'Analysetyp',
    en: 'Analysis type',
    sv: 'Analystyp',
    fi: 'Analyysityyppi',
    nb: 'Analysetype',
  },
  moistureStatusDescription: {
    cz: 'Senzory, které dosáhly červeného stavu, jsou červené. Žluté senzory, jejichž maximum vlhkosti ve vybraném období je alespoň {{threshold}}, jsou varování. Zbývající senzory jsou Normální.',
    de: 'Sensoren mit rotem Status sind Rot. Gelbe Sensoren mit einer maximalen Feuchte von mindestens {{threshold}} im ausgewählten Zeitraum sind Warnung. Die übrigen Sensoren sind Normal.',
    en: 'Sensors that reached red status are Red. Yellow sensors whose selected-period maximum moisture is at least {{threshold}} are Warning. The remaining sensors are Normal.',
    sv: 'Sensorer som nådde röd status är Röda. Gula sensorer vars högsta fuktvärde under vald period är minst {{threshold}} är Varning. Övriga sensorer är Normal.',
    fi: 'Punaisen tilan saavuttaneet anturit ovat punaisia. Keltaiset anturit, joiden valitun jakson suurin kosteusarvo on vähintään {{threshold}}, ovat varoituksia. Muut anturit ovat Normaali.',
    nb: 'Sensorer som nådde rød status er Røde. Gule sensorer med maksimal fukt på minst {{threshold}} i valgt periode er Advarsel. De øvrige sensorene er Normal.',
  },
  temperatureStatusDescriptionSingle: {
    cz: 'Senzory jsou seskupeny podle průměrné teploty a změny teploty ve vybraném období. Jejich teplotní profily jsou podobné, proto je zobrazena jedna skupina.',
    de: 'Sensoren werden nach durchschnittlicher Temperatur und Temperaturvariation im ausgewählten Zeitraum gruppiert. Ihre Temperaturprofile sind ähnlich, daher wird eine Gruppe angezeigt.',
    en: 'Sensors are grouped by their average temperature and temperature variation in the selected period. Their temperature profiles are similar, so one group is shown.',
    sv: 'Sensorer grupperas efter genomsnittlig temperatur och temperaturvariation under vald period. Deras temperaturprofiler är lika, så en grupp visas.',
    fi: 'Anturit ryhmitellään valitun ajanjakson keskilämpötilan ja lämpötilavaihtelun mukaan. Lämpötilaprofiilit ovat samankaltaisia, joten yksi ryhmä näytetään.',
    nb: 'Sensorer grupperes etter gjennomsnittstemperatur og temperaturvariasjon i valgt periode. Temperaturprofilene er like, så én gruppe vises.',
  },
  temperatureStatusDescriptionMultiple: {
    cz: 'Senzory jsou seskupeny podle průměrné teploty a změny teploty ve vybraném období. Zobrazeno je {{count}} odlišných skupin teplotních profilů.',
    de: 'Sensoren werden nach durchschnittlicher Temperatur und Temperaturvariation im ausgewählten Zeitraum gruppiert. {{count}} unterschiedliche Temperaturprofilgruppen werden angezeigt.',
    en: 'Sensors are grouped by their average temperature and temperature variation in the selected period. {{count}} distinct temperature profile groups are shown.',
    sv: 'Sensorer grupperas efter genomsnittlig temperatur och temperaturvariation under vald period. {{count}} olika temperaturprofilgrupper visas.',
    fi: 'Anturit ryhmitellään valitun ajanjakson keskilämpötilan ja lämpötilavaihtelun mukaan. Näytetään {{count}} erillistä lämpötilaprofiiliryhmää.',
    nb: 'Sensorer grupperes etter gjennomsnittstemperatur og temperaturvariasjon i valgt periode. {{count}} ulike temperaturprofilgrupper vises.',
  },
  relativeHumidityStatusDescription: {
    cz: 'Senzory, které dosáhly červeného stavu, jsou červené. Žluté senzory, jejichž maximum relativní vlhkosti ve vybraném období je alespoň {{threshold}} %, jsou varování. Zbývající senzory jsou Normální.',
    de: 'Sensoren mit rotem Status sind Rot. Gelbe Sensoren mit einer maximalen relativen Luftfeuchtigkeit von mindestens {{threshold}} % im ausgewählten Zeitraum sind Warnung. Die übrigen Sensoren sind Normal.',
    en: 'Sensors that reached red status are Red. Yellow sensors whose selected-period maximum RH is at least {{threshold}}% are Warning. The remaining sensors are Normal.',
    sv: 'Sensorer som nådde röd status är Röda. Gula sensorer vars högsta RH under vald period är minst {{threshold}}% är Varning. Övriga sensorer är Normal.',
    fi: 'Punaisen tilan saavuttaneet anturit ovat punaisia. Keltaiset anturit, joiden valitun jakson suurin RH on vähintään {{threshold}} %, ovat varoituksia. Muut anturit ovat Normaali.',
    nb: 'Sensorer som nådde rød status er Røde. Gule sensorer med maksimal RH på minst {{threshold}}% i valgt periode er Advarsel. De øvrige sensorene er Normal.',
  },
  threeHourAggregatedData: {
    cz: '3hodinová agregovaná data',
    de: '3-Stunden-aggregierte Daten',
    en: '3-hour aggregated data',
    sv: '3-timmars aggregerade data',
    fi: '3 tunnin koosteiset tiedot',
    nb: '3-timers aggregerte data',
  },
  dailySensorData: {
    cz: 'Denní data senzoru',
    de: 'Tägliche Sensordaten',
    en: 'daily sensor data',
    sv: 'dagliga sensordata',
    fi: 'päivittäiset anturitiedot',
    nb: 'daglige sensordata',
  },
  hourlySensorData: {
    cz: 'Hodinová data senzoru',
    de: 'Stündliche Sensordaten',
    en: 'hourly sensor data',
    sv: 'sensorvärden per timme',
    fi: 'tunnittaiset anturitiedot',
    nb: 'sensorverdier per time',
  },
  twentyMinuteSensorData: {
    cz: '20minutová data senzoru',
    de: '20-Minuten-Sensordaten',
    en: '20-minute sensor data',
    sv: '20-minuters sensordata',
    fi: '20 minuutin anturitiedot',
    nb: '20-minutters sensordata',
  },
  averageShort: {
    cz: 'Prům',
    de: 'Mittelw',
    en: 'Avg',
    sv: 'Medel',
    fi: 'Ka',
    nb: 'Snitt',
  },
  average: {
    cz: 'Průměr',
    de: 'Durchschnitt',
    en: 'Average',
    sv: 'Genomsnitt',
    fi: 'Keskiarvo',
    nb: 'Gjennomsnitt',
  },
  variation: {
    cz: 'Variace',
    de: 'Variation',
    en: 'Variation',
    sv: 'Variation',
    fi: 'Vaihtelu',
    nb: 'Variasjon',
  },
  overNinetyFivePercent: {
    cz: 'Více než 95 %',
    de: 'Über 95 %',
    en: 'Over 95%',
    sv: 'Över 95 %',
    fi: 'Yli 95 %',
    nb: 'Over 95 %',
  },
  noReadingsAtTime: {
    cz: 'V tomto čase nejsou žádná měření.',
    de: 'Zu diesem Zeitpunkt liegen keine Messwerte vor.',
    en: 'No readings at this time.',
    sv: 'Inga avläsningar vid denna tidpunkt.',
    fi: 'Tällä hetkellä ei ole lukemia.',
    nb: 'Ingen målinger på dette tidspunktet.',
  },
  showingClosestValues: {
    cz: 'Zobrazuje se {{visible}} nejbližších z {{total}} hodnot',
    de: '{{visible}} nächste von {{total}} Werten werden angezeigt',
    en: 'Showing {{visible}} closest of {{total}} values',
    sv: 'Visar {{visible}} närmaste av {{total}} värden',
    fi: 'Näytetään {{visible}} lähintä {{total}} arvosta',
    nb: 'Viser {{visible}} nærmeste av {{total}} verdier',
  },
  insufficientData: {
    cz: 'Nedostatek dat',
    de: 'Unzureichende Daten',
    en: 'Insufficient data',
    sv: 'Otillräckliga data',
    fi: 'Riittämättömät tiedot',
    nb: 'Utilstrekkelige data',
  },
  mean: {
    cz: 'Průměr',
    de: 'Mittelwert',
    en: 'Mean',
    sv: 'Medelvärde',
    fi: 'Keskiarvo',
    nb: 'Gjennomsnitt',
  },
  standardDeviation: {
    cz: 'Směrodatná odchylka',
    de: 'Standardabweichung',
    en: 'Standard deviation',
    sv: 'Standardavvikelse',
    fi: 'Keskihajonta',
    nb: 'Standardavvik',
  },
  percentile95: {
    cz: '95. percentil',
    de: '95. Perzentil',
    en: '95th percentile',
    sv: '95:e percentilen',
    fi: '95. persentiili',
    nb: '95. persentil',
  },
  maximum: {
    cz: 'Maximum',
    de: 'Maximum',
    en: 'Maximum',
    sv: 'Maximum',
    fi: 'Enimmäisarvo',
    nb: 'Maksimum',
  },
  coverage: {
    cz: 'Pokrytí',
    de: 'Abdeckung',
    en: 'Coverage',
    sv: 'Täckning',
    fi: 'Kattavuus',
    nb: 'Dekning',
  },
  dataCoverage: {
    cz: 'Pokrytí dat',
    de: 'Datenabdeckung',
    en: 'Data coverage',
    sv: 'Datatäckning',
    fi: 'Datan kattavuus',
    nb: 'Datadekning',
  },
  minimumShort: {
    cz: 'Min',
    de: 'Min',
    en: 'Min',
    sv: 'Min',
    fi: 'Min',
    nb: 'Min',
  },
  maximumShort: {
    cz: 'Max',
    de: 'Max',
    en: 'Max',
    sv: 'Max',
    fi: 'Maks',
    nb: 'Maks',
  },
  mapTooltipAverage: {
    cz: 'Prům.',
    de: 'Ø',
    en: 'Avg',
    sv: 'Medel',
    fi: 'KA',
    nb: 'Snitt',
  },
  mapTooltipTemperature: {
    cz: 'Tepl.',
    de: 'Temp.',
    en: 'Temp.',
    sv: 'Temp.',
    fi: 'Lämp.',
    nb: 'Temp.',
  },
  mapTooltipRelativeHumidity: {
    cz: 'Rel. vlhk.',
    de: 'Rel. LF',
    en: 'RH',
    sv: 'RF',
    fi: 'SK',
    nb: 'RF',
  },
  mapTooltipWoodMoisture: {
    cz: 'Vlhk. dřeva',
    de: 'Holzfeuchte',
    en: 'Wood moist.',
    sv: 'Träfukt',
    fi: 'Puunkost.',
    nb: 'Trefukt',
  },
  mapTooltipCondensation: {
    cz: 'Možná kond.',
    de: 'Mögl. Kondens.',
    en: 'Poss. condens.',
    sv: 'Möjlig kondens',
    fi: 'Mahd. kondens.',
    nb: 'Mulig kondens',
  },
  mapTooltipSignal: {
    cz: 'Signál',
    de: 'Signal',
    en: 'Signal',
    sv: 'Signal',
    fi: 'Signaali',
    nb: 'Signal',
  },
  longestGap: {
    cz: 'Max výpadek',
    de: 'Max. Datenlücke',
    en: 'Max gap',
    sv: 'Max avbrott',
    fi: 'Pisin katko',
    nb: 'Lengste avbr.',
  },
  periodDowntime: {
    cz: 'Doba výpadku za období',
    de: 'Ausfallzeit im Zeitraum',
    en: 'Period downtime',
    sv: 'Avbrottstid under perioden',
    fi: 'Jakson katkoaika',
    nb: 'Nedetid i perioden',
  },
  periodMinimum: {
    cz: 'Min (období)',
    de: 'Min (Zeitraum)',
    en: 'Min (period)',
    sv: 'Min (period)',
    fi: 'Min (jakso)',
    nb: 'Min (periode)',
  },
  timeBuckets: {
    cz: 'Časové intervaly',
    de: 'Zeitintervalle',
    en: 'Time buckets',
    sv: 'Tidsintervall',
    fi: 'Aikavälit',
    nb: 'Tidsintervaller',
  },
  cloudBase: {
    cz: 'Základna oblačnosti',
    de: 'Wolkenbasis',
    en: 'Cloud base',
    sv: 'Molnbas',
    fi: 'Pilvipohja',
    nb: 'Skybase',
  },
  weatherClearSky: {
    cz: 'Jasno',
    de: 'Klarer Himmel',
    en: 'Clear sky',
    sv: 'Klart',
    fi: 'Selkeää',
    nb: 'Klarvær',
  },
  weatherMostlyClear: {
    cz: 'Převážně jasno',
    de: 'Überwiegend klar',
    en: 'Mostly clear',
    sv: 'Mest klart',
    fi: 'Enimmäkseen selkeää',
    nb: 'Lettskyet',
  },
  weatherPartlyCloudy: {
    cz: 'Polojasno',
    de: 'Teilweise bewölkt',
    en: 'Partly cloudy',
    sv: 'Halvklart',
    fi: 'Puolipilvistä',
    nb: 'Delvis skyet',
  },
  weatherCloudy: {
    cz: 'Oblačno',
    de: 'Bewölkt',
    en: 'Cloudy',
    sv: 'Molnigt',
    fi: 'Pilvistä',
    nb: 'Skyet',
  },
  weatherOvercast: {
    cz: 'Zataženo',
    de: 'Bedeckt',
    en: 'Overcast',
    sv: 'Mulet',
    fi: 'Täysin pilvistä',
    nb: 'Overskyet',
  },
  weatherUnknownSky: {
    cz: 'Neznámý stav oblohy',
    de: 'Unbekannter Himmelszustand',
    en: 'Unknown sky conditions',
    sv: 'Okänt himmelstillstånd',
    fi: 'Tuntemattomat taivasolosuhteet',
    nb: 'Ukjente himmelforhold',
  },
  cloudy: {
    cz: 'Oblačno',
    de: 'Bewölkt',
    en: 'Cloudy',
    sv: 'Molnigt',
    fi: 'Pilvistä',
    nb: 'Skyet',
  },
  outdoorRelativeHumidity: {
    cz: 'Venkovní relativní vlhkost',
    de: 'Relative Außenluftfeuchtigkeit',
    en: 'Outdoor RH',
    sv: 'Relativ luftfuktighet utomhus',
    fi: 'Ulkotilan RH',
    nb: 'Utendørs RH',
  },
  temperatureMapDescription: {
    cz: 'Zobrazuje teploty naměřené senzory ve vybraném období. Modré oblasti jsou chladnější a červené teplejší.',
    de: 'Zeigt die von Sensoren im ausgewählten Zeitraum gemessenen Temperaturen. Blaue Bereiche sind kühler und rote wärmer.',
    en: 'Shows temperatures measured by sensors in the selected period. Blue areas are cooler and red areas are warmer.',
    sv: 'Visar temperaturer som uppmätts av sensorer under vald period. Blå områden är kallare och röda varmare.',
    fi: 'Näyttää antureiden valitulla ajanjaksolla mittaamat lämpötilat. Siniset alueet ovat viileämpiä ja punaiset lämpimämpiä.',
    nb: 'Viser temperaturer målt av sensorer i valgt periode. Blå områder er kaldere og røde varmere.',
  },
  downtimeMapDescription: {
    cz: 'Zobrazuje výpadek senzoru ve vybraném období. Zahrnuty jsou pouze mezery šest hodin nebo delší.',
    de: 'Zeigt Sensorausfallzeiten im ausgewählten Zeitraum. Nur Lücken von sechs Stunden oder länger sind enthalten.',
    en: 'Shows sensor downtime in the selected period. Only gaps of six hours or more are included.',
    sv: 'Visar sensorers driftstopp under vald period. Endast avbrott på sex timmar eller mer ingår.',
    fi: 'Näyttää anturien käyttökatkot valitulla ajanjaksolla. Vain vähintään kuuden tunnin katkot sisältyvät.',
    nb: 'Viser sensors nedetid i valgt periode. Bare avbrudd på seks timer eller mer er inkludert.',
  },
  condensationMapDescription: {
    cz: 'Zobrazuje senzory, u kterých byla ve vybraném období zjištěna možná kondenzace. Oranžové oblasti označují možnou kondenzaci.',
    de: 'Zeigt Sensoren, bei denen im ausgewählten Zeitraum mögliche Kondensation erkannt wurde. Orange Bereiche zeigen mögliche Kondensation an.',
    en: 'Shows sensors where possible condensation was detected in the selected period. Orange areas indicate possible condensation.',
    sv: 'Visar sensorer där möjlig kondens upptäcktes under vald period. Orange områden indikerar möjlig kondens.',
    fi: 'Näyttää anturit, joissa mahdollinen kondensaatio havaittiin valitulla ajanjaksolla. Oranssit alueet osoittavat mahdollista kondensaatiota.',
    nb: 'Viser sensorer der mulig kondens ble oppdaget i valgt periode. Oransje områder viser mulig kondens.',
  },
  elevatedMapDescription: {
    cz: 'Zobrazuje senzory se zvýšenou hodnotou {{metric}} ve vybraném období. Zvýšená znamená {{metric}} na úrovni nebo nad {{threshold}}.',
    de: 'Zeigt Sensoren mit erhöhtem {{metric}} im ausgewählten Zeitraum. Erhöht bedeutet {{metric}} bei oder über {{threshold}}.',
    en: 'Shows sensors that measured elevated {{metric}} in the selected period. Elevated means {{metric}} at or above {{threshold}}.',
    sv: 'Visar sensorer som mätte förhöjt {{metric}} under vald period. Förhöjt betyder {{metric}} vid eller över {{threshold}}.',
    fi: 'Näyttää anturit, jotka mittasivat kohonnutta arvoa {{metric}} valitulla ajanjaksolla. Kohonnut tarkoittaa {{metric}}-arvoa vähintään {{threshold}}.',
    nb: 'Viser sensorer som målte forhøyet {{metric}} i valgt periode. Forhøyet betyr {{metric}} på eller over {{threshold}}.',
  },
  limitedDataMarkerDescription: {
    cz: 'Přerušovaná značka senzoru znamená, že jsou k dispozici omezená data.',
    de: 'Eine gestrichelte Sensormarkierung bedeutet, dass nur begrenzte Daten verfügbar sind.',
    en: 'A dashed sensor marker means limited data is available.',
    sv: 'En streckad sensormarkör betyder att begränsade data är tillgängliga.',
    fi: 'Katkoviivallinen anturimerkki tarkoittaa, että tietoja on saatavilla rajoitetusti.',
    nb: 'En stiplet sensormarkør betyr at begrensede data er tilgjengelige.',
  },
  noDowntime: {
    cz: 'Žádný výpadek',
    de: 'Keine Ausfallzeit',
    en: 'No downtime',
    sv: 'Inget driftstopp',
    fi: 'Ei käyttökatkoa',
    nb: 'Ingen nedetid',
  },
  moreDowntime: {
    cz: 'Více výpadků',
    de: 'Mehr Ausfallzeit',
    en: 'More downtime',
    sv: 'Mer driftstopp',
    fi: 'Enemmän käyttökatkoa',
    nb: 'Mer nedetid',
  },
  moreOftenDetected: {
    cz: 'Častěji zjištěno',
    de: 'Häufiger erkannt',
    en: 'More often detected',
    sv: 'Oftare upptäckt',
    fi: 'Havaittu useammin',
    nb: 'Oftere oppdaget',
  },
  lowRelativeHumidity: {
    cz: 'Nízká relativní vlhkost',
    de: 'Niedrige relative Luftfeuchtigkeit',
    en: 'Low RH',
    sv: 'Låg RH',
    fi: 'Matala RH',
    nb: 'Lav RH',
  },
  highRelativeHumidity: {
    cz: 'Vysoká relativní vlhkost',
    de: 'Hohe relative Luftfeuchtigkeit',
    en: 'High RH',
    sv: 'Hög RH',
    fi: 'Korkea RH',
    nb: 'Høy RH',
  },
  noWoodMoisture: {
    cz: 'Žádná vlhkost dřeva',
    de: 'Keine Holzfeuchte',
    en: 'No wood moisture',
    sv: 'Ingen träfukt',
    fi: 'Ei puukosteutta',
    nb: 'Ingen trefukt',
  },
  higherWoodMoisture: {
    cz: 'Vyšší vlhkost dřeva',
    de: 'Höhere Holzfeuchte',
    en: 'Higher wood moisture',
    sv: 'Högre träfukt',
    fi: 'Korkeampi puukosteus',
    nb: 'Høyere trefukt',
  },
  noMoisture: {
    cz: 'Žádná vlhkost',
    de: 'Keine Feuchte',
    en: 'No moisture',
    sv: 'Ingen fukt',
    fi: 'Ei kosteutta',
    nb: 'Ingen fukt',
  },
  higherMoisture: {
    cz: 'Vyšší vlhkost',
    de: 'Höhere Feuchte',
    en: 'Higher moisture',
    sv: 'Högre fukt',
    fi: 'Korkeampi kosteus',
    nb: 'Høyere fukt',
  },
  individual: {
    cz: 'Jednotlivé',
    de: 'Einzeln',
    en: 'Individual',
    sv: 'Individuella',
    fi: 'Yksittäiset',
    nb: 'Individuell',
  },
  individualChartModeDescription: {
    cz: 'Zobrazí každý senzor samostatnou čarou v grafech níže.',
    de: 'Zeigt jeden Sensor als eigene Linie in den Diagrammen unten.',
    en: 'Shows each sensor as its own line in the charts below.',
    sv: 'Visar varje sensor som en egen linje i diagrammen nedan.',
    fi: 'Näyttää jokaisen anturin omana viivanaan alla olevissa kaavioissa.',
    nb: 'Viser hver sensor som sin egen linje i grafene nedenfor.',
  },
  continuousLine: {
    cz: 'Souvislá čára',
    de: 'Durchgehende Linie',
    en: 'Continuous line',
    sv: 'Sammanhängande linje',
    fi: 'Yhtenäinen viiva',
    nb: 'Sammenhengende linje',
  },
  continuousLineDescription: {
    cz: 'Spojí měření přes období bez dat.',
    de: 'Verbindet Messwerte über Zeiträume ohne Daten hinweg.',
    en: 'Connects readings across periods without data.',
    sv: 'Sammanbinder mätvärden över perioder utan data.',
    fi: 'Yhdistää mittaukset jaksojen yli, joilta puuttuu dataa.',
    nb: 'Kobler målinger på tvers av perioder uten data.',
  },
  pageOrientation: {
    cz: 'Orientace stránky',
    de: 'Seitenausrichtung',
    en: 'Page orientation',
    sv: 'Sidorientering',
    fi: 'Sivun suunta',
    nb: 'Sideorientering',
  },
  landscape: {
    cz: 'Na šířku',
    de: 'Querformat',
    en: 'Landscape',
    sv: 'Liggande',
    fi: 'Vaaka',
    nb: 'Liggende',
  },
  portrait: {
    cz: 'Na výšku',
    de: 'Hochformat',
    en: 'Portrait',
    sv: 'Stående',
    fi: 'Pysty',
    nb: 'Stående',
  },
  sensorCharts: {
    cz: 'Grafy senzorů',
    de: 'Sensordiagramme',
    en: 'Sensor charts',
    sv: 'Sensordiagram',
    fi: 'Anturikaaviot',
    nb: 'Sensorgrafer',
  },
  metric: {
    cz: 'Metrika',
    de: 'Messwert',
    en: 'Metric',
    sv: 'Mätvärde',
    fi: 'Mittari',
    nb: 'Måleverdi',
  },
  mapData: {
    cz: 'Data mapy',
    de: 'Kartendaten',
    en: 'Map data',
    sv: 'Kartdata',
    fi: 'Karttatiedot',
    nb: 'Kartdata',
  },
  downtimeDataMapping: {
    cz: 'Mapa výpadků',
    de: 'Karte der Ausfallzeiten',
    en: 'Downtime map',
    sv: 'Driftstoppskarta',
    fi: 'Käyttökatkokartta',
    nb: 'Nedetidskart',
  },
  downtimeDataMappingDescription: {
    cz: 'Zobrazí výpadky na instalační mapě.',
    de: 'Zeigt Ausfallzeiten auf der Installationskarte.',
    en: 'Show downtime on the installation map.',
    sv: 'Visa driftstopp på installationskartan.',
    fi: 'Näytä käyttökatkot asennuskartalla.',
    nb: 'Vis nedetid på installasjonskartet.',
  },
  downtimeTimeline: {
    cz: 'Časová osa výpadků',
    de: 'Ausfallzeit-Zeitleiste',
    en: 'Downtime timeline',
    sv: 'Tidslinje för driftstopp',
    fi: 'Käyttökatkojen aikajana',
    nb: 'Tidslinje for nedetid',
  },
  downtimeTimelineDescription: {
    cz: 'Zobrazí, kdy a jak dlouho měly senzory výpadky signálu.',
    de: 'Zeigt, wann und wie lange Sensoren Signallücken hatten.',
    en: 'Show when and for how long sensors had signal gaps.',
    sv: 'Visa när och hur länge sensorerna hade signalavbrott.',
    fi: 'Näytä, milloin ja kuinka pitkään antureilla oli signaalikatkoja.',
    nb: 'Vis når og hvor lenge sensorene har hatt signalbrudd.',
  },
} as const;
